import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  CircularProgress,
  Alert,
  Chip,
  IconButton,
  useTheme,
  useMediaQuery,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
  Divider,
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  Autocomplete,
  TextField,
  Tabs,
  Tab,
  Badge,
  Switch,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { tr } from 'date-fns/locale';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CancelIcon from '@mui/icons-material/Cancel';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import QrCodeIcon from '@mui/icons-material/QrCode';
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // ✅ YENİ: Paket Sipariş
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import BlockIcon from '@mui/icons-material/Block';
import { useNavigate } from 'react-router-dom';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ownAuthSession from '../../services/auth/ownAuthSession';
import firebaseDataService from '../../services/FirebaseDataService';
import {
  restaurantActiveSaleApi,
  restaurantCompletedSaleApi,
  restaurantScreenApi,
  endOfDayReportApi,
  RestaurantActiveSaleDto,
  RestaurantCompletedSaleDto,
  CreateEndOfDayReportDto,
} from '../../services/restaurantApiService';
import accountingService from '../../services/accountingService';
import { cardManagementService } from '../../services/cardManagementService';
import salesService, { QuickSaleReceiptDto, getPackageOrdersByDateRange } from '../../services/salesService';
import { clubEntryService, ClubDepositSummaryDto } from '../../services/clubEntryService';
import SaleDetailModal from './components/SaleDetailModal';
import { printEndOfDayReceipt, EndOfDayPrintData } from './components/EndOfDayPrintService';
import { getProductSalesSummaryByInvoiceIds, getProductSalesSummaryByInvoiceNumbers, ProductSalesSummaryItem } from '../../services/productSalesSummaryApi';
import PrintIcon from '@mui/icons-material/Print';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useAuth } from '../../contexts/AuthContext';
import {
  consumePendingEndOfDayFilters,
  END_OF_DAY_FILTERS_EVENT,
  EndOfDayFilterRequest,
} from '../aichat/agent/uiBridge';
import {
  ReportType,
  TransactionStatus,
  PaymentType,
  EndOfDayFilters,
  EndOfDaySummary,
  EndOfDayRestaurantRow,
  EndOfDayQuickSaleRow,
  EndOfDayKioskRow,
  EndOfDayQRMenuRow,
  EndOfDayPackageOrderRow,
  ScreenOption,
  RESTAURANT_COLUMNS,
  QUICK_SALE_COLUMNS,
  KIOSK_COLUMNS,
  QR_MENU_COLUMNS,
  PACKAGE_ORDER_COLUMNS,
  TableColumnDef,
  PlatformOrderSummary,
  ReconciliationResult,
} from './endOfDayReportTypes';
import ReconciliationSubTables from './components/ReconciliationSubTables';
import { salesApi, getirApi, migrosApi, yemeksepetiApi, trendyolApi } from '../../config/apiClient';
import { useTranslation } from 'react-i18next';
import GetirOrderDetailModal from '../salesSystem/orderManagement/modals/GetirOrderDetailModal';
import MigrosOrderDetailModal from '../salesSystem/orderManagement/modals/MigrosOrderDetailModal';
import YemeksepetiOrderDetailModal from '../salesSystem/orderManagement/modals/YemeksepetiOrderDetailModal';
import TrendyolOrderDetailModal from '../salesSystem/orderManagement/modals/TrendyolOrderDetailModal';
// Paket (telefon) sipariş detayları için PackageOrderScreen'in kullandığı modalın
// aynısı; rapor ekranında operasyonel handler'lar geçilmediği için modal otomatik
// olarak salt okuma modunda davranır (Yazdır/İptal/Düzenle butonları gizlenir).
import OrderDetailModal from '../salesSystem/orderManagement/modals/OrderDetailModal';
import type { TrendyolOrder } from '../salesSystem/orderManagement/types';

// ✅ YENİ: Kasa ve Banka lookup için interface'ler
interface CashboxLookup {
  id: string;
  name: string;
}

interface BankAccountLookup {
  id: string;
  bankName: string;
  accountNumber: string;
  subAccounts?: { [key: string]: { id: string; accountName: string } };
}

// ==================== MOCK DATA TEMİZLENDİ ====================
// Kiosk ve QR Menü için gerçek veri kaynağı henüz yok, boş array döndürülüyor

const calculateSummary = (
  data: (EndOfDayRestaurantRow | EndOfDayQuickSaleRow | EndOfDayKioskRow | EndOfDayQRMenuRow)[]
): EndOfDaySummary => {
  return data.reduce(
    (acc, row) => {
      const qsRow = row as EndOfDayQuickSaleRow;
      if (qsRow.isRefund && qsRow.paidAmount < 0) {
        acc.posRefundAmount += Math.abs(qsRow.paidAmount);
        acc.posRefundCount += 1;
        acc.totalAmount += qsRow.paidAmount;
      } else if (row.status === 'CANCELLED') {
        acc.cancelledAmount += row.grandTotal;
        acc.cancelledCount += 1;
      } else if (row.status === 'PAID' || row.status === 'PARTIAL') {
        acc.totalAmount += row.paidAmount;
        acc.totalCount += 1;
        
        if (row.paymentType === 'CASH') {
          acc.cashAmount += row.paidAmount;
          acc.cashCount += 1;
        } else if (row.paymentType === 'POS') {
          acc.posAmount += row.paidAmount;
          acc.posCount += 1;
        } else if (row.paymentType === 'MIXED') {
          acc.mixedAmount += row.paidAmount;
          acc.mixedCount += 1;
        } else if (row.paymentType === 'OTHER' || row.paymentType === 'ONLINE') {
          acc.otherAmount += row.paidAmount;
          acc.otherCount += 1;
        } else if (row.paymentType === 'OPEN_ACCOUNT') {
          acc.openAccountAmount += row.paidAmount;
          acc.openAccountCount += 1;
        } else if (row.paymentType === 'PREPAID') {
          acc.prepaidAmount += row.paidAmount;
          acc.prepaidCount += 1;
        }
      }
      return acc;
    },
    {
      totalAmount: 0,
      totalCount: 0,
      cashAmount: 0,
      cashCount: 0,
      posAmount: 0,
      posCount: 0,
      otherAmount: 0,
      otherCount: 0,
      cancelledAmount: 0,
      cancelledCount: 0,
      mixedAmount: 0,
      mixedCount: 0,
      openAccountAmount: 0,
      openAccountCount: 0,
      posRefundAmount: 0,
      posRefundCount: 0,
      prepaidAmount: 0,
      prepaidCount: 0,
    }
  );
};

// ==================== HELPER FUNCTIONS ====================

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount) + ' ₺';
};

const formatDateTime = (dateString: string | Date, addTurkeyOffset = true): string => {
  let date = new Date(dateString);
  // UTC'den gelen tarihlere +3 saat ekle (Türkiye saati)
  if (addTurkeyOffset) {
    date = new Date(date.getTime() + (3 * 60 * 60 * 1000));
  }
  return new Intl.DateTimeFormat('tr-TR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0) {
    return `${hours}s ${mins}dk`;
  }
  return `${mins}dk`;
};

// Ürün özet API yanıtı (`getProductSalesSummaryByInvoiceIds`) backend tarafında
// `ProductName + UnitPrice` ile gruplanıyor → aynı isimdeki ürün farklı fiyattan
// satıldıysa birden çok satır olarak geliyor. UI'da unit price gösterilmediği
// için bu fragmentation gereksiz (özellikle "GETIR - Platform İndirimi" gibi
// her seferinde farklı tutarlı satırlarda kafa karıştırıcı). Frontend'de ürün
// adıyla (trim + case-sensitive) yeniden birleştiriyoruz; sıralama: en çok
// satılan üstte.
const mergeProductSummaryItems = (
  items: Array<{ ProductName: string; TotalQuantity: number; TotalAmount: number }>
): Array<{ name: string; quantity: number; totalRevenue: number }> => {
  const map = new Map<string, { name: string; quantity: number; totalRevenue: number }>();
  for (const item of items) {
    const name = (item.ProductName || '').trim();
    if (!name) continue;
    const existing = map.get(name);
    if (existing) {
      existing.quantity += item.TotalQuantity || 0;
      existing.totalRevenue += item.TotalAmount || 0;
    } else {
      map.set(name, { name, quantity: item.TotalQuantity || 0, totalRevenue: item.TotalAmount || 0 });
    }
  }
  return Array.from(map.values()).sort((a, b) => b.quantity - a.quantity);
};

const getStatusChip = (status: TransactionStatus, t: any) => {
  switch (status) {
    case 'PAID':
      return <Chip label={t('endOfDayReport.status.paid')} color="success" size="small" />;
    case 'UNPAID':
      return <Chip label={t('endOfDayReport.status.unpaid')} color="warning" size="small" />;
    case 'CANCELLED':
      return <Chip label={t('endOfDayReport.status.cancelled')} color="error" size="small" />;
    case 'PARTIAL':
      return <Chip label={t('endOfDayReport.status.partial')} color="info" size="small" />;
    default:
      return <Chip label="-" size="small" />;
  }
};

const getPaymentTypeChip = (paymentType: PaymentType, t: any) => {
  switch (paymentType) {
    case 'CASH':
      return <Chip icon={<AttachMoneyIcon />} label={t('endOfDayReport.paymentTypes.cash')} color="success" size="small" variant="outlined" />;
    case 'POS':
      return <Chip icon={<CreditCardIcon />} label="POS" color="primary" size="small" variant="outlined" />;
    case 'MIXED':
      return <Chip label={t('endOfDayReport.paymentTypes.mixed')} color="secondary" size="small" variant="outlined" />;
    case 'OPEN_ACCOUNT':
      return <Chip label={t('endOfDayReport.paymentTypes.openAccount')} color="warning" size="small" variant="outlined" />;
    case 'ONLINE':
      return <Chip label={t('endOfDayReport.paymentTypes.online')} color="info" size="small" variant="outlined" />;
    case 'OTHER':
      return <Chip label={t('endOfDayReport.paymentTypes.other')} color="default" size="small" variant="outlined" />;
    case 'PREPAID':
      return <Chip icon={<AccountBalanceWalletIcon />} label={t('endOfDayReport.paymentTypes.prepaid')} color="info" size="small" variant="outlined" />;
    case 'NONE':
      return <Typography variant="body2" color="text.secondary">-</Typography>;
    default:
      return <Typography variant="body2" color="text.secondary">-</Typography>;
  }
};

const getOrderStatusLabel = (orderStatus: string | null | undefined, t: any): string => {
  const normalized = (orderStatus || '').toString().trim().toUpperCase();

  if (!normalized) return '-';

  const statusMap: Record<string, string> = {
    DELIVERED: t('endOfDayReport.deliveryStatuses.delivered'),
    PREPARING: t('endOfDayReport.deliveryStatuses.preparing'),
    READY: t('endOfDayReport.deliveryStatuses.ready'),
    ONWAY: t('endOfDayReport.deliveryStatuses.onWay'),
    ON_THE_WAY: t('endOfDayReport.deliveryStatuses.onWay'),
    SHIPPED: t('endOfDayReport.deliveryStatuses.shipped'),
    UNDELIVERED: t('endOfDayReport.deliveryStatuses.undelivered'),
    CANCELLED: t('endOfDayReport.deliveryStatuses.cancelled'),
    REJECTED: t('endOfDayReport.deliveryStatuses.cancelled'),
    UNSUPPLIED: t('endOfDayReport.deliveryStatuses.cancelled'),
    PENDING: t('endOfDayReport.deliveryStatuses.pending'),
  };

  return statusMap[normalized] || orderStatus || '-';
};

// ==================== MAIN COMPONENT ====================

interface EndOfDayReportProps {
  isManager?: boolean; // ✅ YENİ: Manager modunda mı
  managerBranchId?: string; // ✅ YENİ: Manager'ın şube ID'si (otomatik seçilecek ve kilitlenecek)
}

const EndOfDayReport: React.FC<EndOfDayReportProps> = ({ 
  isManager = false, 
  managerBranchId 
}) => {
  const { t } = useTranslation('salesSystem');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  
  // ✅ YENİ: AuthContext'ten şube bilgileri ve companyId
  const { branches, getBranchName, userDetails } = useAuth();
  const authCompanyId = userDetails?.companyId || null;

  // State
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [companyId, setCompanyId] = useState<string | null>(null);
  
  // Filtre state'leri
  const [startDate, setStartDate] = useState<Date | null>(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  });
  const [endDate, setEndDate] = useState<Date | null>(() => {
    // ✅ Şu anki saat - gün sonu yapıldığı an
    return new Date();
  });
  // ✅ Şube filtresi - Çoklu şube seçimi destekli (boş dizi = Tüm Şubeler)
  const [selectedBranches, setSelectedBranches] = useState<string[]>(() => {
    if (isManager && managerBranchId) {
      return [managerBranchId];
    }
    return [];
  });
  const isAllBranches = selectedBranches.length === 0;
  const getSelectedBranchLabel = () => {
    if (isAllBranches) return t('endOfDayReport.filters.allBranches');
    return selectedBranches.map(id => getBranchName(id)).filter(Boolean).join(', ');
  };
  
  // ✅ YENİ: Tab sistemi - Rapor türü artık filtre değil, tab olarak kullanılıyor
  const [activeTab, setActiveTab] = useState<number>(0); // 0=Restoran, 1=Hızlı Satış, 2=Kiosk, 3=QR Menü
  
  // Veri state'leri
  const [restaurantData, setRestaurantData] = useState<EndOfDayRestaurantRow[]>([]);
  const [quickSaleData, setQuickSaleData] = useState<EndOfDayQuickSaleRow[]>([]);
  const [kioskData, setKioskData] = useState<EndOfDayKioskRow[]>([]);
  const [qrMenuData, setQRMenuData] = useState<EndOfDayQRMenuRow[]>([]);
  const [packageOrderData, setPackageOrderData] = useState<EndOfDayPackageOrderRow[]>([]); // ✅ YENİ: Paket Sipariş
  const [getirOrderData, setGetirOrderData] = useState<EndOfDayPackageOrderRow[]>([]); // ✅ YENİ: Getir Sipariş
  const [migrosOrderData, setMigrosOrderData] = useState<EndOfDayPackageOrderRow[]>([]);
  const [ysOrderData, setYsOrderData] = useState<EndOfDayPackageOrderRow[]>([]);
  const [trendyolOrderData, setTrendyolOrderData] = useState<EndOfDayPackageOrderRow[]>([]);
  // Trendyol detay modali tüm `order` objesini istediği için (orderId + self-fetch
  // değil), reconciliation aşamasında çekilen platform listesini bellekte tutuyoruz
  // ve modal açılırken `find` ile objeyi geçiriyoruz. Diğer platformlar self-fetch
  // yaptığı için listeyi tutmaya gerek yok.
  const trendyolPlatformOrdersRef = useRef<any[]>([]);

  // Yemek platformu detay modal state'leri (tab 5/6/7/8 — Getir/Migros/YS/Trendyol)
  const [getirDetailModalOpen, setGetirDetailModalOpen] = useState(false);
  const [selectedGetirOrderId, setSelectedGetirOrderId] = useState<number | null>(null);
  const [migrosDetailModalOpen, setMigrosDetailModalOpen] = useState(false);
  const [selectedMigrosOrderId, setSelectedMigrosOrderId] = useState<number | null>(null);
  const [ysDetailModalOpen, setYsDetailModalOpen] = useState(false);
  const [selectedYsOrderId, setSelectedYsOrderId] = useState<number | null>(null);
  const [trendyolDetailModalOpen, setTrendyolDetailModalOpen] = useState(false);
  const [selectedTrendyolOrder, setSelectedTrendyolOrder] = useState<TrendyolOrder | null>(null);
  // Paket (telefon) sipariş detay modali — tab 1
  const [packageDetailModalOpen, setPackageDetailModalOpen] = useState(false);
  const [selectedPackageOrderId, setSelectedPackageOrderId] = useState<number | null>(null);

  const [summary, setSummary] = useState<EndOfDaySummary | null>(null);
  const [filterFiscalOnly, setFilterFiscalOnly] = useState(false);
  // Kulüp giriş depozito özeti — satış cirosuna DAHİL DEĞİLDİR, ayrı bölümde gösterilir.
  const [clubDepositSummary, setClubDepositSummary] = useState<ClubDepositSummaryDto | null>(null);
  
  // Sağlama (Reconciliation) state'leri
  const emptyReconciliation: ReconciliationResult = { paid: [], unpaid: [], cancelled: [], warnings: [], paidTotal: 0, unpaidTotal: 0, cancelledTotal: 0, warningTotal: 0 };
  const [reconciliationData, setReconciliationData] = useState<Record<string, ReconciliationResult>>({
    quickSale: emptyReconciliation,
    package: emptyReconciliation,
    restaurant: emptyReconciliation,
    kiosk: emptyReconciliation,
    qrMenu: emptyReconciliation,
    getir: emptyReconciliation,
    migros: emptyReconciliation,
    yemeksepeti: emptyReconciliation,
    trendyol: emptyReconciliation,
  });
  
  // ✅ YENİ: Açık masalar (sadece restoran için)
  const [activeTables, setActiveTables] = useState<RestaurantActiveSaleDto[]>([]);
  const [showActiveTables, setShowActiveTables] = useState(true);
  // ✅ YENİ: Oturumu açık + bakiyesi olan kartlar (sadece Hızlı Satış tab'i için, bilgi amaçlı).
  //   Gün sonuna DAHİL DEĞİLDİR; restoran tab'indaki "Açık Masalar" tablosunun karşılığı.
  const [openCardSessions, setOpenCardSessions] = useState<any[]>([]);
  const [showOpenCardSessions, setShowOpenCardSessions] = useState(true);
  const [loadingOpenCardSessions, setLoadingOpenCardSessions] = useState(false);
  const [showProductSummary, setShowProductSummary] = useState(true);
  // ✅ YENI: Hizli Satis tab'i icin urun bazinda satis ozeti.
  //   `getProductSalesSummaryByInvoiceIds` API'si toplu aggregated donduguyle
  //   `orderCount` (urunun kac satista gectigi) bilgisi yok — UI'da "—" gosterilir.
  const [showQuickSaleProductSummary, setShowQuickSaleProductSummary] = useState(true);
  const [quickSaleProductSummary, setQuickSaleProductSummary] = useState<Array<{ name: string; quantity: number; totalRevenue: number }>>([]);
  const [loadingQuickSaleProducts, setLoadingQuickSaleProducts] = useState(false);
  // Paket sipariş tab'ı için ürün bazında satış özeti — Hızlı Satış ile aynı API
  // (`getProductSalesSummaryByInvoiceIds`) kullanır çünkü her ikisi de
  // QuickSaleReceipts kaynaklı (PKT- prefix). orderCount bilgisi yok (aggregated).
  const [showPackageProductSummary, setShowPackageProductSummary] = useState(true);
  const [packageProductSummary, setPackageProductSummary] = useState<Array<{ name: string; quantity: number; totalRevenue: number }>>([]);
  const [loadingPackageProducts, setLoadingPackageProducts] = useState(false);
  // Getir tab'ı için ürün bazında satış özeti — QuickSaleReceipts (GTR- prefix)
  // kaynaklı olduğu için Hızlı Satış / Paket ile aynı API kullanılır.
  const [showGetirProductSummary, setShowGetirProductSummary] = useState(true);
  const [getirProductSummary, setGetirProductSummary] = useState<Array<{ name: string; quantity: number; totalRevenue: number }>>([]);
  const [loadingGetirProducts, setLoadingGetirProducts] = useState(false);
  // Migros tab'ı için ürün bazında satış özeti — QuickSaleReceipts (MGR- prefix)
  // kaynaklı olduğu için Getir / Hızlı Satış / Paket ile aynı API kullanılır.
  const [showMigrosProductSummary, setShowMigrosProductSummary] = useState(true);
  const [migrosProductSummary, setMigrosProductSummary] = useState<Array<{ name: string; quantity: number; totalRevenue: number }>>([]);
  const [loadingMigrosProducts, setLoadingMigrosProducts] = useState(false);
  // Yemeksepeti tab'ı için ürün bazında satış özeti — QuickSaleReceipts (YS- prefix).
  const [showYsProductSummary, setShowYsProductSummary] = useState(true);
  const [ysProductSummary, setYsProductSummary] = useState<Array<{ name: string; quantity: number; totalRevenue: number }>>([]);
  const [loadingYsProducts, setLoadingYsProducts] = useState(false);
  // Trendyol tab'ı için ürün bazında satış özeti — QuickSaleReceipts (TYL- prefix).
  const [showTrendyolProductSummary, setShowTrendyolProductSummary] = useState(true);
  const [trendyolProductSummary, setTrendyolProductSummary] = useState<Array<{ name: string; quantity: number; totalRevenue: number }>>([]);
  const [loadingTrendyolProducts, setLoadingTrendyolProducts] = useState(false);
  
  // ✅ YENİ: Tamamlanmış satışlar (detay modalı için)
  const [completedSales, setCompletedSales] = useState<RestaurantCompletedSaleDto[]>([]);
  
  // ✅ YENİ: Ekran listesi (API'den gelecek)
  const [screenOptions, setScreenOptions] = useState<ScreenOption[]>([]);
  const [loadingScreens, setLoadingScreens] = useState(false);

  // ✅ YENİ: Hızlı Satış + PYK ekranları (QuickSaleScreen + PykScreen tablolarından) ve seçili ekran filtresi.
  //   QuickSaleReceipts.ScreenId ile eşleşerek Hızlı Satış tab'ını ekran bazında filtreler.
  //   DİKKAT: PYK fişlerinde (PYK- önekli) ScreenId = PykScreen.Id, diğer fişlerde
  //   ScreenId = QuickSaleScreen.Id olduğundan iki ID uzayı çakışabilir; bu yüzden
  //   seçimler "qs-{id}" / "pyk-{id}" önekli anahtarlarla tutulur.
  const [quickSaleScreens, setQuickSaleScreens] = useState<Array<{ key: string; id: number; name: string; branchId: string | null; screenKind: 'QUICKSALE' | 'PYK' }>>([]);
  const [selectedScreenKeys, setSelectedScreenKeys] = useState<string[]>([]);
  
  // ✅ YENİ: Gün sonu onay modalı
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [endOfDayProcessing, setEndOfDayProcessing] = useState(false);
  
  // ✅ YENİ: Gün sonu ön onay modalı (tarih aralığı, şube, toplam gösterilecek)
  const [preConfirmDialogOpen, setPreConfirmDialogOpen] = useState(false);
  
  // ✅ YENİ: Gün sonu başarı modalı
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [successDialogData, setSuccessDialogData] = useState<{ 
    reportId: number; 
    balance: number; 
    branchName: string | null;
    startDate: string;
    endDate: string;
  } | null>(null);
  
  // ✅ YENİ: Son gün sonu raporu bilgisi
  const [lastEndOfDayReport, setLastEndOfDayReport] = useState<{
    id: number;
    endDate: Date;
    screenType: string;
  } | null>(null);
  
  // ✅ YENİ: Tarih çakışması modalı
  const [dateConflictDialogOpen, setDateConflictDialogOpen] = useState(false);
  const [conflictingReports, setConflictingReports] = useState<Array<{
    id: number;
    startDate: string;
    endDate: string;
    screenType: string;
  }>>([]);
  
  // Sayfalama
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  
  // Excel indirme
  const [loadingExport, setLoadingExport] = useState(false);
  
  // ✅ YENİ: Yazdırma
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [productSalesSummary, setProductSalesSummary] = useState<ProductSalesSummaryItem[]>([]);
  
  // ✅ YENİ: Satış detay modalı
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedSaleDetail, setSelectedSaleDetail] = useState<RestaurantCompletedSaleDto | null>(null);
  const [selectedQuickSaleDetail, setSelectedQuickSaleDetail] = useState<QuickSaleReceiptDto | null>(null); // ✅ YENİ: Hızlı satış detayı

  const loadInitialDataRef = useRef(false);
  
  const loadInitialData = useCallback(async () => {
    if (!authCompanyId) return;
    if (loadInitialDataRef.current) return;
    loadInitialDataRef.current = true;
    
    const t0 = performance.now();
    try {
      setLoadingScreens(true);
      
      const compId = authCompanyId;
      setCompanyId(compId);

      const [screensResult, cashboxResult, bankResult, latestReportResult, quickSaleScreensResult, pykScreensResult] = await Promise.allSettled([
        restaurantScreenApi.getByCompanyId(),
        accountingService.getCashboxes(),
        accountingService.getBankAccounts(),
        endOfDayReportApi.getLatest(),
        salesService.getQuickSaleScreens(),
        salesService.getPykScreens(),
      ]);

      const t1 = performance.now();
      console.log(`⏱️ [GÜN SONU] API çağrıları tamamlandı: ${Math.round(t1 - t0)}ms`);

      if (screensResult.status === 'fulfilled') {
        const restaurantScreens: ScreenOption[] = screensResult.value.map(s => ({
          id: s.Id,
          name: s.Name,
          type: 'RESTAURANT' as const,
          branchId: s.BranchId || null,
        }));
        setScreenOptions(restaurantScreens);
        console.log('Ekranlar yüklendi:', restaurantScreens.length);
      } else {
        console.error('Ekranlar yüklenemedi:', screensResult.reason);
      }

      if (cashboxResult.status === 'fulfilled') {
        const cashboxLookup: CashboxLookup[] = cashboxResult.value.map((c: any) => ({
          id: (c.Id || c.id)?.toString() || '',
          name: c.Name || c.name || 'İsimsiz Kasa',
        }));
        setCashboxList(cashboxLookup);
        console.log('Kasalar yüklendi:', cashboxLookup.length);
      } else {
        console.error('Kasalar yüklenemedi:', cashboxResult.reason);
      }

      if (bankResult.status === 'fulfilled') {
        const bankLookup: BankAccountLookup[] = bankResult.value.map((b: any) => {
          const subAccountsObj: { [key: string]: { id: string; accountName: string } } = {};
          const subAccountsArray = b.subAccounts || b.SubAccounts;
          if (subAccountsArray && Array.isArray(subAccountsArray)) {
            subAccountsArray.forEach((sub: any) => {
              const subId = (sub.id || sub.Id)?.toString();
              if (subId) {
                subAccountsObj[subId] = {
                  id: subId,
                  accountName: sub.accountName || sub.AccountName || 'İsimsiz Alt Hesap',
                };
              }
            });
          }
          return {
            id: (b.Id || b.id)?.toString() || '',
            bankName: b.BankName || b.bankName || 'İsimsiz Banka',
            accountNumber: b.AccountNumber || b.accountNumber || '',
            subAccounts: Object.keys(subAccountsObj).length > 0 ? subAccountsObj : undefined,
          };
        });
        setBankAccountList(bankLookup);
        console.log('Banka hesapları yüklendi:', bankLookup.length);
      } else {
        console.error('Banka hesapları yüklenemedi:', bankResult.reason);
      }

      if (latestReportResult.status === 'fulfilled') {
        const latestReport = latestReportResult.value?.Data;
        if (latestReport) {
          const rawEnd = latestReport.EndDate as string;
          const endDateUtc = new Date(rawEnd.endsWith('Z') ? rawEnd : rawEnd + 'Z');
          setLastEndOfDayReport({
            id: latestReport.Id,
            endDate: endDateUtc,
            screenType: latestReport.ScreenType,
          });
          console.log(`✅ Son gün sonu raporu (ID: ${latestReport.Id}) yüklendi - sadece 1 kayıt (server-side latest)`);
        }
      } else {
        console.warn('Son gün sonu raporu yüklenemedi:', latestReportResult.reason);
      }

      // Hızlı Satış + PYK ekranlarını tek listede birleştir (ekran filtresi dropdown'ı).
      // PYK fişleri (PYK- önekli, PaymentType=PREPAID) ScreenId olarak PykScreen.Id taşır;
      // ID çakışmasını önlemek için her seçenek "qs-{id}" / "pyk-{id}" anahtarı alır.
      const combinedScreens: Array<{ key: string; id: number; name: string; branchId: string | null; screenKind: 'QUICKSALE' | 'PYK' }> = [];

      if (quickSaleScreensResult.status === 'fulfilled') {
        quickSaleScreensResult.value
          .filter(s => s.IsActive !== false && (!s.ScreenType || s.ScreenType === 'Standalone'))
          .forEach(s => combinedScreens.push({ key: `qs-${s.Id}`, id: s.Id, name: s.Name, branchId: s.BranchId || null, screenKind: 'QUICKSALE' }));
      } else {
        console.warn('Hızlı satış ekranları yüklenemedi:', quickSaleScreensResult.reason);
      }

      if (pykScreensResult.status === 'fulfilled') {
        pykScreensResult.value
          .filter(s => s.IsActive !== false)
          .forEach(s => combinedScreens.push({ key: `pyk-${s.Id}`, id: s.Id, name: `${s.Name} (PYK)`, branchId: s.BranchId || null, screenKind: 'PYK' }));
      } else {
        console.warn('PYK ekranları yüklenemedi:', pykScreensResult.reason);
      }

      combinedScreens.sort((a, b) => a.name.localeCompare(b.name));
      setQuickSaleScreens(combinedScreens);
      console.log('Hızlı satış + PYK ekranları yüklendi:', combinedScreens.length);
      
    } catch (err: any) {
      console.error('İlk veri yükleme hatası:', err);
      setError(t('endOfDayReport.errors.dataLoadFailed', { message: err.message }));
    } finally {
      setLoadingScreens(false);
    }
  }, [authCompanyId]);

  useEffect(() => {
    loadInitialData();
  }, [loadInitialData]);

  // ─── AI ajan köprüsü (openEndOfDayReport) ─────────────────────────────────
  // Ajan tarih/şube filtrelerini doldurur; state güncellemeleri render'a
  // yansıdıktan sonra ayrı bir effect handleFilter'ı tetikler (stale state
  // olmadan). "Gün Sonu Al" işlemi ajana verilmez.
  const [agentFilterQueued, setAgentFilterQueued] = useState(false);

  useEffect(() => {
    const applyAgentRequest = (req: EndOfDayFilterRequest) => {
      if (req.startDate) {
        const d = new Date(req.startDate);
        if (!isNaN(d.getTime())) setStartDate(d);
      }
      if (req.endDate) {
        const d = new Date(req.endDate);
        if (!isNaN(d.getTime())) setEndDate(d);
      }
      if (Array.isArray(req.branchIds)) {
        // Manager kendi şubesine kilitli — ajan isteği bunu aşamaz
        setSelectedBranches(isManager && managerBranchId ? [managerBranchId] : req.branchIds);
      }
      if (req.autoFilter !== false) setAgentFilterQueued(true);
    };

    const pending = consumePendingEndOfDayFilters();
    if (pending) applyAgentRequest(pending);

    const onAgentEvent = (e: Event) => {
      consumePendingEndOfDayFilters();
      applyAgentRequest((e as CustomEvent).detail as EndOfDayFilterRequest);
    };
    window.addEventListener(END_OF_DAY_FILTERS_EVENT, onAgentEvent);
    return () => window.removeEventListener(END_OF_DAY_FILTERS_EVENT, onAgentEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isManager, managerBranchId]);

  useEffect(() => {
    if (!agentFilterQueued || !companyId || loading) return;
    setAgentFilterQueued(false);
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentFilterQueued, companyId, loading]);

  // ✅ YENİ: TÜM SATIŞ KANALLARI İÇİN TEK FİLTRELEME
  const handleFilter = async () => {
    if (!startDate || !endDate) {
      setError(t('endOfDayReport.errors.selectStartEndDate'));
      return;
    }

    if (!companyId) {
      setError(t('endOfDayReport.errors.companyInfoMissing'));
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Tüm state'leri temizle
      setRestaurantData([]);
      setQuickSaleData([]);
      setKioskData([]);
      setQRMenuData([]);
      setPackageOrderData([]);
      setActiveTables([]);
      setCompletedSales([]);
      setSummaryTableRows([]);
      setClubDepositSummary(null);
      setReconciliationData({
        quickSale: emptyReconciliation, package: emptyReconciliation,
        restaurant: emptyReconciliation, kiosk: emptyReconciliation,
        qrMenu: emptyReconciliation, getir: emptyReconciliation,
        migros: emptyReconciliation, yemeksepeti: emptyReconciliation,
        trendyol: emptyReconciliation,
      });
      
      console.log('[GÜN SONU] 🔄 Tüm satış kanalları filtreleniyor...', { 
        companyId, 
        startDate: startDate.toISOString(), 
        endDate: endDate.toISOString(), 
        selectedBranches,
        isAllBranches,
        screenOptions: screenOptions.map(s => ({ id: s.id, name: s.name, type: s.type, branchId: s.branchId })),
      });
      
      // ✅ Şube seçimine göre restoran ekranlarını belirle
      let restaurantScreensToFetch: ScreenOption[] = [];
      if (!isAllBranches) {
        restaurantScreensToFetch = screenOptions.filter(s => s.type === 'RESTAURANT' && s.branchId && selectedBranches.includes(s.branchId));
      } else {
        restaurantScreensToFetch = screenOptions.filter(s => s.type === 'RESTAURANT');
      }
      console.log('[GÜN SONU-RESTORAN] 📋 Restoran ekranları:', restaurantScreensToFetch.map(s => ({ id: s.id, name: s.name, branchId: s.branchId })));
      
      // ✅ PARALEL API ÇAĞRILARI - Tüm kanallar aynı anda
      const [restaurantResult, quickSaleResult, kioskResult, qrMenuResult, packageOrderResult] = await Promise.allSettled([
        // 1. RESTORAN
        (async () => {
          console.log('[GÜN SONU-RESTORAN] 📡 API çağrısı başlıyor...', { isAllBranches, screenCount: restaurantScreensToFetch.length, selectedBranches });
          if (!isAllBranches) {
            if (restaurantScreensToFetch.length > 0) {
              console.log('[GÜN SONU-RESTORAN] 📡 Ekran bazlı çağrı: getByRestaurantScreenId x', restaurantScreensToFetch.length);
              const results = await Promise.allSettled(
                restaurantScreensToFetch.map(screen =>
                  restaurantCompletedSaleApi.getByRestaurantScreenId(
                    screen.id,
                    startDate.toISOString(),
                    endDate.toISOString()
                  )
                )
              );
              const flatData = results.flatMap(r => r.status === 'fulfilled' ? r.value : []);
              console.log('[GÜN SONU-RESTORAN] 📥 Ekran bazlı sonuç:', flatData.length, 'satış', results.map((r, i) => ({
                screen: restaurantScreensToFetch[i]?.name,
                status: r.status,
                count: r.status === 'fulfilled' ? r.value.length : 0,
                error: r.status === 'rejected' ? r.reason?.message : undefined,
              })));
              return flatData;
            }
            console.log('[GÜN SONU-RESTORAN] 📡 Şube bazlı çağrı: getByCompanyId x', selectedBranches.length);
            const branchResults = await Promise.allSettled(
              selectedBranches.map(branchId =>
                restaurantCompletedSaleApi.getByCompanyId(
                  startDate.toISOString(),
                  endDate.toISOString(),
                  branchId
                )
              )
            );
            const flatBranchData = branchResults.flatMap(r => r.status === 'fulfilled' ? r.value : []);
            console.log('[GÜN SONU-RESTORAN] 📥 Şube bazlı sonuç:', flatBranchData.length, 'satış');
            return flatBranchData;
          }
          console.log('[GÜN SONU-RESTORAN] 📡 Tüm şirket çağrısı: getByCompanyId (tümü)', { start: startDate.toISOString(), end: endDate.toISOString() });
          const allData = await restaurantCompletedSaleApi.getByCompanyId(
            startDate.toISOString(),
            endDate.toISOString()
          );
          console.log('[GÜN SONU-RESTORAN] 📥 Tüm şirket sonucu:', allData.length, 'satış');
          if (allData.length > 0) {
            console.log('[GÜN SONU-RESTORAN] 📥 İlk 3 kayıt:', allData.slice(0, 3).map(s => ({
              Id: s.Id,
              SaleNumber: s.SaleNumber,
              PaymentMethod: s.PaymentMethod,
              TotalAmount: s.TotalAmount,
              CompletedAt: s.CompletedAt,
              BranchId: s.BranchId,
              RestaurantScreenId: s.RestaurantScreenId,
            })));
          }
          return allData;
        })(),
        // 2. HIZLI SATIŞ - ✅ GERÇEK VERİ (QuickSaleReceipts tablosundan)
        (async () => {
          if (!isAllBranches) {
            const qsResults = await Promise.allSettled(
              selectedBranches.map(branchId =>
                salesService.getQuickSaleReceiptsByDateRange(
                  startDate.toISOString(),
                  endDate.toISOString(),
                  branchId
                )
              )
            );
            return qsResults.flatMap(r => r.status === 'fulfilled' ? r.value : []);
          }
          return salesService.getQuickSaleReceiptsByDateRange(
            startDate.toISOString(),
            endDate.toISOString(),
            null
          );
        })(),
        // 3. KIOSK (henüz gerçek veri kaynağı yok)
        Promise.resolve([] as EndOfDayKioskRow[]),
        // 4. QR MENÜ (henüz gerçek veri kaynağı yok)
        Promise.resolve([] as EndOfDayQRMenuRow[]),
        // 5. PAKET SİPARİŞ
        // Ödenmiş paket siparişleri zaten QuickSaleReceipts'ten geliyor (PKT- prefix).
        // Ancak ödeme alınmadan iptal edilen telefon siparişleri (PR1 cancel akışı)
        // QuickSaleReceipts'e hiç yazılmaz — bu yüzden PackageOrders tablosundan
        // ayrıca çekiyoruz ve cancelled olanları packageOrderRows'a merge ediyoruz.
        // (`OrderStatus='CANCELLED'` zaten DTO'da gelir; ek filtreyi aşağıda yapıyoruz.)
        (async () => {
          if (!isAllBranches) {
            const poResults = await Promise.allSettled(
              selectedBranches.map(branchId =>
                getPackageOrdersByDateRange(startDate, endDate, branchId)
              )
            );
            const flat: any[] = [];
            poResults.forEach(r => {
              if (r.status === 'fulfilled' && r.value?.Success && Array.isArray(r.value?.Data)) {
                flat.push(...r.value.Data);
              }
            });
            return { Success: true, Data: flat, Count: flat.length } as { Success: boolean; Data: any[]; Count: number };
          }
          const allRes = await getPackageOrdersByDateRange(startDate, endDate);
          return {
            Success: !!allRes?.Success,
            Data: Array.isArray(allRes?.Data) ? allRes.Data : [],
            Count: allRes?.Count ?? 0,
          } as { Success: boolean; Data: any[]; Count: number };
        })(),
      ]);
      
      // ✅ RESTORAN VERİLERİNİ İŞLE
      let restaurantSales: RestaurantCompletedSaleDto[] = [];
      if (restaurantResult.status === 'fulfilled') {
        restaurantSales = restaurantResult.value;
        console.log('[GÜN SONU-RESTORAN] 📊 API\'den gelen ham veri:', restaurantSales.length, 'satış');
        
        if (restaurantSales.length > 0) {
          const paymentMethodBreakdown = restaurantSales.reduce((acc, s) => {
            const method = s.PaymentMethod || 'UNKNOWN';
            acc[method] = (acc[method] || 0) + 1;
            return acc;
          }, {} as Record<string, number>);
          console.log('[GÜN SONU-RESTORAN] 📊 Ödeme yöntemi dağılımı:', paymentMethodBreakdown);
          console.log('[GÜN SONU-RESTORAN] 📊 Tüm satışlar (özet):', restaurantSales.map(s => ({
            Id: s.Id, SaleNumber: s.SaleNumber, PaymentMethod: s.PaymentMethod,
            TotalAmount: s.TotalAmount, CompletedAt: s.CompletedAt, BranchId: s.BranchId,
          })));
        }
        
        // ✅ GÜVENLİK FİLTRESİ: Şube seçiliyse, sadece o şubelerin satışlarını göster
        if (!isAllBranches) {
          const beforeFilterCount = restaurantSales.length;
          const branchScreenIds = new Set(restaurantScreensToFetch.map(s => s.id));
          restaurantSales = restaurantSales.filter(sale => 
            (sale.BranchId && selectedBranches.includes(sale.BranchId)) || branchScreenIds.has(sale.RestaurantScreenId)
          );
          console.log('[GÜN SONU-RESTORAN] 🔍 Şube filtresi: %d → %d satış (filtrelenen: %d)', beforeFilterCount, restaurantSales.length, beforeFilterCount - restaurantSales.length);
        }
        console.log('[GÜN SONU-RESTORAN] ✅ İşlenecek restoran satışları:', restaurantSales.length, !isAllBranches ? `(Şubeler: ${selectedBranches.join(', ')})` : '(Tümü)');
        
        // Verileri EndOfDayRestaurantRow formatına dönüştür
        const transformedData: EndOfDayRestaurantRow[] = restaurantSales.map((sale, index) => {
          const paymentMethodLower = sale.PaymentMethod?.toLowerCase() || '';
          let status: TransactionStatus = 'PAID';
          let paymentType: PaymentType = 'CASH';
          
          if (paymentMethodLower === 'unpaid' || paymentMethodLower === 'cancelled' || paymentMethodLower === 'iptal') {
            status = 'CANCELLED';
            paymentType = 'NONE';
          } else if (paymentMethodLower.includes('parçalı') || paymentMethodLower.includes('karma') || paymentMethodLower === 'partial' || paymentMethodLower.includes('mixed')) {
            status = 'PAID';
            paymentType = 'MIXED';
          } else if (paymentMethodLower === 'pos' || paymentMethodLower === 'kredi kartı' || paymentMethodLower === 'credit_card') {
            paymentType = 'POS';
          } else if (paymentMethodLower === 'nakit' || paymentMethodLower === 'cash') {
            paymentType = 'CASH';
          } else if (paymentMethodLower === 'açık hesap' || paymentMethodLower === 'open_account') {
            paymentType = 'OPEN_ACCOUNT';
          }
          
          const saleScreen = screenOptions.find(s => s.id === sale.RestaurantScreenId);
          const screenBranchName = saleScreen?.branchId ? getBranchName(saleScreen.branchId) : '-';
          
          return {
            id: String(sale.Id),
            rowNumber: index + 1,
            tableName: sale.TableName || `Masa ${sale.TableId}`,
            orderNumber: sale.SaleNumber || '',
            status,
            subtotal: sale.SubTotal || 0,
            grandTotal: sale.TotalAmount || 0,
            paidAmount: status === 'CANCELLED' ? 0 : sale.TotalAmount || 0,
            paymentType,
            cancelledTotal: status === 'CANCELLED' ? sale.TotalAmount || 0 : 0,
            openedAt: sale.OpenedAt,
            closedAt: sale.CompletedAt,
            seatingDuration: sale.DurationMinutes || 0,
            notes: sale.Notes || '',
            receiptNumber: sale.ReservedShortCode || '',
            customerName: sale.InvoiceNumber ? 'Genel Cari' : '',
            waiterName: sale.ClosedByWaiterName || sale.CompletedByName || '',
            invoiceNumber: sale.InvoiceNumber || '',
            branchName: screenBranchName,
            screenName: saleScreen?.name || '-',
            invoiceId: (sale as any).InvoiceId || undefined,
            isFiscalReceipt: sale.IsFiscalReceipt ?? true,
          };
        });
        
        // En yeni kayıt en üstte
        const sortedData = transformedData.sort((a, b) => {
          const dateA = new Date(a.openedAt).getTime();
          const dateB = new Date(b.openedAt).getTime();
          return dateB - dateA;
        });
        sortedData.forEach((row, index) => { row.rowNumber = index + 1; });
        
        setRestaurantData(sortedData);
        setCompletedSales(restaurantSales);
        
        console.log('[GÜN SONU-RESTORAN] ✅ Dönüştürme tamamlandı:', sortedData.length, 'satır');
        if (sortedData.length > 0) {
          const statusBreakdown = sortedData.reduce((acc, r) => {
            acc[`${r.status}-${r.paymentType}`] = (acc[`${r.status}-${r.paymentType}`] || 0) + 1;
            return acc;
          }, {} as Record<string, number>);
          console.log('[GÜN SONU-RESTORAN] 📊 Durum/Ödeme dağılımı:', statusBreakdown);
          const totalPaid = sortedData.filter(r => r.status === 'PAID').reduce((sum, r) => sum + r.grandTotal, 0);
          const totalCancelled = sortedData.filter(r => r.status === 'CANCELLED').reduce((sum, r) => sum + r.cancelledTotal, 0);
          console.log('[GÜN SONU-RESTORAN] 💰 Toplam ödenen:', totalPaid.toFixed(2), '/ İptal:', totalCancelled.toFixed(2));
        }
      } else {
        console.error('[GÜN SONU-RESTORAN] ❌ API çağrısı başarısız:', (restaurantResult as PromiseRejectedResult).reason);
      }
      
      // ✅ HIZLI SATIŞ VERİLERİNİ İŞLE (QuickSaleReceipts tablosundan)
      let processedQuickSales: EndOfDayQuickSaleRow[] = [];
      let processedPackageOrders: EndOfDayPackageOrderRow[] = [];
      let processedGetirOrders: EndOfDayPackageOrderRow[] = [];
      let processedMigrosOrders: EndOfDayPackageOrderRow[] = [];
      let processedYsOrders: EndOfDayPackageOrderRow[] = [];
      let processedTrendyolOrders: EndOfDayPackageOrderRow[] = [];
      let processedKioskData: EndOfDayKioskRow[] = [];
      if (quickSaleResult.status === 'fulfilled') {
        const receipts = quickSaleResult.value as QuickSaleReceiptDto[];
        console.log('✅ Hızlı satış fişleri:', receipts.length);
        
        // QuickSaleReceiptDto -> EndOfDayQuickSaleRow dönüşümü
        const transformedQuickSales: EndOfDayQuickSaleRow[] = receipts.map((receipt, index) => {
          // Ödeme türünü belirle
          let paymentType: PaymentType = 'CASH';
          const paymentTypeLower = (receipt.PaymentType || '').toLowerCase();
          
          const hasOtherPaymentMethod = (receipt.Payments || []).some(
            (p: any) => p.PaymentMethod?.toLowerCase() === 'other'
          );
          
          if (receipt.PaymentType === 'PREPAID' || paymentTypeLower === 'prepaid') {
            // PYK ön ödemeli (kart) fiş — nakit/POS değil "Ön Ödemeli" kategorisi
            paymentType = 'PREPAID';
          } else if (hasOtherPaymentMethod) {
            paymentType = 'OTHER';
          } else if (receipt.PaymentType === 'OPEN_ACCOUNT' || paymentTypeLower === 'open_account') {
            paymentType = 'OPEN_ACCOUNT';
          } else if (paymentTypeLower === 'online_online') {
            paymentType = 'ONLINE';
          } else if (receipt.PaymentType === 'POS' || paymentTypeLower === 'online_pos' || paymentTypeLower.includes('_pos')) {
            paymentType = 'POS';
          } else if (receipt.PaymentType === 'PARTIAL') {
            paymentType = 'MIXED';
          } else if (paymentTypeLower === 'online_cash' || paymentTypeLower.startsWith('online_')) {
            paymentType = 'CASH';
          }
          
          // Durum belirle
          let status: TransactionStatus = 'PAID';
          let isRefund = false;
          if (receipt.PaymentStatus === 'UNPAID') {
            status = 'UNPAID';
          } else if (receipt.PaymentStatus === 'CANCELLED') {
            status = 'CANCELLED';
            paymentType = 'NONE';
          } else if (receipt.PaymentStatus === 'REFUNDED') {
            status = 'CANCELLED';
            isRefund = true;
          }
          
          // Şube adını bul
          const branchName = receipt.BranchId ? getBranchName(receipt.BranchId) : '-';
          
          // ✅ Kasa/Banka adını Payments dizisinden al (alt hesap dahil)
          let paymentAccountName = '-';
          const payments = receipt.Payments || [];
          
          // Banka adını alt hesap ile birlikte oluştur
          const getFullBankName = (p: any): string => {
            if (p.BankAccountName) {
              // Alt hesap varsa "Banka - Alt Hesap" formatında döndür
              if (p.BankSubAccountName) {
                return `${p.BankAccountName} - ${p.BankSubAccountName}`;
              }
              return p.BankAccountName;
            }
            return '';
          };
          
          if (payments.length > 0) {
            if (payments.length === 1) {
              // Tek ödeme - direkt kasa veya banka adı
              const p = payments[0];
              paymentAccountName = p.CashboxName || getFullBankName(p) || '-';
            } else {
              // Birden fazla ödeme (karma) - hepsini birleştir
              const names: string[] = [];
              payments.forEach(p => {
                if (p.CashboxName) names.push(p.CashboxName);
                const bankName = getFullBankName(p);
                if (bankName) names.push(bankName);
              });
              paymentAccountName = names.length > 0 ? names.join(' + ') : '-';
            }
          }
          
          // ✅ YENİ: Platform bilgisini Payments dizisinden al (Yemek Sepeti, Getir vb.)
          let paymentProviderName: string | undefined = undefined;
          if (payments.length > 0) {
            // İlk ödemenin PaymentProviderName'ini kullan
            const firstProviderName = payments.find(p => p.PaymentProviderName)?.PaymentProviderName;
            if (firstProviderName) {
              paymentProviderName = firstProviderName;
            }
          }
          
          return {
            id: receipt.Id.toString(),
            rowNumber: index + 1,
            referenceNumber: receipt.ReceiptNumber || receipt.ReferenceNumber || '',
            status,
            subtotal: receipt.SubTotal,
            grandTotal: receipt.TotalAmount,
            // ✅ YENİ: Sepete uygulanan indirim (bilgi amaçlı; genel toplamı etkilemez)
            discount: receipt.DiscountAmount || 0,
            paidAmount: status === 'CANCELLED' ? 0 : receipt.TotalPaid,
            paymentType,
            paymentAccountName, // Kasa/Banka adı (alt hesap dahil)
            cancelledTotal: status === 'CANCELLED' ? receipt.TotalAmount : 0,
            transactionDate: receipt.CreatedAt,
            openedAt: receipt.OpenedAt || receipt.CreatedAt,
            notes: receipt.Notes || '',
            receiptNumber: receipt.ShortCode || '',
            customerName: receipt.AccountName || 'Genel Cari',
            invoiceNumber: receipt.InvoiceNumber || '',
            branchName: branchName,
            createdByName: receipt.CashierName || receipt.CreatedByName || '', // Kasiyer varsa kasiyer adını kullan
            cashierName: receipt.CashierName || undefined, // Kasiyer adını ayrıca kaydet
            paymentProviderName, // ✅ YENİ: Platform (Yemek Sepeti, Getir vb.)
            // Özet hesaplaması için ödeme detayları (alt hesap dahil)
            payments: payments.map(p => ({
              paymentMethod: p.PaymentMethod,
              amount: p.Amount,
              cashboxName: p.CashboxName,
              bankAccountName: p.BankAccountName,
              bankSubAccountName: p.BankSubAccountName, // Alt hesap adı
              paymentProviderName: p.PaymentProviderName || undefined, // ✅ YENİ: Platform adı
              paymentProviderType: p.PaymentProviderType || undefined, // ✅ YENİ: Detaylı ödeme türü (ONLINE_YEMEK SEPETİ_NAKİT vb.)
            })),
            invoiceId: receipt.InvoiceId || undefined,
            isFiscalReceipt: (receipt as any).IsFiscalReceipt ?? true,
            isRefund,
            branchId: receipt.BranchId != null && String(receipt.BranchId).trim() !== ''
              ? String(receipt.BranchId).trim()
              : undefined,
            screenId: receipt.ScreenId ?? null,
          };
        });

        // Şube seçiliyken BranchId olmayan fişleri ele — böylece Trendyol vb. şubesiz kayıtlar gün sonunda listelenmez/yazdırılmaz
        let scopedQuickSaleRows = transformedQuickSales;
        if (!isAllBranches) {
          scopedQuickSaleRows = transformedQuickSales.filter(row => {
            const bid = row.branchId ? String(row.branchId).trim() : '';
            return bid !== '' && selectedBranches.includes(bid);
          });
        }
        
        // ✅ Prefix'e göre ayır: Kiosk (D-/P-), Paket Sipariş (PKT-), Getir (GTR-) vs Hızlı Satış
        const isKioskReceipt = (row: EndOfDayQuickSaleRow) => 
          row.referenceNumber?.startsWith('D-') || row.referenceNumber?.startsWith('P-') ||
          row.receiptNumber?.startsWith('D-') || row.receiptNumber?.startsWith('P-');
        
        const kioskSales = scopedQuickSaleRows.filter(row => isKioskReceipt(row));
        const packageSales = scopedQuickSaleRows.filter(row => 
          row.referenceNumber?.startsWith('PKT-') || row.receiptNumber?.startsWith('PKT-')
        );
        const getirSales = scopedQuickSaleRows.filter(row => 
          row.referenceNumber?.startsWith('GTR-') || row.receiptNumber?.startsWith('GTR-')
        );
        const migrosSales = scopedQuickSaleRows.filter(row => 
          row.referenceNumber?.startsWith('MGR-') || row.receiptNumber?.startsWith('MGR-')
        );
        const ysSales = scopedQuickSaleRows.filter(row => 
          row.referenceNumber?.startsWith('YS-') || row.receiptNumber?.startsWith('YS-')
        );
        const trdSales = scopedQuickSaleRows.filter(row => 
          row.referenceNumber?.startsWith('TRD-') || row.receiptNumber?.startsWith('TRD-')
        );
        const regularQuickSales = scopedQuickSaleRows.filter(row => 
          !isKioskReceipt(row) &&
          !row.referenceNumber?.startsWith('PKT-') && !row.receiptNumber?.startsWith('PKT-') &&
          !row.referenceNumber?.startsWith('GTR-') && !row.receiptNumber?.startsWith('GTR-') &&
          !row.referenceNumber?.startsWith('MGR-') && !row.receiptNumber?.startsWith('MGR-') &&
          !row.referenceNumber?.startsWith('YS-') && !row.receiptNumber?.startsWith('YS-') &&
          !row.referenceNumber?.startsWith('TRD-') && !row.receiptNumber?.startsWith('TRD-')
        );
        
        console.log(`🏪 Kiosk: ${kioskSales.length}, 📦 Paket: ${packageSales.length}, Getir: ${getirSales.length}, Migros: ${migrosSales.length}, Y.Sepeti: ${ysSales.length}, Trendyol: ${trdSales.length}, Normal: ${regularQuickSales.length}`);
        
        // En yeni kayıt en üstte - Normal Hızlı Satış
        const sortedQuickSales = regularQuickSales.sort((a, b) => {
          const dateA = new Date(a.transactionDate).getTime();
          const dateB = new Date(b.transactionDate).getTime();
          return dateB - dateA;
        });
        sortedQuickSales.forEach((row, index) => { row.rowNumber = index + 1; });
        
        processedQuickSales = sortedQuickSales;
        setQuickSaleData(sortedQuickSales);
        
        // ✅ Paket Sipariş verilerini ayrı state'e kaydet
        const sortedPackageSales = packageSales.sort((a, b) => {
          const dateA = new Date(a.transactionDate).getTime();
          const dateB = new Date(b.transactionDate).getTime();
          return dateB - dateA;
        });
        sortedPackageSales.forEach((row, index) => { row.rowNumber = index + 1; });
        
        // QuickSaleRow -> PackageOrderRow dönüşümü
        const packageOrderRows: EndOfDayPackageOrderRow[] = sortedPackageSales.map((row) => ({
          id: row.id,
          rowNumber: row.rowNumber,
          orderNumber: row.referenceNumber || '',
          shortCode: row.receiptNumber || '',
          status: row.status,
          orderStatus: 'DELIVERED', // Ödeme alındıysa teslim edilmiştir
          subtotal: row.subtotal,
          grandTotal: row.grandTotal,
          paidAmount: row.paidAmount,
          paymentType: row.paymentType,
          paymentAccountName: row.paymentAccountName,
          cancelledTotal: row.cancelledTotal,
          createdAt: row.openedAt || row.transactionDate,
          paymentDate: row.transactionDate,
          customerName: row.customerName,
          customerPhone: '',
          customerAddress: '',
          courierName: '',
          invoiceNumber: row.invoiceNumber,
          branchName: row.branchName,
          branchId: row.branchId ?? undefined,
          cashierName: row.cashierName || row.createdByName,
          invoiceId: row.invoiceId,
          paymentProviderName: row.paymentProviderName,
          cashAmount: row.paymentType === 'CASH' ? row.paidAmount : 0,
          posAmount: row.paymentType === 'POS' ? row.paidAmount : 0,
          otherAmount: row.paymentType === 'OTHER' ? row.paidAmount : 0,
        }));
        
        // PR1 cancel akışı entegrasyonu — Ödeme alınmadan iptal edilen telefon
        // siparişleri (`OrderStatus='CANCELLED'`) QuickSaleReceipts'te yazılı
        // olmadığı için PackageOrders tablosundan ayrıca çekilir ve burada
        // `packageOrderRows`'a eklenir. Dedup: orderNumber (PKT-...) zaten
        // listede ise (ödenmiş+iptal edilmiş edge case) tekrar eklenmez.
        const cancelledPackageRows: EndOfDayPackageOrderRow[] = [];
        if (packageOrderResult.status === 'fulfilled' &&
            packageOrderResult.value?.Success &&
            Array.isArray(packageOrderResult.value?.Data)) {
          const existingOrderNumbers = new Set(
            packageOrderRows.map(r => (r.orderNumber || '').toUpperCase())
          );
          const cancelledDtos: any[] = (packageOrderResult.value.Data as any[]).filter(o =>
            (o?.OrderStatus || '').toString().toUpperCase() === 'CANCELLED'
          );
          console.log('🚫 PackageOrders cancel akışı:', { total: packageOrderResult.value.Data.length, cancelled: cancelledDtos.length });

          cancelledDtos.forEach((dto: any) => {
            const orderNo = (dto.OrderNumber || '').toString();
            if (!orderNo) return;
            // Dedup: aynı orderNumber zaten QuickSaleReceipts üzerinden gelmişse atla.
            if (existingOrderNumbers.has(orderNo.toUpperCase())) return;

            const dtoBranchId = dto.BranchId != null && String(dto.BranchId).trim() !== ''
              ? String(dto.BranchId).trim()
              : undefined;
            // Şube filtresi: tüm şubeler değilse seçili şubeleri uygula
            // (server-side şube filtresi zaten yapıldı; bu ekstra güvenlik).
            if (!isAllBranches && dtoBranchId && !selectedBranches.includes(dtoBranchId)) return;

            const branchNameForRow = dtoBranchId ? getBranchName(dtoBranchId) : '-';
            // Müşteri sütununda "Genel Cari" yerine isim varsa onu göster.
            const customer = (dto.AccountName || '').toString().trim() || 'Genel Cari';
            // Notes alanına iptal sebebi + (varsa) açıklama yaz — kullanıcı tek
            // bakışta neden iptal edildiğini görsün.
            const reasonText = (dto.CancelReason || '').toString().trim();
            const noteText = (dto.CancelNote || '').toString().trim();
            const notesCombined = [reasonText, noteText].filter(Boolean).join(' — ');

            cancelledPackageRows.push({
              id: `pkt-cancel-${dto.Id}`,
              rowNumber: 0, // sıralama sonrasında yeniden atanır
              orderNumber: orderNo,
              shortCode: (dto.ShortCode || '').toString(),
              status: 'CANCELLED',
              orderStatus: 'CANCELLED',
              subtotal: Number(dto.SubTotal || 0),
              grandTotal: Number(dto.TotalAmount || 0),
              paidAmount: 0,
              paymentType: 'NONE' as PaymentType,
              paymentAccountName: '-',
              cancelledTotal: Number(dto.TotalAmount || 0),
              createdAt: dto.CreatedAt,
              paymentDate: null,
              customerName: customer,
              customerPhone: (dto.CustomerPhone || '').toString(),
              customerAddress: (dto.CustomerAddress || '').toString(),
              courierName: (dto.CourierName || '').toString(),
              invoiceNumber: '',
              branchName: branchNameForRow,
              branchId: dtoBranchId,
              cashierName: undefined,
              invoiceId: undefined,
              paymentProviderName: undefined,
              cashAmount: 0,
              posAmount: 0,
              otherAmount: 0,
              // Paket sipariş detay modali için: cancel akışında dto.Id zaten
              // PackageOrders.Id; doğrudan kullanılabilir, enrichment gerekmez.
              packageOrderId: Number(dto.Id),
              // Ek bağlam: iptal sebebi + açıklama (UI Notes sütunu yoksa
              // ileride i18n tooltip ile kullanılabilir; mevcut interface
              // notes alanı içermediği için bilgi konsola düşer.)
            } as EndOfDayPackageOrderRow);
            console.log('  ↳ iptal eklendi:', { orderNo, total: dto.TotalAmount, reason: notesCombined });
          });
        }

        // Birleşik liste: önce ödenenler/açık olanlar (zaten sortedPackageSales),
        // sonra iptaller. Yeniden sıralamak için createdAt kullanıyoruz —
        // kullanıcı raporda kronolojik (en yeni üstte) görmek ister.
        const mergedPackageRows = [...packageOrderRows, ...cancelledPackageRows].sort((a, b) => {
          const dateA = new Date(a.createdAt as any).getTime();
          const dateB = new Date(b.createdAt as any).getTime();
          return dateB - dateA;
        });
        mergedPackageRows.forEach((row, index) => { row.rowNumber = index + 1; });

        processedPackageOrders = mergedPackageRows;
        setPackageOrderData(mergedPackageRows);
        console.log('✅ Paket Sipariş (QuickSaleReceipts + PackageOrders cancels):', {
          fromReceipts: packageOrderRows.length,
          cancelledFromPackageOrders: cancelledPackageRows.length,
          total: mergedPackageRows.length,
        });

        // ✅ Getir Sipariş verilerini ayrı state'e kaydet
        const sortedGetirSales = getirSales.sort((a, b) => {
          const dateA = new Date(a.transactionDate).getTime();
          const dateB = new Date(b.transactionDate).getTime();
          return dateB - dateA;
        });
        sortedGetirSales.forEach((row, index) => { row.rowNumber = index + 1; });

        const getirOrderRows: EndOfDayPackageOrderRow[] = sortedGetirSales.map((row) => ({
          id: row.id,
          rowNumber: row.rowNumber,
          orderNumber: row.referenceNumber || '',
          shortCode: row.receiptNumber || '',
          status: row.status,
          orderStatus: 'DELIVERED',
          subtotal: row.subtotal,
          grandTotal: row.grandTotal,
          paidAmount: row.paidAmount,
          paymentType: row.paymentType,
          paymentAccountName: row.paymentAccountName,
          cancelledTotal: row.cancelledTotal,
          createdAt: row.openedAt || row.transactionDate,
          paymentDate: row.transactionDate,
          customerName: row.customerName,
          customerPhone: '',
          customerAddress: '',
          courierName: '',
          invoiceNumber: row.invoiceNumber,
          branchName: row.branchName,
          branchId: row.branchId ?? undefined,
          cashierName: row.cashierName || row.createdByName,
          invoiceId: row.invoiceId,
          paymentProviderName: row.paymentProviderName,
          cashAmount: row.paymentType === 'CASH' ? row.paidAmount : 0,
          posAmount: row.paymentType === 'POS' ? row.paidAmount : 0,
          otherAmount: row.paymentType === 'OTHER' ? row.paidAmount : 0,
        }));

        processedGetirOrders = getirOrderRows;
        setGetirOrderData(getirOrderRows);
        console.log('✅ Getir Sipariş (QuickSaleReceipts):', getirOrderRows.length);

        // Migros Sipariş verilerini işle
        const sortedMigrosSales = migrosSales.sort((a, b) => new Date(b.transactionDate).getTime() - new Date(a.transactionDate).getTime());
        sortedMigrosSales.forEach((row, index) => { row.rowNumber = index + 1; });
        const migrosOrderRows: EndOfDayPackageOrderRow[] = sortedMigrosSales.map((row) => ({
          id: row.id, rowNumber: row.rowNumber,
          orderNumber: row.referenceNumber || '', shortCode: row.receiptNumber || '',
          status: row.status, orderStatus: 'DELIVERED',
          subtotal: row.subtotal, grandTotal: row.grandTotal, paidAmount: row.paidAmount,
          paymentType: row.paymentType, paymentAccountName: row.paymentAccountName,
          cancelledTotal: row.cancelledTotal, createdAt: row.openedAt || row.transactionDate, paymentDate: row.transactionDate,
          customerName: row.customerName, customerPhone: '', customerAddress: '', courierName: '',
          invoiceNumber: row.invoiceNumber, branchName: row.branchName,
          branchId: row.branchId ?? undefined,
          cashierName: row.cashierName || row.createdByName, invoiceId: row.invoiceId,
          paymentProviderName: row.paymentProviderName,
          cashAmount: row.paymentType === 'CASH' ? row.paidAmount : 0,
          posAmount: row.paymentType === 'POS' ? row.paidAmount : 0,
          otherAmount: row.paymentType === 'OTHER' ? row.paidAmount : 0,
        }));
        processedMigrosOrders = migrosOrderRows;
        setMigrosOrderData(migrosOrderRows);
        console.log('✅ Migros Sipariş (QuickSaleReceipts):', migrosOrderRows.length);

        // Yemeksepeti Sipariş verilerini işle
        const sortedYsSales = ysSales.sort((a, b) => new Date(b.transactionDate).getTime() - new Date(a.transactionDate).getTime());
        sortedYsSales.forEach((row, index) => { row.rowNumber = index + 1; });
        const ysOrderRows: EndOfDayPackageOrderRow[] = sortedYsSales.map((row) => ({
          id: row.id, rowNumber: row.rowNumber,
          orderNumber: row.referenceNumber || '', shortCode: row.receiptNumber || '',
          status: row.status, orderStatus: 'DELIVERED',
          subtotal: row.subtotal, grandTotal: row.grandTotal, paidAmount: row.paidAmount,
          paymentType: row.paymentType, paymentAccountName: row.paymentAccountName,
          cancelledTotal: row.cancelledTotal, createdAt: row.openedAt || row.transactionDate, paymentDate: row.transactionDate,
          customerName: row.customerName, customerPhone: '', customerAddress: '', courierName: '',
          invoiceNumber: row.invoiceNumber, branchName: row.branchName,
          branchId: row.branchId ?? undefined,
          cashierName: row.cashierName || row.createdByName, invoiceId: row.invoiceId,
          paymentProviderName: row.paymentProviderName,
          cashAmount: row.paymentType === 'CASH' ? row.paidAmount : 0,
          posAmount: row.paymentType === 'POS' ? row.paidAmount : 0,
          otherAmount: row.paymentType === 'OTHER' ? row.paidAmount : 0,
        }));
        processedYsOrders = ysOrderRows;
        setYsOrderData(ysOrderRows);
        console.log('✅ Yemeksepeti Sipariş (QuickSaleReceipts):', ysOrderRows.length);

        // Trendyol Sipariş verilerini işle
        const sortedTrdSales = trdSales.sort((a, b) => new Date(b.transactionDate).getTime() - new Date(a.transactionDate).getTime());
        sortedTrdSales.forEach((row, index) => { row.rowNumber = index + 1; });
        const trdOrderRows: EndOfDayPackageOrderRow[] = sortedTrdSales.map((row) => ({
          id: row.id, rowNumber: row.rowNumber,
          orderNumber: row.referenceNumber || '', shortCode: row.receiptNumber || '',
          status: row.status, orderStatus: 'DELIVERED',
          subtotal: row.subtotal, grandTotal: row.grandTotal, paidAmount: row.paidAmount,
          paymentType: row.paymentType, paymentAccountName: row.paymentAccountName,
          cancelledTotal: row.cancelledTotal, createdAt: row.openedAt || row.transactionDate, paymentDate: row.transactionDate,
          customerName: row.customerName, customerPhone: '', customerAddress: '', courierName: '',
          invoiceNumber: row.invoiceNumber, branchName: row.branchName,
          branchId: row.branchId ?? undefined,
          cashierName: row.cashierName || row.createdByName, invoiceId: row.invoiceId,
          paymentProviderName: row.paymentProviderName,
          cashAmount: row.paymentType === 'CASH' ? row.paidAmount : 0,
          posAmount: row.paymentType === 'POS' ? row.paidAmount : 0,
          otherAmount: row.paymentType === 'OTHER' ? row.paidAmount : 0,
        }));
        processedTrendyolOrders = trdOrderRows;
        setTrendyolOrderData(trdOrderRows);
        console.log('✅ Trendyol Sipariş (QuickSaleReceipts):', trdOrderRows.length);

        // ✅ Kiosk verilerini QuickSaleReceipts'ten dönüştür (D-/P- prefix)
        const sortedKioskSales = kioskSales.sort((a, b) => {
          const dateA = new Date(a.transactionDate).getTime();
          const dateB = new Date(b.transactionDate).getTime();
          return dateB - dateA;
        });
        sortedKioskSales.forEach((row, index) => { row.rowNumber = index + 1; });

        const kioskOrderRows: EndOfDayKioskRow[] = sortedKioskSales.map((row) => ({
          id: row.id,
          rowNumber: row.rowNumber,
          referenceNumber: row.referenceNumber || row.receiptNumber || '',
          status: row.status,
          subtotal: row.subtotal,
          grandTotal: row.grandTotal,
          paidAmount: row.paidAmount,
          paymentType: row.paymentType,
          cancelledTotal: row.cancelledTotal,
          transactionDate: row.transactionDate,
          notes: row.notes || '',
          customerName: row.customerName || 'Kiosk Müşterisi',
          kioskName: row.referenceNumber?.startsWith('D-') ? 'Burada Ye' : 'Paket',
          invoiceId: row.invoiceId,
          invoiceNumber: row.invoiceNumber || '',
          paymentAccountName: row.paymentAccountName,
          payments: row.payments,
        }));

        processedKioskData = kioskOrderRows;
        setKioskData(kioskOrderRows);
        console.log('✅ Kiosk (QuickSaleReceipts D-/P-):', kioskOrderRows.length);
      }
      
      // ✅ KIOSK VERİLERİ: Artık QuickSaleReceipts'ten D-/P- prefix ile dolduruldu (yukarıda)
      
      // ✅ QR MENÜ VERİLERİNİ İŞLE
      let processedQRMenuData: EndOfDayQRMenuRow[] = [];
      if (qrMenuResult.status === 'fulfilled') {
        processedQRMenuData = qrMenuResult.value;
        setQRMenuData(qrMenuResult.value);
        console.log('✅ QR Menü:', qrMenuResult.value.length);
      }
      
      // ✅ PAKET SİPARİŞ VERİLERİ artık yukarıda QuickSaleReceipts'ten filtreleniyor (PKT- prefix)
      // processedPackageOrders değişkeni yukarıda tanımlandı
      
      // Açık masaları paralel çek (sadece restoran için)
      const activeResults = await Promise.allSettled(
        restaurantScreensToFetch.map(screen =>
          restaurantActiveSaleApi.getByRestaurantScreenId(screen.id)
        )
      );
      const allActiveSales = activeResults.flatMap(r => r.status === 'fulfilled' ? r.value : []);
      setActiveTables(allActiveSales);
      console.log('Açık masalar:', allActiveSales.length);
      
      // ✅ DEBUG: Hızlı satış verilerini kontrol et
      console.log('🔍 [DEBUG] Özet hesaplama öncesi:', {
        restoranSayisi: restaurantSales.length,
        hizliSatisSayisi: processedQuickSales.length,
        hizliSatisOrnekPayments: processedQuickSales.slice(0, 2).map(q => ({
          id: q.id,
          paymentType: q.paymentType,
          paymentAccountName: q.paymentAccountName,
          payments: q.payments,
          paidAmount: q.paidAmount
        }))
      });
      
      // ✅ TÜM KANALLARIN BİRLEŞİK ÖZETİNİ HESAPLA
      const allSummaryRows = calculateCombinedSummary(
        restaurantSales,
        processedQuickSales,
        processedKioskData,
        processedQRMenuData,
        processedPackageOrders,
        processedGetirOrders,
        processedMigrosOrders,
        processedYsOrders,
        processedTrendyolOrders
      );
      
      console.log('🔍 [DEBUG] Özet hesaplama sonucu:', allSummaryRows);
      setSummaryTableRows(allSummaryRows);
      
      // Eski summary için de hesapla (gün sonu işlemi için gerekli)
      const combinedSummary = calculateCombinedSummaryOld(
        restaurantSales,
        processedQuickSales,
        processedKioskData,
        processedQRMenuData,
        processedPackageOrders,
        processedGetirOrders,
        processedMigrosOrders,
        processedYsOrders,
        processedTrendyolOrders
      );
      setSummary(combinedSummary);

      // ============================================================
      // KULÜP GİRİŞ DEPOZİTO ÖZETİ (satış cirosuna dahil değil, ayrı bölüm)
      // Şube seçiliyse her şube için ayrı çekip toplarız; tüm şubelerde tek çağrı.
      // Hata olursa rapor akışını bozmadan sessizce geçilir.
      // ============================================================
      try {
        const depStartISO = startDate.toISOString();
        const depEndISO = endDate.toISOString();
        const emptyDeposit: ClubDepositSummaryDto = {
          collectedCash: 0, collectedPos: 0, collectedTotal: 0, collectedCount: 0,
          refundedTotal: 0, refundedCount: 0, netTotal: 0,
        };
        let depositSummary: ClubDepositSummaryDto;
        if (isAllBranches) {
          depositSummary = await clubEntryService.getDepositsSummary({ startDate: depStartISO, endDate: depEndISO });
        } else {
          const perBranch = await Promise.allSettled(
            selectedBranches.map(bid =>
              clubEntryService.getDepositsSummary({ startDate: depStartISO, endDate: depEndISO, branchId: bid })
            )
          );
          depositSummary = perBranch.reduce<ClubDepositSummaryDto>((acc, r) => {
            if (r.status !== 'fulfilled') return acc;
            const d = r.value;
            return {
              collectedCash: acc.collectedCash + d.collectedCash,
              collectedPos: acc.collectedPos + d.collectedPos,
              collectedTotal: acc.collectedTotal + d.collectedTotal,
              collectedCount: acc.collectedCount + d.collectedCount,
              refundedTotal: acc.refundedTotal + d.refundedTotal,
              refundedCount: acc.refundedCount + d.refundedCount,
              netTotal: acc.netTotal + d.netTotal,
            };
          }, { ...emptyDeposit });
        }
        setClubDepositSummary(depositSummary);
      } catch (depErr) {
        console.warn('[GÜN SONU] Kulüp giriş depozito özeti alınamadı:', depErr);
        setClubDepositSummary(null);
      }

      // ============================================================
      // SAĞLAMA SİSTEMİ: Platform API'lerden sipariş çek + çapraz kontrol
      // ============================================================
      const branchParam = !isAllBranches ? selectedBranches[0] : '';
      const startISO = startDate.toISOString();
      const endISO = endDate.toISOString();
      
      const buildReconciliationParams = (extra?: Record<string, string>) => {
        const p = new URLSearchParams();
        p.append('page', '1');
        p.append('pageSize', '5000');
        p.append('startDate', startISO);
        p.append('endDate', endISO);
        if (branchParam) p.append('branchId', branchParam);
        if (extra) Object.entries(extra).forEach(([k, v]) => p.append(k, v));
        return p.toString();
      };

      /** Çoklu şube seçildiğinde tek çağrıda yalnızca ilk şube gidiyordu; Trendyol için her seçili şubeyi çekip birleştiriyoruz */
      const fetchTrendyolPlatformMerged = async (): Promise<PromiseSettledResult<any>> => {
        try {
          if (isAllBranches) {
            const r = await trendyolApi.get(`/api/trendyol/order/list?${buildReconciliationParams()}`);
            return { status: 'fulfilled', value: r.data };
          }
          const merged: any[] = [];
          const seen = new Set<string>();
          for (const bid of selectedBranches) {
            const p = new URLSearchParams();
            p.append('page', '1');
            p.append('pageSize', '5000');
            p.append('startDate', startISO);
            p.append('endDate', endISO);
            p.append('branchId', bid);
            const r = await trendyolApi.get(`/api/trendyol/order/list?${p.toString()}`);
            const raw = r.data?.Data ?? r.data?.data ?? [];
            for (const o of raw) {
              const oid = String(o.id ?? o.Id ?? '');
              if (!oid || seen.has(oid)) continue;
              seen.add(oid);
              merged.push(o);
            }
          }
          return { status: 'fulfilled', value: { Success: true, Data: merged } };
        } catch (e) {
          return { status: 'rejected', reason: e };
        }
      };
      
      const [pkgPlatform, getirPlatform, migrosPlatform, ysPlatform] = await Promise.allSettled([
        salesApi.get(`/api/PackageOrder/by-date-range?${buildReconciliationParams()}`).then(r => r.data).catch(() => null),
        getirApi.get(`/api/getir-orders/list?${buildReconciliationParams()}`).then(r => r.data).catch(() => null),
        migrosApi.get(`/api/migros-orders/list?${buildReconciliationParams()}`).then(r => r.data).catch(() => null),
        yemeksepetiApi.get(`/api/ys-orders/list?${buildReconciliationParams()}`).then(r => r.data).catch(() => null),
      ]);
      const trendyolPlatform = await fetchTrendyolPlatformMerged();
      
      const filterStartMs = startDate.getTime();
      const filterEndMs = endDate.getTime();
      
      // Restoran satışlarını da dahil et (fatura sağlaması için)
      const restaurantAsRows = restaurantSales.map(s => ({
        invoiceNumber: s.InvoiceNumber || '',
        invoiceId: '',
        grandTotal: s.TotalAmount || 0,
      }));
      const allReceipts = [...processedQuickSales, ...processedKioskData, ...processedPackageOrders, ...processedGetirOrders, ...processedMigrosOrders, ...processedYsOrders, ...processedTrendyolOrders, ...restaurantAsRows];
      
      const invoiceNumberSet = new Set<string>();
      const invoiceIdSet = new Set<string>();
      const invoiceIdToNumber = new Map<string, string>();
      const invoiceIdToAmount = new Map<string, number>();
      for (const r of allReceipts) {
        const invNum = (r as any).invoiceNumber ?? (r as any).InvoiceNumber ?? '';
        const invId = (r as any).invoiceId ?? (r as any).InvoiceId ?? '';
        const amount = (r as any).grandTotal ?? (r as any).paidAmount ?? 0;
        if (invNum) invoiceNumberSet.add(invNum);
        if (invId) invoiceIdSet.add(invId);
        if (invId && invNum) invoiceIdToNumber.set(invId, invNum);
        if (invId) invoiceIdToAmount.set(invId, amount);
      }
      console.log(`🔍 [SAĞLAMA] Fiş verisinden ${invoiceNumberSet.size} fatura numarası bulundu:`, Array.from(invoiceNumberSet));
      // Trendyol vb.: iş tarihi OrderDate — CreatedAt senkron zamanıdır; rapor tarihi ile CreatedAt filtrelemek yanlış satır üretirdi
      const filterByDate = (orders: any[]): any[] =>
        orders.filter(o => {
          const raw =
            o.orderDate ?? o.OrderDate ??
            o.createdAt ?? o.CreatedAt ?? o.receivedAt ?? o.ReceivedAt ?? '';
          if (!raw) return true;
          const t = new Date(raw).getTime();
          return !isNaN(t) && t >= filterStartMs && t <= filterEndMs;
        });
      
      const receiptInvoiceNumbers = new Set(allReceipts.map(r => r.invoiceNumber).filter(Boolean));
      
      // Platform verilerinden müşteri adı çıkaran yardımcı fonksiyon
      const extractCustomerName = (order: any): string => {
        if (order.CustomerName || order.customerName) {
          return String(order.CustomerName ?? order.customerName);
        }
        if (order.customer && (order.customer.firstName || order.customer.lastName)) {
          return [order.customer.firstName, order.customer.lastName].filter(Boolean).join(' ').trim();
        }
        if (order.OrderDetailsJson || order.orderDetailsJson) {
          try {
            const json = typeof (order.OrderDetailsJson ?? order.orderDetailsJson) === 'string'
              ? JSON.parse(order.OrderDetailsJson ?? order.orderDetailsJson) : (order.OrderDetailsJson ?? order.orderDetailsJson);
            if (json?.customer) {
              return [json.customer.firstName, json.customer.lastName].filter(Boolean).join(' ').trim();
            }
          } catch {}
        }
        return order.clientName ?? order.ClientName
          ?? order.customerFullName ?? order.CustomerFullName
          ?? order.customerFirstName ?? order.CustomerFirstName
          ?? '';
      };
      
      const reconcile = (platformOrders: any[], platform: string, receiptPrefix: string, amountDivisor: number = 1): ReconciliationResult => {
        const paid: PlatformOrderSummary[] = [];
        const unpaid: PlatformOrderSummary[] = [];
        const cancelled: PlatformOrderSummary[] = [];
        const warnings: PlatformOrderSummary[] = [];
        
        const prefixReceipts = allReceipts.filter((r: any) =>
          r.invoiceNumber && ((r.referenceNumber ?? r.orderNumber ?? '')?.startsWith(receiptPrefix) || (r.receiptNumber ?? r.shortCode ?? '')?.startsWith(receiptPrefix))
        );
        const prefixInvoiceNumbers = new Set(prefixReceipts.map(r => r.invoiceNumber).filter(Boolean));
        
        for (const order of platformOrders) {
          const id = String(order.id ?? order.Id ?? '');
          const orderNumber = order.orderNumber ?? order.OrderNumber ?? order.confirmationId ?? order.ConfirmationId ?? order.shortCode ?? order.ShortCode ?? '';
          const customerName = extractCustomerName(order) || '-';
          // ⚠️ PLATFORM-SPESIFIK NET ONCELIGI
          // Sadece Getir icin NET'i (totalDiscountedPrice) oncelikli aliyoruz;
          // cunku Getir backend `totalAmount` alanini BRUT olarak dolduruyor.
          //
          // YS / Trendyol / Migros / Package icin backend `totalAmount` zaten
          // net olarak kullaniliyor (eski davranis). Bu platformlarin alan
          // isimleri (totalNet, netAmount vb.) tutarsiz oldugundan dokunulmaz.
          let rawAmount: number;
          if (platform === 'getir') {
            rawAmount = Number(
              order.totalDiscountedPrice ?? order.TotalDiscountedPrice ??
              order.totalPrice ?? order.TotalPrice ?? 0
            );
          } else {
            rawAmount = Number(
              order.totalAmount ?? order.TotalAmount ??
              order.grandTotal ?? order.GrandTotal ??
              order.totalPrice ?? order.TotalPrice ??
              order.ToplamTutar ?? order.toplamTutar ?? 0
            );
          }
          const totalAmount = amountDivisor !== 1 ? Math.round((rawAmount / amountDivisor) * 100) / 100 : rawAmount;
          const createdAt =
            order.orderDate ?? order.OrderDate ??
            order.createdAt ?? order.CreatedAt ?? order.receivedAt ?? order.ReceivedAt ?? '';
          let invoiceNumber = order.invoiceNumber ?? order.InvoiceNumber ?? '';
          const invoiceId = order.invoiceId ?? order.InvoiceId ?? '';
          if (!invoiceNumber && invoiceId && invoiceIdToNumber.has(invoiceId)) {
            invoiceNumber = invoiceIdToNumber.get(invoiceId) || '';
          }
          const paymentStatusRaw = (order.paymentStatus ?? order.PaymentStatus ?? '').toUpperCase();
          const orderStatusRaw = (order.orderStatus ?? order.OrderStatus ?? order.status ?? order.Status ?? '').toString();
          
          const isCancelledOrder = ['CANCELLED', 'REJECTED', 'CANCEL', '1500', '1600', 'UNSUPPLIED'].some(s =>
            orderStatusRaw.toUpperCase().includes(s) || paymentStatusRaw.includes(s)
          );
          // Trendyol: ödenmiş pakette çoğu zaman PaymentStatus boş; kesilmiş fatura no ile ödendi kabul et (sağlama satırında doğru bucket)
          const isPaidOrder =
            paymentStatusRaw === 'PAID'
            || order.isPaid === true
            || order.IsPaid === true
            || (!!invoiceNumber && platform === 'trendyol');
          const hasReceipt = invoiceNumber ? prefixInvoiceNumbers.has(invoiceNumber) : undefined;
          const hasInvoice = !!((invoiceNumber && invoiceNumberSet.has(invoiceNumber)) || (invoiceId && invoiceIdSet.has(invoiceId)));
          
          const rawBranchId = order.branchId ?? order.BranchId;
          const branchIdNorm =
            rawBranchId != null && String(rawBranchId).trim() !== ''
              ? String(rawBranchId).trim()
              : undefined;

          const summary: PlatformOrderSummary = {
            id,
            orderNumber,
            customerName,
            totalAmount,
            createdAt,
            invoiceNumber,
            invoiceId,
            branchId: branchIdNorm,
            platform,
            hasReceipt,
            hasInvoice,
            paymentStatus: isCancelledOrder ? 'CANCELLED' : isPaidOrder ? 'PAID' : 'UNPAID',
          };
          
          if (isCancelledOrder) {
            cancelled.push(summary);
          } else if (isPaidOrder) {
            paid.push(summary);
            if (!invoiceNumber && !hasInvoice) {
              warnings.push({ ...summary, hasReceipt: false, hasInvoice: false });
            } else if (invoiceNumber && !hasInvoice) {
              warnings.push({ ...summary });
            } else if (invoiceNumber && !hasReceipt) {
              warnings.push({ ...summary });
            }
          } else {
            unpaid.push(summary);
          }
        }
        
        return {
          paid, unpaid, cancelled, warnings,
          paidTotal: paid.reduce((s, o) => s + o.totalAmount, 0),
          unpaidTotal: unpaid.reduce((s, o) => s + o.totalAmount, 0),
          cancelledTotal: cancelled.reduce((s, o) => s + o.totalAmount, 0),
          warningTotal: warnings.reduce((s, o) => s + o.totalAmount, 0),
        };
      };
      
      const reconcileSimple = (rows: any[], platform: string): ReconciliationResult => {
        const paid: PlatformOrderSummary[] = [];
        const cancelled: PlatformOrderSummary[] = [];
        const warnings: PlatformOrderSummary[] = [];
        
        for (const row of rows) {
          let invNum = row.invoiceNumber ?? '';
          const invId = row.invoiceId ?? '';
          const hasInvoice = (invNum && invoiceNumberSet.has(invNum)) || (invId && invoiceIdSet.has(invId));
          
          if (!invNum && invId && invoiceIdToNumber.has(invId)) {
            invNum = invoiceIdToNumber.get(invId) || '';
          }
          
          const summary: PlatformOrderSummary = {
            id: String(row.id ?? ''),
            orderNumber: row.orderNumber ?? row.referenceNumber ?? row.receiptNumber ?? '',
            customerName: row.customerName ?? '-',
            totalAmount: row.grandTotal ?? 0,
            createdAt: row.openedAt ?? row.transactionDate ?? row.createdAt ?? '',
            invoiceNumber: invNum,
            platform,
            paymentStatus: row.status === 'CANCELLED' ? 'CANCELLED' : 'PAID',
            hasReceipt: true,
            hasInvoice: !!hasInvoice,
            invoiceId: invId,
          };
          if (row.status === 'CANCELLED') {
            cancelled.push(summary);
          } else {
            paid.push(summary);
            if (!hasInvoice) {
              warnings.push({ ...summary });
            }
          }
        }
        
        return {
          paid, unpaid: [], cancelled, warnings,
          paidTotal: paid.reduce((s, o) => s + o.totalAmount, 0),
          unpaidTotal: 0,
          cancelledTotal: cancelled.reduce((s, o) => s + o.totalAmount, 0),
          warningTotal: warnings.reduce((s, o) => s + o.totalAmount, 0),
        };
      };
      
      const newReconciliation: Record<string, ReconciliationResult> = {
        quickSale: reconcileSimple(processedQuickSales, 'quickSale'),
        restaurant: reconcileSimple(restaurantSales.map(s => ({
          id: s.Id, orderNumber: s.SaleNumber, customerName: s.InvoiceNumber ? 'Genel Cari' : '',
          grandTotal: s.TotalAmount, openedAt: s.OpenedAt, invoiceNumber: s.InvoiceNumber,
          invoiceId: (s as any).InvoiceId || '',
          status: (s.PaymentMethod?.toLowerCase() === 'unpaid' || s.PaymentMethod?.toLowerCase() === 'cancelled' || s.PaymentMethod?.toLowerCase() === 'iptal') ? 'CANCELLED' : 'PAID',
        })), 'restaurant'),
        kiosk: reconcileSimple(processedKioskData, 'kiosk'),
        qrMenu: emptyReconciliation,
        package: emptyReconciliation,
        getir: emptyReconciliation,
        migros: emptyReconciliation,
        yemeksepeti: emptyReconciliation,
        trendyol: emptyReconciliation,
      };
      
      const extractData = (result: PromiseSettledResult<any>) =>
        result.status === 'fulfilled' && result.value && (result.value.Success || result.value.success)
          ? filterByDate(result.value.Data || result.value.data || [])
          : [];
      
      newReconciliation.package = reconcile(extractData(pkgPlatform).filter((o: any) => {
        const src = (o.syncSource ?? o.SyncSource ?? '').toLowerCase();
        return src === 'phone' || src === 'manual' || src === '' || src === 'web' || src === 'ecommerce';
      }), 'package', 'PKT-');
      newReconciliation.getir = reconcile(extractData(getirPlatform), 'getir', 'GTR-');
      newReconciliation.migros = reconcile(extractData(migrosPlatform), 'migros', 'MGR-', 100);
      newReconciliation.yemeksepeti = reconcile(extractData(ysPlatform), 'yemeksepeti', 'YS-');
      newReconciliation.trendyol = reconcile(extractData(trendyolPlatform), 'trendyol', 'TRD-');

      // Trendyol modal'i icin platform order listesini bellekte tut (find ile obje cekecegiz)
      trendyolPlatformOrdersRef.current = extractData(trendyolPlatform);

      // 🔍 [TANI] Yemeksepeti reconcile akışını detaylı incele — neden bazı siparişler kayboluyor?
      try {
        const ysRawResult = ysPlatform.status === 'fulfilled' ? ysPlatform.value : null;
        const ysRawData = ysRawResult?.Data || ysRawResult?.data || [];
        const ysAfterDateFilter = extractData(ysPlatform);
        console.log('🔍 [TANI-YS] API yanıt özeti:', {
          status: ysPlatform.status,
          success: !!(ysRawResult?.Success || ysRawResult?.success),
          ham_kayit_sayisi: ysRawData.length,
          tarih_filtresi_sonrasi: ysAfterDateFilter.length,
          frontend_filterStart: new Date(filterStartMs).toISOString(),
          frontend_filterEnd: new Date(filterEndMs).toISOString(),
        });
        if (ysAfterDateFilter.length > 0) {
          const sample = ysAfterDateFilter.map((o: any) => ({
            id: o.id ?? o.Id,
            shortCode: o.shortCode ?? o.ShortCode ?? o.code ?? o.Code,
            paymentStatus: o.paymentStatus ?? o.PaymentStatus,
            orderStatus: o.orderStatus ?? o.OrderStatus ?? o.status ?? o.Status,
            invoiceNumber: o.invoiceNumber ?? o.InvoiceNumber,
            branchId: o.branchId ?? o.BranchId,
            receivedAt: o.receivedAt ?? o.ReceivedAt,
            createdAt: o.createdAt ?? o.CreatedAt,
            orderDate: o.orderDate ?? o.OrderDate,
            grandTotal: o.grandTotal ?? o.GrandTotal,
          }));
          console.log('🔍 [TANI-YS] Tarih filtresinden sonra kalan kayıtlar:', sample);
        }
        // Filtrelenenleri ayrıca yazdır (varsa)
        if (ysRawData.length > ysAfterDateFilter.length) {
          const filteredOut = ysRawData.filter((o: any) => {
            const raw = o.orderDate ?? o.OrderDate ?? o.createdAt ?? o.CreatedAt ?? o.receivedAt ?? o.ReceivedAt ?? '';
            if (!raw) return false;
            const t = new Date(raw).getTime();
            return isNaN(t) || t < filterStartMs || t > filterEndMs;
          }).map((o: any) => ({
            id: o.id ?? o.Id,
            shortCode: o.shortCode ?? o.ShortCode ?? o.code ?? o.Code,
            receivedAt: o.receivedAt ?? o.ReceivedAt,
            createdAt: o.createdAt ?? o.CreatedAt,
            orderDate: o.orderDate ?? o.OrderDate,
          }));
          console.warn('⚠️ [TANI-YS] FilterByDate ELEDİĞİ kayıtlar:', filteredOut);
        }
        console.log('🔍 [TANI-YS] Reconcile bucket dağılımı:', {
          paid: newReconciliation.yemeksepeti.paid.length,
          unpaid: newReconciliation.yemeksepeti.unpaid.length,
          cancelled: newReconciliation.yemeksepeti.cancelled.length,
          warnings: newReconciliation.yemeksepeti.warnings.length,
          paidIds: newReconciliation.yemeksepeti.paid.map(o => ({ id: o.id, ord: o.orderNumber, inv: o.invoiceNumber })),
          unpaidIds: newReconciliation.yemeksepeti.unpaid.map(o => ({ id: o.id, ord: o.orderNumber, inv: o.invoiceNumber, br: o.branchId })),
          cancelledIds: newReconciliation.yemeksepeti.cancelled.map(o => ({ id: o.id, ord: o.orderNumber })),
        });
      } catch (e) {
        console.error('🔍 [TANI-YS] Log hatası:', e);
      }
      
      // Platform API verilerinden gerçek müşteri adlarını VE platform sipariş ID'sini
      // row'lara propagate et. ID propagate olduğu için EndOfDayReport tab'larındaki
      // satırlara tıklayınca platform-spesifik detay modali açılabiliyor.
      // Eşleştirme öncelik sırası: invoiceId → invoiceNumber → orderNumber/shortCode (prefix ile/siz).
      type PlatformIdField = 'getirOrderId' | 'migrosOrderId' | 'yemeksepetiOrderId' | 'trendyolOrderId' | 'packageOrderId';
      // Bütün prefix'leri sıyır — row.orderNumber `XXX-1234` formatındaysa platform tarafındaki
      // ham `1234` ile, ya da tersi durumda eşleşebilsin.
      const stripAnyPrefix = (s: string) => s.replace(/^(TRD|MGR|YS|GTR|PKT)-/i, '');
      const enrichRowsWithPlatformData = (
        orders: EndOfDayPackageOrderRow[],
        platformResult: PromiseSettledResult<any>,
        _prefix: string,
        idField: PlatformIdField
      ): EndOfDayPackageOrderRow[] => {
        const platformOrders = extractData(platformResult);
        if (platformOrders.length === 0 || orders.length === 0) return orders;

        const normRef = (s: string) => s.trim();

        // Platform-spesifik "indirimsiz toplam" hesabı — modal'larda "Ara/İndirimsiz Toplam"
        // diye gösterilen değerle aynı kaynaktan üretilir.
        const computeOriginal = (o: any): number | undefined => {
          if (idField === 'getirOrderId') {
            // Getir entity: `totalPrice` = brüt (urunler toplami, indirim oncesi)
            const v = Number(o.totalPrice ?? o.TotalPrice ?? 0);
            return Number.isFinite(v) && v > 0 ? v : undefined;
          }
          if (idField === 'migrosOrderId') {
            // Migros tutarları kuruş cinsinden döner.
            const raw = Number(o.totalPrice ?? o.TotalPrice ?? 0);
            const v = raw / 100;
            return Number.isFinite(v) && v > 0 ? v : undefined;
          }
          if (idField === 'yemeksepetiOrderId') {
            // Yemeksepeti v2026 (15.05.2026) ile birlikte products[].paidPrice
            // semantigi degisti: artik satir toplami degil, sadece urun baz
            // fiyati (topping haric). Bu yuzden hem v2026 oncesi hem sonrasi
            // siparisler icin tek kod yolu olusturan 3 katmanli fallback:
            //   1. Backend kolonu order.totalNet (her iki formatta da dolu)
            //   2. Ham JSON `price.totalNet` (Yemeksepeti'nin kendi hesabi)
            //   3. sum(paidPrice) (eski format icin dogru fallback)
            const totalNet = Number(o.totalNet ?? o.TotalNet ?? 0);
            if (Number.isFinite(totalNet) && totalNet > 0) return totalNet;
            try {
              const rawJson: string | undefined = o.rawJsonData ?? o.RawJsonData;
              if (rawJson) {
                const raw = JSON.parse(rawJson);
                const fromRaw = parseFloat(raw?.price?.totalNet ?? '0');
                if (Number.isFinite(fromRaw) && fromRaw > 0) return fromRaw;
              }
            } catch { /* fallthrough */ }
            const items: any[] = o.items ?? o.Items ?? [];
            const v = items.reduce((s: number, i: any) => s + Number(i.paidPrice ?? i.PaidPrice ?? 0), 0);
            return v > 0 ? v : undefined;
          }
          if (idField === 'trendyolOrderId') {
            // Trendyol entity şeması: TotalAmount (brüt, indirim öncesi),
            // NetAmount (indirim sonrası), DiscountAmount. List endpoint'i
            // bunları flat olarak döndürüyor; `totalPrice` field'ı YOKTUR
            // (eski koddaki o.totalPrice araması her zaman undefined dönüyordu
            // ve originalTotal boş kalıyordu → renderCellValue grandTotal'e
            // düşüyordu).
            //
            // 3 katmanli fallback hiyerarşisi (Yemeksepeti'yle paralel):
            //   1. Backend kolonu o.totalAmount (brüt, list response'undan)
            //   2. orderDetailsJson içindeki totalPrice (Trendyol API ham
            //      payload'i, eski entity'lerde TotalAmount mapping'i yoksa
            //      veya 0 kaydedilmişse fallback)
            //   3. Eski koddaki o.totalPrice (eski cache satırları için)
            const totalAmount = Number(o.totalAmount ?? o.TotalAmount ?? 0);
            if (Number.isFinite(totalAmount) && totalAmount > 0) return totalAmount;
            try {
              const odj = o.orderDetailsJson ?? o.OrderDetailsJson;
              if (odj) {
                const raw = typeof odj === 'string' ? JSON.parse(odj) : odj;
                const fromRaw = Number(raw?.totalPrice ?? 0);
                if (Number.isFinite(fromRaw) && fromRaw > 0) return fromRaw;
              }
            } catch { /* fallthrough */ }
            const v = Number(o.totalPrice ?? o.TotalPrice ?? 0);
            return Number.isFinite(v) && v > 0 ? v : undefined;
          }
          return undefined;
        };

        // Platform-spesifik "NET TOPLAM" (indirim sonrasi) hesabi.
        // Detay modali ile ayni kaynaktan uretilir; UI'da "Genel Toplam"
        // sutununda gosterilir. Indirim YOKSA computeOriginal ile esit doner.
        //
        // ⚠️ Bu helper olmadan once: UNPAID/iptal platform siparisleri
        //    `convertPlatformOrderToRow` icinde `grandTotal = totalAmount`
        //    (BRUT) olarak set ediliyordu → Getir 645 (net) gostermesi
        //    gereken siparis tabloda 795 (brut) gozukuyordu. Indirim toplami
        //    da sifir cikiyordu (brut = brut).
        // ⚠️ PLATFORM-SPESIFIK NET HESAPLAMA STRATEJISI
        //
        // `computeNet` SADECE Getir icin aktif. Sebep:
        //   - Getir backend `totalAmount` brut tutar oldugu icin reconcile'da
        //     PlatformOrderSummary.totalAmount brut cikiyor ve row.grandTotal
        //     yanlis (795 yerine 645 olmasi gerekirken) goruluyordu.
        //   - Diger platformlar (YS, Trendyol, Migros) reconcile asamasinda
        //     PLATFORM-SPESIFIK `rawAmount` kuralina gore zaten NET cektigi
        //     icin row.grandTotal dogru olusuyor — bu noktada override
        //     etmeye CALISIRSAK platformlarin farkli alan isimleri yuzunden
        //     (orn. YS'de `totalNet` bazen brut deger tutuyor) yanlis sonuc
        //     veriyoruz.
        //
        // Once 2026-05-22: Tum platformlar icin `computeNet` net donduruyor
        // ve grandTotal override ediliyordu => YS ve Trendyol bozuldu.
        const computeNet = (o: any): number | undefined => {
          if (idField === 'getirOrderId') {
            const discounted = Number(o.totalDiscountedPrice ?? o.TotalDiscountedPrice ?? 0);
            if (Number.isFinite(discounted) && discounted > 0) return discounted;
            const v = Number(o.totalPrice ?? o.TotalPrice ?? 0);
            return Number.isFinite(v) && v > 0 ? v : undefined;
          }
          // YS / Trendyol / Migros: grandTotal'a dokunma — reconcile dogrudur.
          return undefined;
        };

        // InvoiceId / InvoiceNumber / OrderRef -> customer name + platform order id + originalTotal + netTotal haritaları
        const customerByInvoiceId = new Map<string, string>();
        const customerByInvoiceNum = new Map<string, string>();
        const customerByOrderRef = new Map<string, string>();
        const idByInvoiceId = new Map<string, number>();
        const idByInvoiceNum = new Map<string, number>();
        const idByOrderRef = new Map<string, number>();
        const originalByInvoiceId = new Map<string, number>();
        const originalByInvoiceNum = new Map<string, number>();
        const originalByOrderRef = new Map<string, number>();
        const netByInvoiceId = new Map<string, number>();
        const netByInvoiceNum = new Map<string, number>();
        const netByOrderRef = new Map<string, number>();

        for (const order of platformOrders) {
          const name = extractCustomerName(order);
          const rawId = order.id ?? order.Id ?? order.orderId ?? order.OrderId;
          const numericId = rawId != null && !Number.isNaN(Number(rawId)) ? Number(rawId) : undefined;
          const original = computeOriginal(order);
          const net = computeNet(order);
          const invId = String(order.invoiceId ?? order.InvoiceId ?? '');
          const invNum = String(order.invoiceNumber ?? order.InvoiceNumber ?? '');
          if (name) {
            if (invId) customerByInvoiceId.set(invId, name);
            if (invNum) customerByInvoiceNum.set(invNum, name);
          }
          if (numericId !== undefined) {
            if (invId) idByInvoiceId.set(invId, numericId);
            if (invNum) idByInvoiceNum.set(invNum, numericId);
          }
          if (typeof original === 'number') {
            if (invId) originalByInvoiceId.set(invId, original);
            if (invNum) originalByInvoiceNum.set(invNum, original);
          }
          if (typeof net === 'number') {
            if (invId) netByInvoiceId.set(invId, net);
            if (invNum) netByInvoiceNum.set(invNum, net);
          }

          const refCandidates = [
            order.orderNumber,
            order.OrderNumber,
            order.orderCode,
            order.OrderCode,
            order.packageId,
            order.PackageId,
            order.shortCode,
            order.ShortCode,
            order.code,
            order.Code,
            order.confirmationId,
            order.ConfirmationId,
            order.referenceNumber,
            order.ReferenceNumber,
          ].filter(Boolean).map((x: any) => String(x));
          for (const c of refCandidates) {
            const n = normRef(c);
            if (!n) continue;
            const nNoPrefix = stripAnyPrefix(n);
            if (name) {
              customerByOrderRef.set(n, name);
              if (nNoPrefix !== n) customerByOrderRef.set(nNoPrefix, name);
            }
            if (numericId !== undefined) {
              idByOrderRef.set(n, numericId);
              if (nNoPrefix !== n) idByOrderRef.set(nNoPrefix, numericId);
            }
            if (typeof original === 'number') {
              originalByOrderRef.set(n, original);
              if (nNoPrefix !== n) originalByOrderRef.set(nNoPrefix, original);
            }
            if (typeof net === 'number') {
              netByOrderRef.set(n, net);
              if (nNoPrefix !== n) netByOrderRef.set(nNoPrefix, net);
            }
          }
        }

        if (
          customerByInvoiceId.size === 0 &&
          customerByInvoiceNum.size === 0 &&
          customerByOrderRef.size === 0 &&
          idByInvoiceId.size === 0 &&
          idByInvoiceNum.size === 0 &&
          idByOrderRef.size === 0 &&
          originalByInvoiceId.size === 0 &&
          originalByInvoiceNum.size === 0 &&
          originalByOrderRef.size === 0 &&
          netByInvoiceId.size === 0 &&
          netByInvoiceNum.size === 0 &&
          netByOrderRef.size === 0
        ) return orders;

        let matchedCount = 0;
        let matchedOriginalCount = 0;
        let matchedNetCount = 0;
        const updatedOrders = orders.map(row => {
          const ordRef = row.orderNumber ? normRef(row.orderNumber) : '';
          const ordRefNoPrefix = stripAnyPrefix(ordRef);
          const shortRef = row.shortCode ? normRef(row.shortCode) : '';
          const shortRefNoPrefix = stripAnyPrefix(shortRef);
          const platformName =
            (row.invoiceId && customerByInvoiceId.get(row.invoiceId))
            || (row.invoiceNumber && customerByInvoiceNum.get(row.invoiceNumber))
            || (ordRef && customerByOrderRef.get(ordRef))
            || (ordRefNoPrefix && customerByOrderRef.get(ordRefNoPrefix))
            || (shortRef && customerByOrderRef.get(shortRef))
            || (shortRefNoPrefix && customerByOrderRef.get(shortRefNoPrefix))
            || '';
          const lookupId = (): number | undefined => {
            if (row.invoiceId) {
              const v = idByInvoiceId.get(row.invoiceId);
              if (v !== undefined) return v;
            }
            if (row.invoiceNumber) {
              const v = idByInvoiceNum.get(row.invoiceNumber);
              if (v !== undefined) return v;
            }
            if (ordRef) {
              const v = idByOrderRef.get(ordRef);
              if (v !== undefined) return v;
            }
            if (ordRefNoPrefix && ordRefNoPrefix !== ordRef) {
              const v = idByOrderRef.get(ordRefNoPrefix);
              if (v !== undefined) return v;
            }
            if (shortRef) {
              const v = idByOrderRef.get(shortRef);
              if (v !== undefined) return v;
            }
            if (shortRefNoPrefix && shortRefNoPrefix !== shortRef) {
              const v = idByOrderRef.get(shortRefNoPrefix);
              if (v !== undefined) return v;
            }
            return undefined;
          };
          const lookupOriginal = (): number | undefined => {
            if (row.invoiceId) {
              const v = originalByInvoiceId.get(row.invoiceId);
              if (v !== undefined) return v;
            }
            if (row.invoiceNumber) {
              const v = originalByInvoiceNum.get(row.invoiceNumber);
              if (v !== undefined) return v;
            }
            if (ordRef) {
              const v = originalByOrderRef.get(ordRef);
              if (v !== undefined) return v;
            }
            if (ordRefNoPrefix && ordRefNoPrefix !== ordRef) {
              const v = originalByOrderRef.get(ordRefNoPrefix);
              if (v !== undefined) return v;
            }
            if (shortRef) {
              const v = originalByOrderRef.get(shortRef);
              if (v !== undefined) return v;
            }
            if (shortRefNoPrefix && shortRefNoPrefix !== shortRef) {
              const v = originalByOrderRef.get(shortRefNoPrefix);
              if (v !== undefined) return v;
            }
            return undefined;
          };
          const lookupNet = (): number | undefined => {
            if (row.invoiceId) {
              const v = netByInvoiceId.get(row.invoiceId);
              if (v !== undefined) return v;
            }
            if (row.invoiceNumber) {
              const v = netByInvoiceNum.get(row.invoiceNumber);
              if (v !== undefined) return v;
            }
            if (ordRef) {
              const v = netByOrderRef.get(ordRef);
              if (v !== undefined) return v;
            }
            if (ordRefNoPrefix && ordRefNoPrefix !== ordRef) {
              const v = netByOrderRef.get(ordRefNoPrefix);
              if (v !== undefined) return v;
            }
            if (shortRef) {
              const v = netByOrderRef.get(shortRef);
              if (v !== undefined) return v;
            }
            if (shortRefNoPrefix && shortRefNoPrefix !== shortRef) {
              const v = netByOrderRef.get(shortRefNoPrefix);
              if (v !== undefined) return v;
            }
            return undefined;
          };
          const platformId: number | undefined = lookupId();
          const platformOriginal: number | undefined = lookupOriginal();
          const platformNet: number | undefined = lookupNet();
          const next: EndOfDayPackageOrderRow = { ...row };
          let rowChanged = false;
          if (platformName && platformName !== row.customerName) {
            next.customerName = platformName;
            rowChanged = true;
          }
          if (typeof platformId === 'number' && row[idField] !== platformId) {
            next[idField] = platformId;
            rowChanged = true;
            matchedCount++;
          }
          if (typeof platformOriginal === 'number' && row.originalTotal !== platformOriginal) {
            next.originalTotal = platformOriginal;
            rowChanged = true;
            matchedOriginalCount++;
          }
          // ✅ NET TOPLAM override: convertPlatformOrderToRow brut'u grandTotal'a
          //    yaziyordu (Getir UNPAID 795 vs gercek net 645). Burada platform
          //    spesifik net'i lookup edip duzeltiyoruz. PAID satirlarda
          //    row.grandTotal zaten QuickSaleReceipt'ten geliyor (net); platform
          //    net'iyle birebir eslesmesi gerekir, eslesmedigi durumda da
          //    platform tarafindaki "gercek" (cihaz/platform onayli) deger
          //    ekrana daha guvenilir cikar.
          if (typeof platformNet === 'number' && Math.abs(platformNet - (row.grandTotal ?? 0)) > 0.01) {
            next.grandTotal = platformNet;
            // subtotal de senkronize edilmeli: KDV hariç değer ayrı kaynak yok,
            // mevcut subtotal/grandTotal oranını koruyarak yaklaşık değer
            // veriyoruz (UI'da modal `subtotal`'ı yeniden hesaplamiyor).
            if (row.subtotal && row.grandTotal && row.grandTotal > 0) {
              next.subtotal = Math.round((row.subtotal / row.grandTotal) * platformNet * 100) / 100;
            } else {
              next.subtotal = platformNet;
            }
            // UNPAID satirda paidAmount=0, dokunmuyoruz. PAID/PARTIAL'da
            // paidAmount ayri (gercekte ne tahsil edildi); platform indirimi
            // tahsilati etkilemiyor.
            rowChanged = true;
            matchedNetCount++;
          }
          if (rowChanged) {
            return next;
          }
          return row;
        });

        // Geçici tanı log'u — Migros / YS / Trendyol için hangi satırlar eşleşemedi
        try {
          const samplePlatform = platformOrders[0] || null;
          const sampleRow = orders[0] || null;
          const unmatchedRows = updatedOrders.filter(r => !r[idField]).map(r => ({
            orderNumber: r.orderNumber,
            shortCode: r.shortCode,
            invoiceNumber: r.invoiceNumber,
            invoiceId: r.invoiceId,
          }));
          console.log(`[ENRICH ${idField}]`, {
            platformCount: platformOrders.length,
            rowCount: orders.length,
            matched: matchedCount,
            matchedOriginal: matchedOriginalCount,
            matchedNet: matchedNetCount,
            mapsSize: {
              customerByInvoiceId: customerByInvoiceId.size,
              customerByInvoiceNum: customerByInvoiceNum.size,
              customerByOrderRef: customerByOrderRef.size,
              idByInvoiceId: idByInvoiceId.size,
              idByInvoiceNum: idByInvoiceNum.size,
              idByOrderRef: idByOrderRef.size,
            },
            samplePlatformOrder: samplePlatform ? {
              keys: Object.keys(samplePlatform).slice(0, 30),
              id: samplePlatform.id ?? samplePlatform.Id,
              orderNumber: samplePlatform.orderNumber ?? samplePlatform.OrderNumber,
              invoiceNumber: samplePlatform.invoiceNumber ?? samplePlatform.InvoiceNumber,
              invoiceId: samplePlatform.invoiceId ?? samplePlatform.InvoiceId,
            } : null,
            sampleRow: sampleRow ? {
              orderNumber: sampleRow.orderNumber,
              shortCode: sampleRow.shortCode,
              invoiceNumber: sampleRow.invoiceNumber,
              invoiceId: sampleRow.invoiceId,
            } : null,
            unmatchedSample: unmatchedRows.slice(0, 5),
          });
        } catch (e) {
          console.error(`[ENRICH ${idField}] log hatası:`, e);
        }

        return updatedOrders;
      };

      // Enrichment'i merge'den sonra yapacağız (mergeUnpaidIntoData state'i override etmesin diye).
      // Ayrıca merge sırasında eklenen UNPAID/cancelled satırlar da platform listesinde varsa ID'lenir.
      
      console.log('✅ [SAĞLAMA] Sonuçlar:', Object.fromEntries(
        Object.entries(newReconciliation).map(([k, v]) => [k, { paid: v.paid.length, unpaid: v.unpaid.length, cancelled: v.cancelled.length, warnings: v.warnings.length }])
      ));
      
      setReconciliationData(newReconciliation);
      
      // Şube seçili raporda BranchId bilinmeyen ödenmemiş platform satırlarını rapora hiç katma (liste + yazdırma)
      const filterPlatformUnpaidBySelectedBranches = (unpaid: PlatformOrderSummary[]): PlatformOrderSummary[] => {
        if (isAllBranches || unpaid.length === 0) return unpaid;
        return unpaid.filter(u => {
          const bid = (u.branchId || '').trim();
          return bid !== '' && selectedBranches.includes(bid);
        });
      };
      
      // Platform siparişlerini tab verilerine birleştir
      // bucket: 'unpaid' | 'paid-no-receipt' | 'cancelled'
      // - unpaid: platform "PAID" demiyor + fatura yok → "Bilinmiyor"
      // - paid-no-receipt: platform "PAID" diyor ama bizde fatura yok → "Bilinmiyor (Platform Ödendi)"
      // - cancelled: platform iptal → "İptal"
      type MergeBucket = 'unpaid' | 'paid-no-receipt' | 'cancelled';
      const convertPlatformOrderToRow = (
        order: PlatformOrderSummary,
        bucket: MergeBucket
      ): EndOfDayPackageOrderRow => {
        const isCancelled = bucket === 'cancelled';
        return {
          id: `${bucket}-${order.platform}-${order.id}`,
          rowNumber: 0,
          orderNumber: order.orderNumber,
          shortCode: '',
          status: (isCancelled ? 'CANCELLED' : 'UNPAID') as TransactionStatus,
          orderStatus: isCancelled ? 'CANCELLED' : 'DELIVERED',
          subtotal: order.totalAmount,
          grandTotal: order.totalAmount,
          paidAmount: 0,
          paymentType: 'NONE' as PaymentType,
          paymentAccountName: isCancelled
            ? 'İptal'
            : bucket === 'paid-no-receipt'
              ? 'Bilinmiyor (Platform Ödendi)'
              : 'Bilinmiyor',
          cancelledTotal: isCancelled ? order.totalAmount : 0,
          createdAt: order.createdAt,
          paymentDate: null,
          customerName: order.customerName || '-',
          customerPhone: '',
          customerAddress: '',
          courierName: '',
          invoiceNumber: '',
          branchId: order.branchId,
          branchName: order.branchId ? getBranchName(order.branchId) : '-',
        };
      };

      // Geriye uyumluluk için isim koruyoruz; tüm bucket'ları (unpaid + paid-no-receipt + cancelled) birleştirir.
      const mergeUnpaidIntoData = (
        existing: EndOfDayPackageOrderRow[],
        unpaid: PlatformOrderSummary[],
        paidNoReceipt: PlatformOrderSummary[] = [],
        cancelled: PlatformOrderSummary[] = []
      ): EndOfDayPackageOrderRow[] => {
        if (unpaid.length === 0 && paidNoReceipt.length === 0 && cancelled.length === 0) return existing;

        const existingIds = new Set(existing.map(r => r.id));
        const existingInvoiceNumbers = new Set(existing.map(r => r.invoiceNumber).filter(Boolean));

        // invoiceNumber ile zaten ödenen satırda mevcutsa çıkar (çift-sayım önleme)
        const filterNotInReceipts = (list: PlatformOrderSummary[]) => list.filter(u => {
          if (u.invoiceNumber && existingInvoiceNumbers.has(u.invoiceNumber)) return false;
          if (u.invoiceId && existingInvoiceNumbers.has(u.invoiceId)) return false;
          return true;
        });

        const filteredUnpaid = filterNotInReceipts(unpaid);
        const filteredPaidNoReceipt = filterNotInReceipts(paidNoReceipt);
        const filteredCancelled = filterNotInReceipts(cancelled);

        if (filteredUnpaid.length === 0 && filteredPaidNoReceipt.length === 0 && filteredCancelled.length === 0) {
          return existing;
        }

        const newRows = [
          ...filteredUnpaid.map(o => convertPlatformOrderToRow(o, 'unpaid')),
          ...filteredPaidNoReceipt.map(o => convertPlatformOrderToRow(o, 'paid-no-receipt')),
          ...filteredCancelled.map(o => convertPlatformOrderToRow(o, 'cancelled')),
        ].filter(r => !existingIds.has(r.id));

        if (newRows.length === 0) return existing;
        const merged = [...existing, ...newRows];
        return merged.map((row, idx) => ({ ...row, rowNumber: idx + 1 }));
      };

      const mergedPackage = mergeUnpaidIntoData(
        processedPackageOrders,
        filterPlatformUnpaidBySelectedBranches(newReconciliation.package.unpaid)
      );
      const mergedGetir = mergeUnpaidIntoData(
        processedGetirOrders,
        filterPlatformUnpaidBySelectedBranches(newReconciliation.getir.unpaid)
      );
      const mergedMigros = mergeUnpaidIntoData(
        processedMigrosOrders,
        filterPlatformUnpaidBySelectedBranches(newReconciliation.migros.unpaid)
      );
      // Yemeksepeti: platform "PAID" diyor ama bizde fatura yok → "Bilinmiyor (Platform Ödendi)" satırı eklenir.
      // İptal edilen YS siparişleri de tab'a eklenir. Sadece YS için bu davranış aktif (Trendyol/Getir/Migros
      // ileride benzer sorun yaşarsa simetrik genişletilebilir).
      // 🔍 [TANI-YS] Bucket dağılımı ve merge sonucu
      const ysUnpaidAfterBranchFilter = filterPlatformUnpaidBySelectedBranches(newReconciliation.yemeksepeti.unpaid);
      const ysPaidAfterBranchFilter = filterPlatformUnpaidBySelectedBranches(newReconciliation.yemeksepeti.paid);
      const ysCancelledAfterBranchFilter = filterPlatformUnpaidBySelectedBranches(newReconciliation.yemeksepeti.cancelled);
      console.log('🔍 [TANI-YS] Bucket sube filtresi sonrasi dagilimi:', {
        unpaid: ysUnpaidAfterBranchFilter.length,
        paid_total: ysPaidAfterBranchFilter.length,
        cancelled: ysCancelledAfterBranchFilter.length,
        existing_processedYsOrders: processedYsOrders.length,
        existing_invoiceNumbers: processedYsOrders.map(r => r.invoiceNumber).filter(Boolean),
      });
      const mergedYs = mergeUnpaidIntoData(
        processedYsOrders,
        ysUnpaidAfterBranchFilter,
        ysPaidAfterBranchFilter,
        ysCancelledAfterBranchFilter
      );
      console.log('🔍 [TANI-YS] mergeUnpaidIntoData sonucu:', {
        processedYsOrders_count: processedYsOrders.length,
        unpaid_count: ysUnpaidAfterBranchFilter.length,
        paid_count: ysPaidAfterBranchFilter.length,
        cancelled_count: ysCancelledAfterBranchFilter.length,
        mergedYs_count: mergedYs.length,
      });
      // Trendyol ödenmemişleri diğer platformlarla (Getir/YS/Migros/Paket) simetrik şekilde filtrele.
      // `filterPlatformUnpaidBySelectedBranches` zaten BranchId boş veya seçili şubelerde olmayan
      // hayalet kayıtları eliyor — ayrıca `isAllBranches` özel-case gerekmiyor.
      const mergedTrendyol = mergeUnpaidIntoData(
        processedTrendyolOrders,
        filterPlatformUnpaidBySelectedBranches(newReconciliation.trendyol.unpaid)
      );

      // Merge sonrasında platform sipariş listesinden müşteri adını ve platform orderId'yi
      // row'lara propagate et — böylece state override edilse bile ID'ler korunur.
      // pkgPlatform burada `PromiseSettledResult` formatına sarılmadığı için
      // enrichRowsWithPlatformData'nın beklediği şekle çeviriyoruz.
      const pkgPlatformSettled: PromiseSettledResult<any> = pkgPlatform.status === 'fulfilled'
        ? { status: 'fulfilled', value: pkgPlatform.value }
        : { status: 'rejected', reason: (pkgPlatform as PromiseRejectedResult).reason };
      const enrichedPackage = enrichRowsWithPlatformData(mergedPackage, pkgPlatformSettled, 'PKT-', 'packageOrderId');
      const enrichedGetir = enrichRowsWithPlatformData(mergedGetir, getirPlatform, 'GTR-', 'getirOrderId');
      const enrichedMigros = enrichRowsWithPlatformData(mergedMigros, migrosPlatform, 'MGR-', 'migrosOrderId');
      const enrichedYs = enrichRowsWithPlatformData(mergedYs, ysPlatform, 'YS-', 'yemeksepetiOrderId');
      const enrichedTrendyol = enrichRowsWithPlatformData(mergedTrendyol, trendyolPlatform, 'TRD-', 'trendyolOrderId');

      // Yemeksepeti: son gelen sipariş en üstte olacak şekilde sırala (createdAt descending).
      // mergeUnpaidIntoData UNPAID/iptal satırlarını sona ekliyor; sıralamayı tek seferde
      // yeniden uyguluyoruz ve rowNumber'leri sıraya göre 1'den başlatıyoruz.
      const sortedYs = [...enrichedYs].sort((a, b) => {
        const ta = new Date(a.createdAt as Date | string).getTime();
        const tb = new Date(b.createdAt as Date | string).getTime();
        return (Number.isFinite(tb) ? tb : 0) - (Number.isFinite(ta) ? ta : 0);
      }).map((row, idx) => ({ ...row, rowNumber: idx + 1 }));

      // Paket için enrichedPackage'ı yaz — ID propagation cancel akışı dışındaki
      // ödenmiş paket siparişlerinde (PKT- prefix) detay modali için gereklidir.
      setPackageOrderData(enrichedPackage);
      setGetirOrderData(enrichedGetir);
      setMigrosOrderData(enrichedMigros);
      setYsOrderData(sortedYs);
      setTrendyolOrderData(enrichedTrendyol);

      // ⚠️ ÖZETI ENRICH SONRASI HER DURUMDA YENIDEN HESAPLA
      //    Ilk calculateCombinedSummary cagrisi (yukarida) `processedYsOrders` ile
      //    yapildigi icin `originalTotal` HENUZ DOLDURULMAMIS (mapping satirinda
      //    set edilmiyor, enrichRowsWithPlatformData ile platformdan getiriliyor).
      //    Bu yuzden "Yemek Platformlari Indirim Toplami" satiri 0 cikiyordu.
      //
      //    Coozum: enrichment'tan sonra (enrichedGetir/Migros/Ys/Trendyol +
      //    sortedYs) tek bir merkezi recalc yap. Bu, hasUnpaid false olsa bile
      //    indirim hesabini dogrulastirir (PAID satirlarinda da indirim olabilir).
      const hasUnpaid = newReconciliation.package.unpaid.length > 0
        || newReconciliation.getir.unpaid.length > 0
        || newReconciliation.migros.unpaid.length > 0
        || newReconciliation.yemeksepeti.unpaid.length > 0
        || newReconciliation.trendyol.unpaid.length > 0;

      const recalcSummaryRows = calculateCombinedSummary(
        restaurantSales, processedQuickSales, processedKioskData, processedQRMenuData,
        enrichedPackage, enrichedGetir, enrichedMigros, sortedYs, enrichedTrendyol
      );
      setSummaryTableRows(recalcSummaryRows);

      const recalcSummary = calculateCombinedSummaryOld(
        restaurantSales, processedQuickSales, processedKioskData, processedQRMenuData,
        enrichedPackage, enrichedGetir, enrichedMigros, sortedYs, enrichedTrendyol
      );
      setSummary(recalcSummary);

      if (hasUnpaid) {
        console.log('✅ [UNPAID] Ödenmemiş siparişler birleştirildi:', {
          package: newReconciliation.package.unpaid.length,
          getir: newReconciliation.getir.unpaid.length,
          migros: newReconciliation.migros.unpaid.length,
          yemeksepeti: newReconciliation.yemeksepeti.unpaid.length,
          trendyol: newReconciliation.trendyol.unpaid.length,
        });
      }
      console.log('🔍 [DEBUG] Platform indirim toplami (enrich sonrasi recalc):', {
        rows: recalcSummaryRows.length,
        platformDiscountRow: recalcSummaryRows.find(r => r.paymentType === 'Platform Discount') ?? '(yok — indirim 0 veya originalTotal eksik)',
      });

      setDataLoaded(true);
      setPage(0);
    } catch (err: any) {
      console.error('Veri çekme hatası:', err);
      setError(err.message || t('endOfDayReport.errors.dataLoadGeneric'));
    } finally {
      setLoading(false);
    }
  };
  
  // ✅ YENİ: Tüm kanalların birleşik özet tablosunu hesapla
  const calculateCombinedSummary = (
    restaurantSales: RestaurantCompletedSaleDto[],
    quickSaleData: EndOfDayQuickSaleRow[],
    kioskData: EndOfDayKioskRow[],
    qrMenuData: EndOfDayQRMenuRow[],
    packageOrderData: EndOfDayPackageOrderRow[] = [],
    getirOrderData: EndOfDayPackageOrderRow[] = [],
    migrosOrderData: EndOfDayPackageOrderRow[] = [],
    ysOrderData: EndOfDayPackageOrderRow[] = [],
    trendyolOrderData: EndOfDayPackageOrderRow[] = []
  ): SummaryTableRow[] => {
    const cashboxMap = new Map<string, number>();
    const bankMap = new Map<string, number>();
    let restaurantCancelledTotal = 0;
    let quickSaleCancelledTotal = 0;
    let otherCancelledTotal = 0;
    // PYK ön ödemeli (kart) satışlar. Bakiye yükleme (CARD_LOAD) bu rapora HİÇ girmez
    // (rapor kasa defterini değil, satış ödemelerini toplar), bu yüzden ön ödemeli satış
    // günün gerçek cirosudur. AYRI bir "Ön Ödemeli" satırı olarak gösterilir ve genel
    // toplama (grandTotal) DAHİL edilir (modal/fiş ile tutarlı).
    let prepaidTotal = 0;
    // Yemek platformlari (Getir / Migros / Yemeksepeti / Trendyol) icin
    // (originalTotal - grandTotal) farki = uygulanan indirim. Iptal edilen
    // siparisler hesaba katilmaz (kullanici tarafindan iptal edildigi icin).
    let platformDiscountTotal = 0;
    // Hızlı satış ekranında sepete uygulanan toplam indirim (bilgi amaçlı).
    // GENEL TOPLAM'a EKLENMEZ — grandTotal zaten indirim sonrası net tutardan oluşur.
    let quickSaleDiscountTotal = 0;

    // RESTORAN satışlarını işle (Payments dizisi öncelikli, fallback: PaymentDetailsJson)
    restaurantSales.forEach(sale => {
      const paymentMethod = sale.PaymentMethod?.toLowerCase() || '';
      const totalAmount = sale.TotalAmount || 0;

      if (paymentMethod === 'unpaid' || paymentMethod === 'cancelled' || paymentMethod === 'iptal') {
        restaurantCancelledTotal += totalAmount;
        return;
      }

      // Payments dizisi varsa yapısal veriyi kullan
      if (sale.Payments && sale.Payments.length > 0) {
        sale.Payments.forEach(payment => {
          const method = payment.PaymentMethod?.toLowerCase() || '';
          if (method === 'cash' || method === 'nakit') {
            const cashboxName = getCashboxNameById(payment.CashboxId) || payment.CashboxName || 'Kasa';
            cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + payment.Amount);
          } else if (method === 'pos' || method === 'credit_card' || method === 'kredi kartı') {
            let bankName = getBankNameById(payment.BankAccountId, payment.BankSubAccountId) || payment.BankAccountName || 'POS';
            if (payment.BankSubAccountName && !bankName.includes(payment.BankSubAccountName)) {
              bankName = `${payment.BankAccountName} - ${payment.BankSubAccountName}`;
            }
            bankMap.set(bankName, (bankMap.get(bankName) || 0) + payment.Amount);
          } else if (method === 'open_account' || method === 'açık hesap') {
            cashboxMap.set('Açık Hesap', (cashboxMap.get('Açık Hesap') || 0) + payment.Amount);
          } else {
            cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + payment.Amount);
          }
        });
      } else {
        // Fallback: eski PaymentDetailsJson mantığı
        let paymentDetails: any = null;
        if (sale.PaymentDetailsJson) {
          try {
            paymentDetails = JSON.parse(sale.PaymentDetailsJson);
          } catch (e) {}
        }

        if (paymentMethod === 'nakit' || paymentMethod === 'cash') {
          const cashboxName = getCashboxNameById(paymentDetails?.cashboxId) || paymentDetails?.cashboxName || 'Kasa';
          cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + totalAmount);
        } else if (paymentMethod === 'pos' || paymentMethod === 'kredi kartı' || paymentMethod === 'credit_card') {
          const bankName = getBankNameById(paymentDetails?.bankAccountId, paymentDetails?.bankSubAccountId) || paymentDetails?.bankAccountName || paymentDetails?.posLabel || 'POS';
          bankMap.set(bankName, (bankMap.get(bankName) || 0) + totalAmount);
        } else if (paymentMethod.includes('parçalı') || paymentMethod === 'partial' || paymentMethod.includes('karma') || paymentMethod.includes('mixed')) {
          if (paymentDetails) {
            if (paymentDetails.cashAmount && paymentDetails.cashAmount > 0) {
              const cashboxName = getCashboxNameById(paymentDetails.cashboxId) || paymentDetails.cashboxName || 'Kasa';
              cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + paymentDetails.cashAmount);
            }
            if (paymentDetails.posAmount && paymentDetails.posAmount > 0) {
              const bankName = getBankNameById(paymentDetails.bankAccountId, paymentDetails.bankSubAccountId) || paymentDetails.bankAccountName || paymentDetails.posLabel || 'POS';
              bankMap.set(bankName, (bankMap.get(bankName) || 0) + paymentDetails.posAmount);
            }
          } else {
            cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + totalAmount);
          }
        } else if (paymentMethod === 'açık hesap' || paymentMethod === 'open_account') {
          cashboxMap.set('Açık Hesap', (cashboxMap.get('Açık Hesap') || 0) + totalAmount);
        } else {
          cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + totalAmount);
        }
      }
    });

    // ✅ HIZLI SATIŞ - Gerçek kasa/banka isimleriyle hesapla (alt hesap dahil)
    quickSaleData.forEach(row => {
      if (row.status === 'CANCELLED') {
        quickSaleCancelledTotal += row.grandTotal || 0;
        return;
      }

      // Bilgi amaçlı: iptal olmayan fişlerde uygulanan indirimi topla
      quickSaleDiscountTotal += row.discount || 0;
      
      // payments dizisi varsa gerçek kasa/banka isimlerini kullan
      if (row.payments && row.payments.length > 0) {
        row.payments.forEach(payment => {
          const method = payment.paymentMethod?.toLowerCase() || '';
          const isOnlineMethod = method === 'online_online' || (method.startsWith('online_') && method.endsWith('_online'));
          
          if (method === 'prepaid') {
            // Ön ödemeli: kasa/banka satırına değil ayrı "Ön Ödemeli" satırına yazılır;
            // genel toplama (grandTotal) prepaidTotal üzerinden dahil edilir.
            prepaidTotal += payment.amount;
          } else if (method === 'open_account') {
            cashboxMap.set('Açık Hesap', (cashboxMap.get('Açık Hesap') || 0) + payment.amount);
          } else if (isOnlineMethod) {
            const platformName = payment.paymentProviderName || 'Online';
            cashboxMap.set(`${platformName} (Online)`, (cashboxMap.get(`${platformName} (Online)`) || 0) + payment.amount);
          } else if (method === 'cash' || method === 'nakit' || method === 'online_cash') {
            const cashboxName = payment.cashboxName || 'Kasa';
            cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + payment.amount);
          } else if (method === 'pos' || method === 'credit_card' || method === 'online_pos') {
            let bankName = payment.bankAccountName || 'POS';
            if (payment.bankSubAccountName) {
              bankName = `${payment.bankAccountName} - ${payment.bankSubAccountName}`;
            }
            bankMap.set(bankName, (bankMap.get(bankName) || 0) + payment.amount);
          } else if (payment.cashboxName) {
            const cashboxName = payment.cashboxName;
            cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + payment.amount);
          } else if (payment.bankAccountName) {
            let bankName = payment.bankAccountName;
            if (payment.bankSubAccountName) {
              bankName = `${payment.bankAccountName} - ${payment.bankSubAccountName}`;
            }
            bankMap.set(bankName, (bankMap.get(bankName) || 0) + payment.amount);
          } else {
            cashboxMap.set('Diğer Ödemeler', (cashboxMap.get('Diğer Ödemeler') || 0) + payment.amount);
          }
        });
      } else {
        // Fallback: payments yoksa eski yöntem
        if (row.paymentType === 'PREPAID') {
          prepaidTotal += (row.paidAmount || 0);
        } else if (row.paymentType === 'OPEN_ACCOUNT') {
          cashboxMap.set('Açık Hesap', (cashboxMap.get('Açık Hesap') || 0) + (row.paidAmount || 0));
        } else if (row.paymentType === 'ONLINE') {
          const platformName = row.paymentProviderName || 'Online';
          cashboxMap.set(`${platformName} (Online)`, (cashboxMap.get(`${platformName} (Online)`) || 0) + (row.paidAmount || 0));
        } else if (row.paymentType === 'CASH') {
          const cashboxName = row.paymentAccountName !== '-' ? row.paymentAccountName : 'Kasa';
          cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + (row.paidAmount || 0));
        } else if (row.paymentType === 'POS') {
          const bankName = row.paymentAccountName !== '-' ? row.paymentAccountName : 'POS';
          bankMap.set(bankName, (bankMap.get(bankName) || 0) + (row.paidAmount || 0));
        } else if (row.paymentType === 'MIXED') {
          const half = (row.paidAmount || 0) / 2;
          cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + half);
          bankMap.set('POS', (bankMap.get('POS') || 0) + half);
        } else if (row.paymentAccountName && row.paymentAccountName !== '-') {
          cashboxMap.set(row.paymentAccountName, (cashboxMap.get(row.paymentAccountName) || 0) + (row.paidAmount || 0));
        }
      }
    });

    // ✅ KIOSK VERİLERİNİ AYRI İŞLE (Kiosk sadece POS ödeme alır)
    kioskData.forEach(row => {
      if (row.status === 'CANCELLED') {
        otherCancelledTotal += row.grandTotal || 0;
        return;
      }
      
      // Detaylı ödeme bilgileri varsa banka adını kullan
      if (row.payments && row.payments.length > 0) {
        row.payments.forEach(payment => {
          const amount = payment.amount || 0;
          let bankName = payment.bankAccountName || 'POS';
          if (payment.bankSubAccountName) {
            bankName = `${payment.bankAccountName} - ${payment.bankSubAccountName}`;
          }
          bankMap.set(`Kiosk - ${bankName}`, (bankMap.get(`Kiosk - ${bankName}`) || 0) + amount);
        });
      } else {
        // Fallback: payments yoksa paymentAccountName veya genel "POS" kullan
        const bankName = row.paymentAccountName && row.paymentAccountName !== '-' ? row.paymentAccountName : 'POS';
        bankMap.set(`Kiosk - ${bankName}`, (bankMap.get(`Kiosk - ${bankName}`) || 0) + (row.paidAmount || 0));
      }
    });

    // QR Menü için (şimdilik mock veri)
    const processGenericData = (data: any[]) => {
      data.forEach(row => {
        if (row.status === 'CANCELLED') {
          otherCancelledTotal += row.grandTotal || 0;
        } else if (row.paymentType === 'CASH') {
          cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + (row.paidAmount || 0));
        } else if (row.paymentType === 'POS') {
          bankMap.set('POS', (bankMap.get('POS') || 0) + (row.paidAmount || 0));
        } else if (row.paymentType === 'MIXED') {
          const half = (row.paidAmount || 0) / 2;
          cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + half);
          bankMap.set('POS', (bankMap.get('POS') || 0) + half);
        }
      });
    };
    processGenericData(qrMenuData);

    const processPlatformOrders = (
      rows: EndOfDayPackageOrderRow[],
      label: string,
      isFoodPlatform: boolean = false,
    ) => {
      rows.forEach(row => {
        if (row.status === 'CANCELLED') {
          otherCancelledTotal += row.grandTotal || 0;
          return;
        }
        // Yemek platformu indirimi: originalTotal (indirim oncesi sepet) ile
        // grandTotal (indirim sonrasi net) farki. UNPAID/PARTIAL durumlarinda
        // bile uygulanmis indirim mevcut oldugu icin bu kontrol status'ten
        // bagimsiz yapilir (CANCELLED haric — yukarida zaten erken donmustuk).
        if (isFoodPlatform) {
          const original = Number(row.originalTotal ?? 0);
          const net = Number(row.grandTotal ?? 0);
          const discount = original - net;
          if (discount > 0) platformDiscountTotal += discount;
        }
        if (row.status === 'UNPAID') {
          const amount = row.grandTotal || 0;
          if (amount <= 0) return;
          const key = `${label} - Ödenmemiş (Bilinmiyor)`;
          cashboxMap.set(key, (cashboxMap.get(key) || 0) + amount);
          return;
        }
        if (row.status !== 'PAID' && row.status !== 'PARTIAL') return;
        
        const amount = row.paidAmount || row.grandTotal || 0;
        if (amount <= 0) return;

        if (row.paymentType === 'ONLINE') {
          const providerName = row.paymentProviderName || label;
          cashboxMap.set(`${providerName} (Online)`, (cashboxMap.get(`${providerName} (Online)`) || 0) + amount);
        } else if (row.cashAmount && row.cashAmount > 0) {
          cashboxMap.set(`${label} - Nakit`, (cashboxMap.get(`${label} - Nakit`) || 0) + row.cashAmount);
          const remaining = amount - row.cashAmount;
          if (row.posAmount && row.posAmount > 0) {
            bankMap.set(`${label} - POS`, (bankMap.get(`${label} - POS`) || 0) + row.posAmount);
          } else if (remaining > 0) {
            bankMap.set(`${label} - POS`, (bankMap.get(`${label} - POS`) || 0) + remaining);
          }
        } else if (row.posAmount && row.posAmount > 0) {
          bankMap.set(`${label} - POS`, (bankMap.get(`${label} - POS`) || 0) + row.posAmount);
        } else if (row.paymentType === 'CASH') {
          cashboxMap.set(`${label} - Nakit`, (cashboxMap.get(`${label} - Nakit`) || 0) + amount);
        } else if (row.paymentType === 'POS') {
          bankMap.set(`${label} - POS`, (bankMap.get(`${label} - POS`) || 0) + amount);
        } else if (row.paymentType === 'OTHER' && row.otherAmount) {
          const providerName = row.paymentProviderName || 'Diğer';
          cashboxMap.set(`${label} - ${providerName}`, (cashboxMap.get(`${label} - ${providerName}`) || 0) + row.otherAmount);
        } else {
          cashboxMap.set(`${label} (Online)`, (cashboxMap.get(`${label} (Online)`) || 0) + amount);
        }
      });
    };

    // Paket sipariş "yemek platformu" sayilmiyor (genel paket akisi);
    // sadece Getir / Migros / Yemeksepeti / Trendyol indirimleri toplanir.
    processPlatformOrders(packageOrderData, 'Paket', false);
    processPlatformOrders(getirOrderData, 'Getir', true);
    processPlatformOrders(migrosOrderData, 'Migros', true);
    processPlatformOrders(ysOrderData, 'Y.Sepeti', true);
    processPlatformOrders(trendyolOrderData, 'Trendyol', true);

    // Sonuç dizisini oluştur
    const rows: SummaryTableRow[] = [];
    let grandTotal = 0;

    cashboxMap.forEach((amount, cashboxName) => {
      const isOnline = cashboxName.includes('(Online)');
      const isUnpaid = cashboxName.includes('Unpaid (Unknown)');
      const isOpenAccount = cashboxName === 'Open Account';
      rows.push({
        paymentType: isOpenAccount ? 'Open Account' : isUnpaid ? 'Unknown' : isOnline ? 'Online' : 'Cash',
        accountName: cashboxName,
        amount,
      });
      grandTotal += amount;
    });

    bankMap.forEach((amount, bankName) => {
      rows.push({ paymentType: 'POS', accountName: bankName, amount });
      grandTotal += amount;
    });

    if (restaurantCancelledTotal > 0) {
      rows.push({ paymentType: 'Restaurant Cancelled', accountName: '-', amount: restaurantCancelledTotal });
    }
    if (quickSaleCancelledTotal > 0) {
      rows.push({ paymentType: 'Quick Sale Cancelled', accountName: '-', amount: quickSaleCancelledTotal });
    }
    if (otherCancelledTotal > 0) {
      rows.push({ paymentType: 'Other Cancelled', accountName: '-', amount: otherCancelledTotal });
    }

    // PYK ön ödemeli satışlar: ayrı "Ön Ödemeli" satırı olarak gösterilir ve genel
    // toplama (grandTotal) DAHİL edilir. Bakiye yükleme parası bu rapora hiç girmediği
    // için, ön ödemeli satış genel toplamda sayılmazsa o ciro hiçbir yerde görünmez.
    if (prepaidTotal > 0) {
      rows.push({ paymentType: 'Prepaid', accountName: '-', amount: prepaidTotal });
      grandTotal += prepaidTotal;
    }

    // Yemek platformlari (Getir / Migros / Yemeksepeti / Trendyol) icin
    // uygulanan toplam indirim. GENEL TOPLAM satirinin BIR USTUNE yerlestirilir;
    // bilgi amacli — `grandTotal`'a EKLENMEZ (cunku grandTotal zaten net,
    // indirim sonrasi tutardan olusuyor).
    if (platformDiscountTotal > 0) {
      rows.push({
        paymentType: 'Platform Discount',
        accountName: '-',
        amount: platformDiscountTotal,
      });
    }

    // Hızlı satış indirimi: GENEL TOPLAM'ın bir üstüne yerleştirilir; bilgi amaçlı —
    // `grandTotal`'a EKLENMEZ (grandTotal zaten indirim sonrası net tutardır).
    if (quickSaleDiscountTotal > 0) {
      rows.push({
        paymentType: 'Quick Sale Discount',
        accountName: '-',
        amount: quickSaleDiscountTotal,
      });
    }

    rows.push({ paymentType: 'GRAND TOTAL', accountName: '', amount: grandTotal, isTotal: true });

    return rows;
  };

  // ✅ YENİ: Eski format summary hesapla (gün sonu işlemi için)
  const calculateCombinedSummaryOld = (
    restaurantSales: RestaurantCompletedSaleDto[],
    quickSaleData: EndOfDayQuickSaleRow[],
    kioskData: EndOfDayKioskRow[],
    qrMenuData: EndOfDayQRMenuRow[],
    packageOrderData: EndOfDayPackageOrderRow[] = [],
    getirOrderData: EndOfDayPackageOrderRow[] = [],
    migrosOrderData: EndOfDayPackageOrderRow[] = [],
    ysOrderData: EndOfDayPackageOrderRow[] = [],
    trendyolOrderData: EndOfDayPackageOrderRow[] = []
  ): EndOfDaySummary => {
    const summary: EndOfDaySummary = {
      totalAmount: 0,
      totalCount: 0,
      cashAmount: 0,
      cashCount: 0,
      posAmount: 0,
      posCount: 0,
      otherAmount: 0,
      otherCount: 0,
      cancelledAmount: 0,
      cancelledCount: 0,
      mixedAmount: 0,
      mixedCount: 0,
      openAccountAmount: 0,
      openAccountCount: 0,
      posRefundAmount: 0,
      posRefundCount: 0,
      prepaidAmount: 0,
      prepaidCount: 0,
    };

    // Restoran satışları
    restaurantSales.forEach(sale => {
      const paymentMethod = sale.PaymentMethod?.toLowerCase() || '';
      const totalAmount = sale.TotalAmount || 0;
      
      if (paymentMethod === 'unpaid' || paymentMethod === 'cancelled' || paymentMethod === 'iptal') {
        summary.cancelledAmount += totalAmount;
        summary.cancelledCount += 1;
      } else {
        summary.totalAmount += totalAmount;
        summary.totalCount += 1;
        
        if (paymentMethod === 'nakit' || paymentMethod === 'cash') {
          summary.cashAmount += totalAmount;
          summary.cashCount += 1;
        } else if (paymentMethod === 'pos' || paymentMethod === 'kredi kartı' || paymentMethod === 'credit_card') {
          summary.posAmount += totalAmount;
          summary.posCount += 1;
        } else if (paymentMethod.includes('parçalı') || paymentMethod === 'partial' || paymentMethod.includes('karma') || paymentMethod.includes('mixed')) {
          summary.mixedAmount += totalAmount;
          summary.mixedCount += 1;
        } else if (paymentMethod === 'açık hesap' || paymentMethod === 'open_account') {
          summary.openAccountAmount += totalAmount;
          summary.openAccountCount += 1;
        } else {
          summary.otherAmount += totalAmount;
          summary.otherCount += 1;
        }
      }
    });

    // Diğer kanallar - Hızlı satış için payments dizisini kullan
    quickSaleData.forEach(row => {
      if (row.isRefund && row.paidAmount < 0) {
        summary.posRefundAmount += Math.abs(row.paidAmount);
        summary.posRefundCount += 1;
        summary.totalAmount += row.paidAmount;
        return;
      }
      if (row.status === 'CANCELLED') {
        summary.cancelledAmount += row.grandTotal || 0;
        summary.cancelledCount += 1;
      } else {
        summary.totalAmount += row.paidAmount || 0;
        summary.totalCount += 1;
        
        // payments dizisinden ödeme türlerini hesapla
        if (row.payments && row.payments.length > 0) {
          row.payments.forEach(payment => {
            const method = payment.paymentMethod?.toLowerCase() || '';
            if (method === 'prepaid') {
              summary.prepaidAmount += payment.amount || 0;
            } else if (method === 'open_account') {
              summary.openAccountAmount += payment.amount || 0;
            } else if (method === 'online_online' || (method.startsWith('online_') && method.endsWith('_online'))) {
              summary.otherAmount += payment.amount || 0;
            } else if (method === 'cash' || method === 'nakit' || method === 'online_cash') {
              summary.cashAmount += payment.amount || 0;
            } else if (method === 'pos' || method === 'credit_card' || method === 'online_pos') {
              summary.posAmount += payment.amount || 0;
            } else if (method) {
              summary.otherAmount += payment.amount || 0;
            }
          });
          // Karma ödeme sayısını güncelle
          if (row.payments.length > 1) {
            summary.mixedCount += 1;
          } else {
            const method = row.payments[0]?.paymentMethod?.toLowerCase() || '';
            if (method === 'prepaid') {
              summary.prepaidCount += 1;
            } else if (method === 'open_account') {
              summary.openAccountCount += 1;
            } else if (method === 'online_online' || (method.startsWith('online_') && method.endsWith('_online'))) {
              summary.otherCount += 1;
            } else if (method === 'cash' || method === 'nakit' || method === 'online_cash') {
              summary.cashCount += 1;
            } else if (method === 'pos' || method === 'credit_card' || method === 'online_pos') {
              summary.posCount += 1;
            } else {
              summary.otherCount += 1;
            }
          }
        } else {
          // Fallback: payments yoksa eski yöntem
          if (row.paymentType === 'PREPAID') {
            summary.prepaidAmount += row.paidAmount || 0;
            summary.prepaidCount += 1;
          } else if (row.paymentType === 'OPEN_ACCOUNT') {
            summary.openAccountAmount += row.paidAmount || 0;
            summary.openAccountCount += 1;
          } else if (row.paymentType === 'ONLINE') {
            summary.otherAmount += row.paidAmount || 0;
            summary.otherCount += 1;
          } else if (row.paymentType === 'CASH') {
            summary.cashAmount += row.paidAmount || 0;
            summary.cashCount += 1;
          } else if (row.paymentType === 'POS') {
            summary.posAmount += row.paidAmount || 0;
            summary.posCount += 1;
          } else if (row.paymentType === 'MIXED') {
            summary.mixedAmount += row.paidAmount || 0;
            summary.mixedCount += 1;
          }
        }
      }
    });

    const processGenericSimple = (data: any[]) => {
      data.forEach(row => {
        if (row.status === 'CANCELLED') {
          summary.cancelledAmount += row.grandTotal || 0;
          summary.cancelledCount += 1;
        } else {
          const amount = row.paidAmount || 0;
          summary.totalAmount += amount;
          summary.totalCount += 1;
          if (row.paymentType === 'OPEN_ACCOUNT') { summary.openAccountAmount += amount; summary.openAccountCount += 1; }
          else if (row.paymentType === 'ONLINE') { summary.otherAmount += amount; summary.otherCount += 1; }
          else if (row.paymentType === 'CASH') { summary.cashAmount += amount; summary.cashCount += 1; }
          else if (row.paymentType === 'POS') { summary.posAmount += amount; summary.posCount += 1; }
          else if (row.paymentType === 'MIXED') { summary.mixedAmount += amount; summary.mixedCount += 1; }
          else if (row.paymentType === 'OTHER') { summary.otherAmount += amount; summary.otherCount += 1; }
        }
      });
    };

    processGenericSimple(kioskData);
    processGenericSimple(qrMenuData);

    const processPlatformOrdersOld = (data: EndOfDayPackageOrderRow[]) => {
      data.forEach(row => {
        if (row.status === 'CANCELLED') {
          summary.cancelledAmount += row.grandTotal || 0;
          summary.cancelledCount += 1;
        } else if (row.status === 'UNPAID') {
          const amount = row.grandTotal || 0;
          summary.totalAmount += amount;
          summary.totalCount += 1;
          summary.otherAmount += amount;
          summary.otherCount += 1;
        } else if (row.status === 'PAID' || row.status === 'PARTIAL') {
          const amount = row.paidAmount || 0;
          summary.totalAmount += amount;
          summary.totalCount += 1;
          if (row.paymentType === 'ONLINE') { summary.otherAmount += amount; summary.otherCount += 1; }
          else if (row.paymentType === 'CASH') { summary.cashAmount += amount; summary.cashCount += 1; }
          else if (row.paymentType === 'POS') { summary.posAmount += amount; summary.posCount += 1; }
          else if (row.paymentType === 'MIXED') { summary.mixedAmount += amount; summary.mixedCount += 1; }
          else if (row.paymentType === 'OTHER') { summary.otherAmount += amount; summary.otherCount += 1; }
          else { summary.otherAmount += amount; summary.otherCount += 1; }
        }
      });
    };
    processPlatformOrdersOld(packageOrderData);
    processPlatformOrdersOld(getirOrderData);
    processPlatformOrdersOld(migrosOrderData);
    processPlatformOrdersOld(ysOrderData);
    processPlatformOrdersOld(trendyolOrderData);

    return summary;
  };

  // ✅ YENİ: Özet tablosu satır tipi
  interface SummaryTableRow {
    paymentType: string; // "Nakit" | "POS" | "İptal"
    accountName: string; // Kasa veya Banka adı
    amount: number;
    isTotal?: boolean; // GENEL TOPLAM satırı mı?
  }

  // ✅ YENİ: Özet tablosu state'i
  const [summaryTableRows, setSummaryTableRows] = useState<SummaryTableRow[]>([]);

  const getSummaryPaymentTypeLabel = useCallback((paymentType: string): string => {
    switch (paymentType) {
      case 'Cash':
        return t('endOfDayReport.paymentTypes.cash');
      case 'POS':
        return t('endOfDayReport.paymentTypes.pos');
      case 'Open Account':
        return t('endOfDayReport.paymentTypes.openAccount');
      case 'Online':
        return t('endOfDayReport.paymentTypes.online');
      case 'Unknown':
        return t('endOfDayReport.paymentTypes.unknown');
      case 'Restaurant Cancelled':
        return t('endOfDayReport.paymentTypes.restaurantCancelled');
      case 'Quick Sale Cancelled':
        return t('endOfDayReport.paymentTypes.quickSaleCancelled');
      case 'Other Cancelled':
        return t('endOfDayReport.paymentTypes.otherCancelled');
      case 'Platform Discount':
        return t('endOfDayReport.paymentTypes.platformDiscount');
      case 'Quick Sale Discount':
        return t('endOfDayReport.paymentTypes.quickSaleDiscount');
      case 'Prepaid':
        return t('endOfDayReport.paymentTypes.prepaid');
      case 'GRAND TOTAL':
        return t('endOfDayReport.paymentTypes.grandTotal');
      default:
        return paymentType;
    }
  }, [t]);

  // ✅ YENİ: Kasa ve Banka lookup listeleri
  const [cashboxList, setCashboxList] = useState<CashboxLookup[]>([]);
  const [bankAccountList, setBankAccountList] = useState<BankAccountLookup[]>([]);

  // ✅ YENİ: ID'den kasa adını bul
  const getCashboxNameById = (cashboxId: string | number | null | undefined): string | null => {
    if (!cashboxId) return null;
    const idStr = cashboxId.toString();
    const found = cashboxList.find(c => c.id === idStr);
    return found?.name || null;
  };

  // ✅ YENİ: ID'den banka adını bul (alt hesap dahil)
  const getBankNameById = (bankAccountId: string | number | null | undefined, subAccountId?: string | number | null): string | null => {
    if (!bankAccountId) return null;
    const idStr = bankAccountId.toString();
    const found = bankAccountList.find(b => b.id === idStr);
    if (!found) return null;
    
    // Alt hesap varsa alt hesap adını kullan
    if (subAccountId && found.subAccounts) {
      const subIdStr = subAccountId.toString();
      const subAccount = found.subAccounts[subIdStr];
      if (subAccount) {
        return `${found.bankName} - ${subAccount.accountName}`;
      }
    }
    
    // Hesap numarası varsa ekle
    if (found.accountNumber) {
      return `${found.bankName} - ${found.accountNumber}`;
    }
    return found.bankName;
  };

  // ✅ YENİ: Restoran satışlarından detaylı özet tablosu hesapla
  const calculateDetailedSummaryFromRestaurantSales = (sales: RestaurantCompletedSaleDto[]): SummaryTableRow[] => {
    // Kasa ve Banka bazında gruplama için map
    const cashboxMap = new Map<string, number>(); // cashboxName -> toplam tutar
    const bankMap = new Map<string, number>(); // bankAccountName -> toplam tutar
    let cancelledTotal = 0;

    sales.forEach(sale => {
      const paymentMethod = sale.PaymentMethod?.toLowerCase() || '';
      const totalAmount = sale.TotalAmount || 0;

      if (paymentMethod === 'unpaid' || paymentMethod === 'cancelled' || paymentMethod === 'iptal') {
        cancelledTotal += totalAmount;
        return;
      }

      // Payments dizisi varsa yapısal veriyi kullan
      if (sale.Payments && sale.Payments.length > 0) {
        sale.Payments.forEach(payment => {
          const method = payment.PaymentMethod?.toLowerCase() || '';
          if (method === 'cash' || method === 'nakit') {
            const cashboxName = getCashboxNameById(payment.CashboxId) || payment.CashboxName || 'Kasa';
            cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + payment.Amount);
          } else if (method === 'pos' || method === 'credit_card' || method === 'kredi kartı') {
            let bankName = getBankNameById(payment.BankAccountId, payment.BankSubAccountId) || payment.BankAccountName || 'POS';
            if (payment.BankSubAccountName && !bankName.includes(payment.BankSubAccountName)) {
              bankName = `${payment.BankAccountName} - ${payment.BankSubAccountName}`;
            }
            bankMap.set(bankName, (bankMap.get(bankName) || 0) + payment.Amount);
          } else if (method === 'open_account' || method === 'açık hesap') {
            cashboxMap.set('Açık Hesap', (cashboxMap.get('Açık Hesap') || 0) + payment.Amount);
          } else {
            cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + payment.Amount);
          }
        });
      } else {
        // Fallback: eski PaymentDetailsJson mantığı
        let paymentDetails: any = null;
        if (sale.PaymentDetailsJson) {
          try {
            paymentDetails = JSON.parse(sale.PaymentDetailsJson);
          } catch (e) {
            console.warn('PaymentDetailsJson parse hatası:', e);
          }
        }

        if (paymentMethod === 'nakit' || paymentMethod === 'cash') {
          const cashboxName = getCashboxNameById(paymentDetails?.cashboxId) || paymentDetails?.cashboxName || 'Kasa';
          cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + totalAmount);
        } else if (paymentMethod === 'pos' || paymentMethod === 'kredi kartı' || paymentMethod === 'credit_card') {
          const bankName = getBankNameById(paymentDetails?.bankAccountId, paymentDetails?.bankSubAccountId) || paymentDetails?.bankAccountName || paymentDetails?.posLabel || 'POS';
          bankMap.set(bankName, (bankMap.get(bankName) || 0) + totalAmount);
        } else if (paymentMethod.includes('parçalı') || paymentMethod === 'partial' || paymentMethod.includes('karma') || paymentMethod.includes('mixed')) {
          if (paymentDetails) {
            if (paymentDetails.cashAmount && paymentDetails.cashAmount > 0) {
              const cashboxName = getCashboxNameById(paymentDetails.cashboxId) || paymentDetails.cashboxName || 'Kasa';
              cashboxMap.set(cashboxName, (cashboxMap.get(cashboxName) || 0) + paymentDetails.cashAmount);
            }
            if (paymentDetails.posAmount && paymentDetails.posAmount > 0) {
              const bankName = getBankNameById(paymentDetails.bankAccountId, paymentDetails.bankSubAccountId) || paymentDetails.bankAccountName || paymentDetails.posLabel || 'POS';
              bankMap.set(bankName, (bankMap.get(bankName) || 0) + paymentDetails.posAmount);
            }
          } else {
            cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + totalAmount);
          }
        } else if (paymentMethod === 'açık hesap' || paymentMethod === 'open_account') {
          cashboxMap.set('Açık Hesap', (cashboxMap.get('Açık Hesap') || 0) + totalAmount);
        } else {
          cashboxMap.set('Kasa', (cashboxMap.get('Kasa') || 0) + totalAmount);
        }
      }
    });

    const rows: SummaryTableRow[] = [];
    let grandTotal = 0;

    cashboxMap.forEach((amount, cashboxName) => {
      const isOpenAccount = cashboxName === 'Open Account';
      rows.push({
        paymentType: isOpenAccount ? 'Open Account' : 'Cash',
        accountName: cashboxName,
        amount,
      });
      grandTotal += amount;
    });

    bankMap.forEach((amount, bankName) => {
      rows.push({
        paymentType: 'POS',
        accountName: bankName,
        amount,
      });
      grandTotal += amount;
    });

    // İptal satırı (eğer varsa)
    if (cancelledTotal > 0) {
      rows.push({
        paymentType: 'Restaurant Cancelled',
        accountName: '-',
        amount: cancelledTotal,
      });
    }

    // GENEL TOPLAM satırı
    rows.push({
      paymentType: 'GRAND TOTAL',
      accountName: '',
      amount: grandTotal,
      isTotal: true,
    });

    return rows;
  };

  // ✅ YENİ: Restoran satışlarından özet hesapla (mevcut kartlar için - yedek)
  const calculateSummaryFromRestaurantSales = (sales: RestaurantCompletedSaleDto[]): EndOfDaySummary => {
    return sales.reduce(
      (acc, sale) => {
        const paymentMethod = sale.PaymentMethod?.toLowerCase() || '';
        const totalAmount = sale.TotalAmount || 0;
        
        // İptal kontrol
        if (paymentMethod === 'unpaid' || paymentMethod === 'cancelled' || paymentMethod === 'iptal') {
          acc.cancelledAmount += totalAmount;
          acc.cancelledCount += 1;
        } else {
          // Ödeme alınmış
          acc.totalAmount += totalAmount;
          acc.totalCount += 1;
          
          // Ödeme türüne göre
          if (paymentMethod === 'nakit' || paymentMethod === 'cash') {
            acc.cashAmount += totalAmount;
            acc.cashCount += 1;
          } else if (paymentMethod === 'pos' || paymentMethod === 'kredi kartı' || paymentMethod === 'credit_card') {
            acc.posAmount += totalAmount;
            acc.posCount += 1;
          } else if (paymentMethod.includes('parçalı') || paymentMethod === 'partial' || paymentMethod.includes('karma')) {
            acc.mixedAmount += totalAmount;
            acc.mixedCount += 1;
          } else if (paymentMethod === 'açık hesap' || paymentMethod === 'open_account') {
            acc.openAccountAmount += totalAmount;
            acc.openAccountCount += 1;
          } else {
            acc.otherAmount += totalAmount;
            acc.otherCount += 1;
          }
        }
        
        return acc;
      },
      {
        totalAmount: 0,
        totalCount: 0,
        cashAmount: 0,
        cashCount: 0,
        posAmount: 0,
        posCount: 0,
        otherAmount: 0,
        otherCount: 0,
        cancelledAmount: 0,
        cancelledCount: 0,
        mixedAmount: 0,
        mixedCount: 0,
        openAccountAmount: 0,
        openAccountCount: 0,
        posRefundAmount: 0,
        posRefundCount: 0,
        prepaidAmount: 0,
        prepaidCount: 0,
      }
    );
  };

  // ✅ YENİ: Gün sonu yapma işlemi - Önce ön onay modalını göster
  const handleEndOfDay = () => {
    if (!companyId || !startDate || !endDate) {
      setError('Şirket bilgisi veya tarih aralığı eksik.');
      return;
    }
    
    // ✅ Önce ön onay modalını göster (tarih, şube, toplam bilgileri ile)
    setPreConfirmDialogOpen(true);
  };
  
  // ✅ YENİ: Ön onay modalından sonra tarih çakışması kontrolü ve işleme devam
  const handlePreConfirmContinue = async () => {
    setPreConfirmDialogOpen(false);
    
    if (!companyId || !startDate || !endDate) {
      setError('Şirket bilgisi veya tarih aralığı eksik.');
      return;
    }

    setEndOfDayProcessing(true);
    
    try {
      // ✅ Önce tarih çakışması kontrolü yap
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      
      const reportsResponse = await endOfDayReportApi.getByCompanyId(
        oneYearAgo.toISOString(),
        new Date().toISOString()
      );
      
      if (reportsResponse.Data && reportsResponse.Data.length > 0) {
        // Seçilen tarih aralığıyla çakışan raporları bul
        const selectedStart = startDate.getTime();
        const selectedEnd = endDate.getTime();
        
        const conflicting = reportsResponse.Data.filter(report => {
          // ✅ YENİ: Artık tüm kanallar tek raporda olduğu için sadece tarih çakışması kontrol ediliyor
          // Şube seçiliyse, sadece o şubenin raporlarını kontrol et
          if (!isAllBranches && report.BranchId && !selectedBranches.includes(report.BranchId)) {
            return false;
          }
          
          const reportStart = new Date(report.StartDate).getTime();
          const reportEnd = new Date(report.EndDate).getTime();
          
          // Tarih aralıkları çakışıyor mu?
          // Çakışma: (A.start <= B.end) && (A.end >= B.start)
          return selectedStart <= reportEnd && selectedEnd >= reportStart;
        });
        
        if (conflicting.length > 0) {
          // Çakışan raporlar var, modalı göster
          setConflictingReports(conflicting.map(r => ({
            id: r.Id,
            startDate: r.StartDate,
            endDate: r.EndDate,
            screenType: r.ScreenType,
          })));
          setDateConflictDialogOpen(true);
          setEndOfDayProcessing(false);
          return;
        }
      }
      
      // Çakışma yoksa devam et
      setEndOfDayProcessing(false);
      
      if (activeTables.length > 0) {
        // Açık masa varsa onay iste
        setConfirmDialogOpen(true);
      } else {
        // Açık masa yoksa direkt işlemi başlat
        processEndOfDay();
      }
    } catch (err: any) {
      console.error('Tarih kontrolü hatası:', err);
      setEndOfDayProcessing(false);
      // Hata olsa bile devam edelim
      if (activeTables.length > 0) {
        setConfirmDialogOpen(true);
      } else {
        processEndOfDay();
      }
    }
  };

  // ✅ YENİ: Satır tıklama - Detay modalını aç (Restoran veya Hızlı Satış)
  // Sıralama: 0=Hızlı Satış, 1=Paket Sipariş, 2=Restoran, 3=Kiosk, 4=QR Menü, 5=Getir
  const handleRowClick = (row: EndOfDayRestaurantRow | EndOfDayQuickSaleRow | EndOfDayPackageOrderRow) => {
    // Restoran (tab 2) için
    if (activeTab === 2) {
      const saleDetail = completedSales.find(s => String(s.Id) === row.id);
      if (saleDetail) {
        setSelectedSaleDetail(saleDetail);
        setSelectedQuickSaleDetail(null); // Hızlı satış detayını temizle
        setDetailModalOpen(true);
      }
      return;
    }
    
    // ✅ YENİ: Hızlı Satış (tab 0) için
    if (activeTab === 0) {
      // quickSaleData içinden QuickSaleReceiptDto'yu bul
      // Önce handleFilter'da çekilen receipts'i kullanmamız gerekiyor
      // quickSaleData EndOfDayQuickSaleRow formatında, ama bize QuickSaleReceiptDto lazım
      // Bu yüzden API'den çekilen ham veriyi saklamamız gerekiyor
      
      // Şimdilik row.id ile eşleştirme yapalım ve fatura numarasından detay çekelim
      const quickSaleRow = row as EndOfDayQuickSaleRow;
      if (quickSaleRow.invoiceNumber) {
        // QuickSaleReceiptDto oluştur (minimum gerekli alanlarla)
        const quickSaleReceipt: QuickSaleReceiptDto = {
          Id: parseInt(quickSaleRow.id) || 0,
          BranchId: null,
          ScreenId: null,
          ReceiptNumber: quickSaleRow.referenceNumber || '',
          ShortCode: quickSaleRow.receiptNumber || null,
          InvoiceId: quickSaleRow.invoiceId || null,
          InvoiceNumber: quickSaleRow.invoiceNumber || null,
          ReferenceNumber: quickSaleRow.referenceNumber || null,
          SubTotal: quickSaleRow.subtotal || 0,
          DiscountAmount: quickSaleRow.discount || 0,
          TaxAmount: (quickSaleRow.grandTotal || 0) - (quickSaleRow.subtotal || 0),
          TotalAmount: quickSaleRow.grandTotal || 0,
          AccountId: 0,
          AccountName: quickSaleRow.customerName || null,
          PaymentStatus: quickSaleRow.status || 'PAID',
          TotalPaid: quickSaleRow.paidAmount || 0,
          RemainingAmount: 0,
          PaymentType: quickSaleRow.paymentType || 'CASH',
          OpenedAt: typeof quickSaleRow.transactionDate === 'string' ? quickSaleRow.transactionDate : (quickSaleRow.transactionDate?.toString() || ''),
          CompletedAt: typeof quickSaleRow.transactionDate === 'string' ? quickSaleRow.transactionDate : (quickSaleRow.transactionDate?.toString() || null),
          CreatedBy: null,
          CreatedByName: quickSaleRow.createdByName || null,
          Notes: quickSaleRow.notes || null,
          CreatedAt: typeof quickSaleRow.transactionDate === 'string' ? quickSaleRow.transactionDate : (quickSaleRow.transactionDate?.toString() || ''),
          // ✅ Payments dizisini row'dan al (varsa)
          Payments: (quickSaleRow as any).payments?.map((p: any) => ({
            Id: 0,
            PaymentMethod: p.paymentMethod || '',
            Amount: p.amount || 0,
            PaymentPercentage: null,
            CashboxId: null,
            CashboxName: p.cashboxName || null,
            BankAccountId: null,
            BankAccountName: p.bankAccountName || null,
            BankSubAccountId: null,
            BankSubAccountName: p.bankSubAccountName || null,
            AuthCode: null,
            BatchNo: null,
            MaskedCardNumber: null,
            CardType: null,
            FiscalTransactionId: null,
            AccountTransactionId: null,
            CashboxTransactionId: null,
            BankTransactionId: null,
            Notes: null,
            CreatedAt: '',
            CreatedBy: null,
            PaymentProviderType: null,
            PaymentProviderId: null,
            PaymentProviderName: null,
          })) || [],
        };
        
        setSelectedQuickSaleDetail(quickSaleReceipt);
        setSelectedSaleDetail(null); // Restoran detayını temizle
        setDetailModalOpen(true);
      }
      return;
    }

    // Paket (telefon) siparişleri (tab 1) — row'a propagate edilen packageOrderId
    // varsa OrderDetailModal'ı (PackageOrderScreen'in kullandığı aynı modal) aç.
    if (activeTab === 1) {
      const pkgRow = row as EndOfDayPackageOrderRow;
      console.log('[ROW-CLICK package]', { packageOrderId: pkgRow.packageOrderId, orderNumber: pkgRow.orderNumber, invoiceNumber: pkgRow.invoiceNumber });
      if (pkgRow.packageOrderId) {
        setSelectedPackageOrderId(pkgRow.packageOrderId);
        setPackageDetailModalOpen(true);
      }
      return;
    }

    // Yemek platformu tab'ları (5=Getir, 6=Migros, 7=Yemeksepeti, 8=Trendyol)
    // — row'a propagate edilen platform orderId varsa ilgili modali aç
    if (activeTab === 5) {
      const pkgRow = row as EndOfDayPackageOrderRow;
      console.log('[ROW-CLICK getir]', { getirOrderId: pkgRow.getirOrderId, orderNumber: pkgRow.orderNumber, invoiceNumber: pkgRow.invoiceNumber });
      if (pkgRow.getirOrderId) {
        setSelectedGetirOrderId(pkgRow.getirOrderId);
        setGetirDetailModalOpen(true);
      }
      return;
    }

    if (activeTab === 6) {
      const pkgRow = row as EndOfDayPackageOrderRow;
      console.log('[ROW-CLICK migros]', { migrosOrderId: pkgRow.migrosOrderId, orderNumber: pkgRow.orderNumber, invoiceNumber: pkgRow.invoiceNumber });
      if (pkgRow.migrosOrderId) {
        setSelectedMigrosOrderId(pkgRow.migrosOrderId);
        setMigrosDetailModalOpen(true);
      }
      return;
    }

    if (activeTab === 7) {
      const pkgRow = row as EndOfDayPackageOrderRow;
      console.log('[ROW-CLICK yemeksepeti]', { yemeksepetiOrderId: pkgRow.yemeksepetiOrderId, orderNumber: pkgRow.orderNumber, invoiceNumber: pkgRow.invoiceNumber });
      if (pkgRow.yemeksepetiOrderId) {
        setSelectedYsOrderId(pkgRow.yemeksepetiOrderId);
        setYsDetailModalOpen(true);
      }
      return;
    }

    if (activeTab === 8) {
      const pkgRow = row as EndOfDayPackageOrderRow;
      console.log('[ROW-CLICK trendyol]', { trendyolOrderId: pkgRow.trendyolOrderId, orderNumber: pkgRow.orderNumber, invoiceNumber: pkgRow.invoiceNumber, refListSize: trendyolPlatformOrdersRef.current.length });
      if (pkgRow.trendyolOrderId) {
        const found = trendyolPlatformOrdersRef.current.find(
          (o: any) => Number(o.id ?? o.Id) === pkgRow.trendyolOrderId
        );
        console.log('[ROW-CLICK trendyol] order objesi bulundu mu?', !!found);
        if (found) {
          // Detaylı tanı: list endpoint sadece flat field'lar döndürüyor; modal lines/customer/address/payment bekliyor
          console.log('[TRENDYOL-DEBUG] found objesi keys:', Object.keys(found));
          console.log('[TRENDYOL-DEBUG] flat field özeti:', {
            id: (found as any).id,
            packageId: (found as any).packageId,
            orderNumber: (found as any).orderNumber,
            orderStatus: (found as any).orderStatus,
            orderDate: (found as any).orderDate,
            customerName: (found as any).customerName,
            totalAmount: (found as any).totalAmount,
            isPaid: (found as any).isPaid,
            paymentMethod: (found as any).paymentMethod,
          });
          console.log('[TRENDYOL-DEBUG] iç-obje field varlığı (modal bunları okuyor):', {
            hasLines: Array.isArray((found as any).lines),
            linesCount: (found as any).lines?.length,
            hasCustomer: !!(found as any).customer,
            hasAddress: !!(found as any).address,
            hasPayment: !!(found as any).payment,
            packageStatus: (found as any).packageStatus,
            packageCreationDate: (found as any).packageCreationDate,
          });
          const odjRaw = (found as any).orderDetailsJson ?? (found as any).OrderDetailsJson;
          console.log('[TRENDYOL-DEBUG] orderDetailsJson varlığı:', {
            type: typeof odjRaw,
            length: typeof odjRaw === 'string' ? odjRaw.length : null,
            preview: typeof odjRaw === 'string' ? odjRaw.slice(0, 200) : odjRaw,
          });

          // Düzeltme denemesi: orderDetailsJson string ise parse edip lines/customer/address/payment alanlarını
          // Trendyol entity'siyle birleştir. List endpoint'i bu iç-objeleri yalın olarak döndürmüyor.
          let mergedOrder: any = found;
          try {
            if (odjRaw) {
              const parsed = typeof odjRaw === 'string' ? JSON.parse(odjRaw) : odjRaw;
              if (parsed && typeof parsed === 'object') {
                // Trendyol API payload'i: { lines, customer, address, payment, packageStatus, packageCreationDate, ... }
                mergedOrder = { ...parsed, ...found };
                // Eğer found'da bu alt-objeler boşsa parsed'tan al
                mergedOrder.lines = (found as any).lines ?? parsed.lines;
                mergedOrder.customer = (found as any).customer ?? parsed.customer;
                mergedOrder.address = (found as any).address ?? parsed.address;
                mergedOrder.payment = (found as any).payment ?? parsed.payment;
                mergedOrder.packageStatus = (found as any).packageStatus ?? parsed.packageStatus;
                mergedOrder.packageCreationDate = (found as any).packageCreationDate ?? parsed.packageCreationDate;
                mergedOrder.callCenterPhone = (found as any).callCenterPhone ?? parsed.callCenterPhone;
                mergedOrder.customerNote = (found as any).customerNote ?? parsed.customerNote;
                console.log('[TRENDYOL-DEBUG] merge sonrası obje keys:', Object.keys(mergedOrder));
                console.log('[TRENDYOL-DEBUG] merge sonrası iç-obje:', {
                  linesCount: mergedOrder.lines?.length,
                  hasCustomer: !!mergedOrder.customer,
                  hasAddress: !!mergedOrder.address,
                  hasPayment: !!mergedOrder.payment,
                  packageStatus: mergedOrder.packageStatus,
                });
              }
            }
          } catch (e) {
            console.error('[TRENDYOL-DEBUG] orderDetailsJson parse hatası:', e);
          }

          setSelectedTrendyolOrder(mergedOrder as TrendyolOrder);
          setTrendyolDetailModalOpen(true);
        }
      }
      return;
    }
  };

  // ✅ YENİ: Gün sonu işlemini gerçekleştir
  const processEndOfDay = async () => {
    setConfirmDialogOpen(false);
    setEndOfDayProcessing(true);
    
    try {
      if (!companyId || !startDate || !endDate) {
        throw new Error('Şirket bilgisi veya tarih aralığı eksik.');
      }

      const uid = ownAuthSession.getCurrentUid();
      if (!uid) {
        throw new Error('Oturum bilgisi bulunamadı.');
      }

      // Kullanıcı adını Firebase'den al
      let closedByName: string | null = null;
      try {
        const userData = await firebaseDataService.getUserData(uid);
        if (userData) {
          const uName = `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
          closedByName = uName || ownAuthSession.getCurrentEmail() || null;
        }
      } catch (e) {
        console.warn('Kullanıcı adı alınamadı:', e);
      }

      // Summary null kontrolü
      if (!summary) {
        throw new Error('Özet bilgisi hesaplanamadı. Lütfen önce Filtrele butonuna basın.');
      }

      // ✅ YENİ: Tüm ekranları JSON formatında hazırla (şube bazlı veya tümü)
      let screensJsonData: Array<{id: number; name: string; type: string}> = [];
      if (!isAllBranches) {
        screensJsonData = screenOptions
          .filter(s => s.branchId && selectedBranches.includes(s.branchId))
          .map(s => ({ id: s.id, name: s.name, type: s.type }));
      } else {
        // Tümü seçili - tüm ekranlar
        screensJsonData = screenOptions.map(s => ({ id: s.id, name: s.name, type: s.type }));
      }

      // Gün sonu raporu verilerini hazırla
      const reportData: CreateEndOfDayReportDto = {
        ScreenId: null,
        ScreenType: 'ALL', // ✅ Tüm kanalları kapsıyor
        StartDate: startDate.toISOString(),
        EndDate: endDate.toISOString(),
        Balance: summary.totalAmount - summary.cancelledAmount,
        CashTotal: summary.cashAmount,
        PosTotal: summary.posAmount,
        OtherTotal: summary.otherAmount, // ✅ YENİ: Diğer ödeme yöntemleri (yemek kartı, hediye kartı vb.)
        CancelledTotal: summary.cancelledAmount,
        TransactionCount: summary.totalCount,
        ClosedBy: uid,
        ClosedByName: closedByName,
        ClosedByEmail: ownAuthSession.getCurrentEmail(),
        Notes: null, // İsteğe bağlı not eklenebilir
        BranchId: isAllBranches ? null : (selectedBranches.length === 1 ? selectedBranches[0] : null), // Tek şube seçiliyse o şubenin ID'si
        ScreensJson: screensJsonData.length > 0 ? JSON.stringify(screensJsonData) : null, // ✅ YENİ: Ekranlar JSON
      };

      console.log('🔄 Gün sonu raporu kaydediliyor...', reportData);
      console.log('📍 Şube bilgisi:', {
        selectedBranches,
        branchId: reportData.BranchId,
        branchName: getSelectedBranchLabel(),
      });

      // Backend'e kaydet
      const response = await endOfDayReportApi.create(reportData);
      
      console.log('✅ Gün sonu raporu başarıyla kaydedildi:', response);
      
      // Başarılı bildirim - Modal göster
      setSuccessDialogData({
        reportId: response.Data.Id,
        balance: response.Data.Balance,
        branchName: isAllBranches ? null : getSelectedBranchLabel(),
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      });
      setSuccessDialogOpen(true);
      
      // ✅ YENİ: Son gün sonu raporunu güncelle
      const rawNewEnd = response.Data.EndDate as string;
      setLastEndOfDayReport({
        id: response.Data.Id,
        endDate: new Date(rawNewEnd.endsWith('Z') ? rawNewEnd : rawNewEnd + 'Z'),
        screenType: response.Data.ScreenType,
      });
      
    } catch (err: any) {
      console.error('Gün sonu hatası:', err);
      
      // Hata mesajını düzenle
      let errorMessage = 'Gün sonu kaydedilirken bir hata oluştu.';
      if (err.response?.data?.Message) {
        errorMessage = err.response.data.Message;
        if (err.response.data.ExistingReportId) {
          errorMessage += `\n\nMevcut Rapor No: ${err.response.data.ExistingReportId}`;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
      alert(`❌ ${errorMessage}`);
    } finally {
      setEndOfDayProcessing(false);
    }
  };

  // ✅ YENİ: Son gün sonu tarihinden sonrasını aktar
  const handleApplyLastEndOfDayDate = () => {
    if (lastEndOfDayReport) {
      // Son gün sonu bitiş tarihinden 1 saniye sonrasını başlangıç olarak ayarla
      const newStartDate = new Date(lastEndOfDayReport.endDate.getTime() + 1000);
      setStartDate(newStartDate);
      
      // Bitiş tarihi şu anki saat
      setEndDate(new Date());
      
      // Veri yükleme durumunu sıfırla
      setDataLoaded(false);
      setRestaurantData([]);
      setQuickSaleData([]);
      setKioskData([]);
      setQRMenuData([]);
      setSummary(null);
    }
  };

  // Sayfalama
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ÖKC filtresi: filterFiscalOnly KAPALI (false, varsayılan) = ÖKC'siz nakit kayıtları GİZLE
  // filterFiscalOnly AÇIK (true) = ÖKC'siz nakit kayıtları da GÖSTER
  const shouldHideNonFiscal = !filterFiscalOnly;

  const filteredRestaurantData = useMemo(() => {
    if (!shouldHideNonFiscal) return restaurantData;
    return restaurantData
      .filter(row => !(row.paymentType === 'CASH' && row.isFiscalReceipt === false))
      .map((row, i) => ({ ...row, rowNumber: i + 1 }));
  }, [restaurantData, shouldHideNonFiscal]);

  // Ekran filtresi (QuickSaleReceipts.ScreenId) — seçili ekran(lar) varsa sadece o ekranların fişleri.
  // PREPAID satırlarda fiş numarası önekine göre ID uzayı belirlenir:
  //   - "PYK-" önekli (legacy, PYK ekranından fişlenen) → ScreenId = PykScreen.Id → "pyk-{id}"
  //   - "HSP-" önekli (yeni sistem, satış ANINDA yazılan) → ScreenId = QuickSaleScreen.Id → "qs-{id}"
  // ÖKC filtresi UYGULANMADAN; fiscal düzeltmesi ayrıca nonFiscalCashTotal ile yapılır.
  const screenScopedQuickSaleData = useMemo(() => {
    if (selectedScreenKeys.length === 0) return quickSaleData;
    const selected = new Set(selectedScreenKeys);
    return quickSaleData.filter(row => {
      if (row.screenId == null) return false;
      const isLegacyPyk = (row.referenceNumber || '').startsWith('PYK-');
      return selected.has(isLegacyPyk ? `pyk-${row.screenId}` : `qs-${row.screenId}`);
    });
  }, [quickSaleData, selectedScreenKeys]);

  const filteredQuickSaleData = useMemo(() => {
    if (!shouldHideNonFiscal) {
      return selectedScreenKeys.length > 0
        ? screenScopedQuickSaleData.map((row, i) => ({ ...row, rowNumber: i + 1 }))
        : screenScopedQuickSaleData;
    }
    return screenScopedQuickSaleData
      .filter(row => !(row.paymentType === 'CASH' && row.isFiscalReceipt === false))
      .map((row, i) => ({ ...row, rowNumber: i + 1 }));
  }, [screenScopedQuickSaleData, shouldHideNonFiscal, selectedScreenKeys]);

  // Ekran filtresi seçenekleri: şube seçiliyse sadece o şubelere ait ekranlar
  const availableQuickSaleScreens = useMemo(() => {
    if (isAllBranches) return quickSaleScreens;
    return quickSaleScreens.filter(s => s.branchId && selectedBranches.includes(s.branchId));
  }, [quickSaleScreens, selectedBranches, isAllBranches]);

  // ✅ YENI: Restoran tab'i icin "Urun Bazinda Satis Ozeti" tablosu icin veri.
  //   Kaynak: completedSales[].ItemsJson (JSON parse) — ham DTO'da bu alan var.
  //   Filtre: filteredRestaurantData icindeki CANCELLED OLMAYAN satislar
  //     (kullanici secimi: 'completed_only').
  //   Grupla: productName -> { quantity, totalRevenue, orderCount }.
  //   orderCount: kac farkli SATISTA bu urun gectigi (aynı satışta birden çok
  //   satır olsa bile 1 sayilir).
  // Not: `productSalesSummary` ismi yukarida fatura kaynakli ProductSalesSummaryItem[]
  //   state'i icin kullaniliyor; cakismayi onlemek icin `restaurantProductSummary`.
  const restaurantProductSummary = useMemo(() => {
    const visibleIds = new Set(
      filteredRestaurantData.filter(r => r.status !== 'CANCELLED').map(r => r.id),
    );
    const map = new Map<string, { name: string; quantity: number; totalRevenue: number; orderCount: number }>();

    for (const sale of completedSales) {
      if (!visibleIds.has(String(sale.Id))) continue;
      if (!sale.ItemsJson) continue;
      let items: any[];
      try {
        const parsed = JSON.parse(sale.ItemsJson);
        items = Array.isArray(parsed) ? parsed : [];
      } catch {
        continue;
      }
      const seenInSale = new Set<string>();
      for (const item of items) {
        const rawName = item?.productName ?? item?.ProductName ?? item?.name ?? item?.Name ?? '';
        const name = String(rawName).trim();
        if (!name) continue;
        const qty = Number(item?.quantity ?? item?.Quantity ?? 0);
        if (!Number.isFinite(qty) || qty <= 0) continue;
        const unitPrice = Number(item?.unitPrice ?? item?.UnitPrice ?? item?.price ?? item?.Price ?? 0);
        const totalPrice = Number(item?.totalPrice ?? item?.TotalPrice ?? qty * unitPrice);
        const lineTotal = Number.isFinite(totalPrice) ? totalPrice : 0;

        const existing = map.get(name);
        const firstTimeInThisSale = !seenInSale.has(name);
        seenInSale.add(name);
        if (existing) {
          existing.quantity += qty;
          existing.totalRevenue += lineTotal;
          if (firstTimeInThisSale) existing.orderCount += 1;
        } else {
          map.set(name, { name, quantity: qty, totalRevenue: lineTotal, orderCount: 1 });
        }
      }
    }

    return Array.from(map.values()).sort((a, b) => b.quantity - a.quantity);
  }, [completedSales, filteredRestaurantData]);

  // ✅ YENI: Hizli Satis tab'i icin "Urun Bazinda Satis Ozeti" verisi.
  //   Restoran'dan FARKLI olarak hizli satis fislerinde `ItemsJson` alani yok.
  //   Urunler invoice (fatura) kalemleri uzerinden tutuldugu icin toplu API
  //   `getProductSalesSummaryByInvoiceIds` ile cekiyoruz.
  //   Filtre: filteredQuickSaleData icindeki CANCELLED OLMAYAN ve invoiceId
  //     bulunan satislar (iade dahil degil — status='CANCELLED' iade icin de
  //     atanmis halde).
  //   API aggregated donduyle `orderCount` bilgisi yok; UI'da "—" gosterilir.
  useEffect(() => {
    if (activeTab !== 0) return;
    if (!filteredQuickSaleData || filteredQuickSaleData.length === 0) {
      setQuickSaleProductSummary([]);
      return;
    }
    const invoiceIds = filteredQuickSaleData
      .filter(r => r.status !== 'CANCELLED' && r.invoiceId)
      .map(r => r.invoiceId as string);

    if (invoiceIds.length === 0) {
      setQuickSaleProductSummary([]);
      return;
    }

    let cancelled = false;
    setLoadingQuickSaleProducts(true);

    getProductSalesSummaryByInvoiceIds(invoiceIds)
      .then(response => {
        if (cancelled) return;
        setQuickSaleProductSummary(mergeProductSummaryItems(response.Items || []));
      })
      .catch(err => {
        console.error('[Hizli Satis Urun Ozet] API hatasi:', err);
        if (!cancelled) setQuickSaleProductSummary([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingQuickSaleProducts(false);
      });

    return () => { cancelled = true; };
  }, [activeTab, filteredQuickSaleData]);

  // Paket Sipariş tab'ı için ürün bazında satış özeti.
  //   Kaynak: packageOrderData (PKT- prefixli QuickSaleReceipts) +
  //           cancel akışından gelen PackageOrders satırları.
  //   Filtre: CANCELLED olmayan ve invoiceId taşıyan satırlar.
  //   UNPAID / "Bilinmiyor (Platform Ödendi)" satırları zaten invoiceId
  //   taşımadığı için doğal olarak filtre dışında kalır.
  useEffect(() => {
    if (activeTab !== 1) return;
    if (!packageOrderData || packageOrderData.length === 0) {
      setPackageProductSummary([]);
      return;
    }
    const invoiceIds = packageOrderData
      .filter(r => r.status !== 'CANCELLED' && r.invoiceId)
      .map(r => r.invoiceId as string);

    if (invoiceIds.length === 0) {
      setPackageProductSummary([]);
      return;
    }

    let cancelled = false;
    setLoadingPackageProducts(true);

    getProductSalesSummaryByInvoiceIds(invoiceIds)
      .then(response => {
        if (cancelled) return;
        setPackageProductSummary(mergeProductSummaryItems(response.Items || []));
      })
      .catch(err => {
        console.error('[Paket Urun Ozet] API hatasi:', err);
        if (!cancelled) setPackageProductSummary([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingPackageProducts(false);
      });

    return () => { cancelled = true; };
  }, [activeTab, packageOrderData]);

  // Getir tab'ı için ürün bazında satış özeti.
  //   Kaynak: getirOrderData (GTR- prefixli QuickSaleReceipts).
  //   Filtre: CANCELLED olmayan ve invoiceId taşıyan satırlar.
  //   UNPAID / "Bilinmiyor (Platform Ödendi)" satırlar invoiceId taşımadığı
  //   için doğal olarak filtre dışında kalır.
  useEffect(() => {
    if (activeTab !== 5) return;
    if (!getirOrderData || getirOrderData.length === 0) {
      setGetirProductSummary([]);
      return;
    }
    const invoiceIds = getirOrderData
      .filter(r => r.status !== 'CANCELLED' && r.invoiceId)
      .map(r => r.invoiceId as string);

    if (invoiceIds.length === 0) {
      setGetirProductSummary([]);
      return;
    }

    let cancelled = false;
    setLoadingGetirProducts(true);

    getProductSalesSummaryByInvoiceIds(invoiceIds)
      .then(response => {
        if (cancelled) return;
        setGetirProductSummary(mergeProductSummaryItems(response.Items || []));
      })
      .catch(err => {
        console.error('[Getir Urun Ozet] API hatasi:', err);
        if (!cancelled) setGetirProductSummary([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingGetirProducts(false);
      });

    return () => { cancelled = true; };
  }, [activeTab, getirOrderData]);

  // Migros tab'ı için ürün bazında satış özeti.
  //   Kaynak: migrosOrderData (MGR- prefixli QuickSaleReceipts).
  //   Filtre: CANCELLED olmayan ve invoiceId taşıyan satırlar.
  useEffect(() => {
    if (activeTab !== 6) return;
    if (!migrosOrderData || migrosOrderData.length === 0) {
      setMigrosProductSummary([]);
      return;
    }
    const invoiceIds = migrosOrderData
      .filter(r => r.status !== 'CANCELLED' && r.invoiceId)
      .map(r => r.invoiceId as string);

    if (invoiceIds.length === 0) {
      setMigrosProductSummary([]);
      return;
    }

    let cancelled = false;
    setLoadingMigrosProducts(true);

    getProductSalesSummaryByInvoiceIds(invoiceIds)
      .then(response => {
        if (cancelled) return;
        setMigrosProductSummary(mergeProductSummaryItems(response.Items || []));
      })
      .catch(err => {
        console.error('[Migros Urun Ozet] API hatasi:', err);
        if (!cancelled) setMigrosProductSummary([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingMigrosProducts(false);
      });

    return () => { cancelled = true; };
  }, [activeTab, migrosOrderData]);

  // Yemeksepeti tab'ı için ürün bazında satış özeti.
  //   Kaynak: ysOrderData (YS- prefixli QuickSaleReceipts).
  //   Filtre: CANCELLED olmayan ve invoiceId taşıyan satırlar.
  useEffect(() => {
    if (activeTab !== 7) return;
    if (!ysOrderData || ysOrderData.length === 0) {
      setYsProductSummary([]);
      return;
    }
    const invoiceIds = ysOrderData
      .filter(r => r.status !== 'CANCELLED' && r.invoiceId)
      .map(r => r.invoiceId as string);

    if (invoiceIds.length === 0) {
      setYsProductSummary([]);
      return;
    }

    let cancelled = false;
    setLoadingYsProducts(true);

    getProductSalesSummaryByInvoiceIds(invoiceIds)
      .then(response => {
        if (cancelled) return;
        setYsProductSummary(mergeProductSummaryItems(response.Items || []));
      })
      .catch(err => {
        console.error('[YS Urun Ozet] API hatasi:', err);
        if (!cancelled) setYsProductSummary([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingYsProducts(false);
      });

    return () => { cancelled = true; };
  }, [activeTab, ysOrderData]);

  // Trendyol tab'ı için ürün bazında satış özeti.
  //   Kaynak: trendyolOrderData (TYL- prefixli QuickSaleReceipts).
  //   Filtre: CANCELLED olmayan ve invoiceId taşıyan satırlar.
  useEffect(() => {
    if (activeTab !== 8) return;
    if (!trendyolOrderData || trendyolOrderData.length === 0) {
      setTrendyolProductSummary([]);
      return;
    }
    const invoiceIds = trendyolOrderData
      .filter(r => r.status !== 'CANCELLED' && r.invoiceId)
      .map(r => r.invoiceId as string);

    if (invoiceIds.length === 0) {
      setTrendyolProductSummary([]);
      return;
    }

    let cancelled = false;
    setLoadingTrendyolProducts(true);

    getProductSalesSummaryByInvoiceIds(invoiceIds)
      .then(response => {
        if (cancelled) return;
        setTrendyolProductSummary(mergeProductSummaryItems(response.Items || []));
      })
      .catch(err => {
        console.error('[Trendyol Urun Ozet] API hatasi:', err);
        if (!cancelled) setTrendyolProductSummary([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingTrendyolProducts(false);
      });

    return () => { cancelled = true; };
  }, [activeTab, trendyolOrderData]);

  // ✅ YENİ: Hızlı Satış tab'ı açıkken oturumu açık + bakiyesi olan kartları çek.
  //   Bunlar "şu anki" anlık görüntüdür (tarih filtresinden bağımsız), tıpkı restoran
  //   tab'indaki açık masalar gibi. Sadece bilgi amaçlı; gün sonu toplamına KATILMAZ.
  useEffect(() => {
    if (activeTab !== 0) return;
    if (!authCompanyId) return;

    let cancelled = false;
    setLoadingOpenCardSessions(true);

    (async () => {
      try {
        // Oturumu açık tüm kartları çek (server-side filtre: sessionStatus=ACTIVE),
        // ardından bakiyesi olanları (totalBalance > 0) client'ta süz.
        const res = await cardManagementService.getCards(authCompanyId, {
          page: 1,
          pageSize: 1000,
          sessionStatus: 'ACTIVE',
        });
        if (cancelled) return;
        const all = res.data?.data || [];
        const withBalance = all.filter((c: any) =>
          c.activeSession && c.activeSession.status === 'ACTIVE' && (Number(c.totalBalance) || 0) > 0
        );
        setOpenCardSessions(withBalance);
      } catch (err) {
        console.error('[GÜN SONU] Oturumu açık kartlar yüklenemedi:', err);
        if (!cancelled) setOpenCardSessions([]);
      } finally {
        if (!cancelled) setLoadingOpenCardSessions(false);
      }
    })();

    return () => { cancelled = true; };
  }, [activeTab, authCompanyId]);

  // ÖKC'siz nakit toplam tutarı (özet ve yazdırma düzeltmeleri için)
  // Hızlı satış kısmı seçili ekran(lar)a göre kapsanır.
  const nonFiscalCashTotal = useMemo(() => {
    if (!shouldHideNonFiscal) return 0;
    const fromRestaurant = restaurantData
      .filter(row => row.paymentType === 'CASH' && row.isFiscalReceipt === false && row.status !== 'CANCELLED')
      .reduce((sum, row) => sum + row.paidAmount, 0);
    const fromQuickSale = screenScopedQuickSaleData
      .filter(row => row.paymentType === 'CASH' && row.isFiscalReceipt === false && row.status !== 'CANCELLED')
      .reduce((sum, row) => sum + row.paidAmount, 0);
    return fromRestaurant + fromQuickSale;
  }, [restaurantData, screenScopedQuickSaleData, shouldHideNonFiscal]);

  // Üstteki özet tablosu — seçili ekran(lar) varsa hızlı satış katkısı o ekranlara göre
  // yeniden hesaplanır (diğer kanallar değişmez). Ekran seçili değilse handleFilter'ın
  // ürettiği summaryTableRows aynen kullanılır (enrichment dahil, davranış değişmez).
  const displaySummaryTableRows = useMemo(() => {
    if (selectedScreenKeys.length === 0) return summaryTableRows;
    return calculateCombinedSummary(
      completedSales,
      screenScopedQuickSaleData,
      kioskData,
      qrMenuData,
      packageOrderData,
      getirOrderData,
      migrosOrderData,
      ysOrderData,
      trendyolOrderData
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedScreenKeys, summaryTableRows, completedSales, screenScopedQuickSaleData, kioskData, qrMenuData, packageOrderData, getirOrderData, migrosOrderData, ysOrderData, trendyolOrderData]);

  // ÖKC filtresi uygulanmış özet tablosu
  const filteredSummaryTableRows = useMemo(() => {
    if (!shouldHideNonFiscal || nonFiscalCashTotal === 0) return displaySummaryTableRows;

    // ÖKC filtresi aktifken "Hızlı Satış İndirim Toplamı" satırı da tablodaki
    // (fiscal-filtrelenmiş) verilerle aynı olmalı; aksi halde filtre dışı kalan
    // fişlerin indirimleri özette görünür ve tablo footer'ı ile uyuşmaz.
    const filteredQuickSaleDiscountSum = filteredQuickSaleData
      .filter(r => r.status !== 'CANCELLED')
      .reduce((sum, r) => sum + (Number(r.discount) || 0), 0);

    let remaining = nonFiscalCashTotal;
    const result = displaySummaryTableRows.map(row => {
      // Nakit satırlarından düş (GENEL TOPLAM hariç).
      // NOT: summaryTableRows içindeki paymentType İNGİLİZCE atanıyor ('Cash');
      // Türkçe etiket sadece UI render aşamasında getSummaryPaymentTypeLabel
      // ile çevriliyor. Bu yüzden burada hem 'Cash' (asıl değer) hem 'Nakit'
      // (defensive — başka bir akış Türkçe gönderirse) match ediliyor.
      if ((row.paymentType === 'Cash' || row.paymentType === 'Nakit') && !row.isTotal && remaining > 0) {
        const deduction = Math.min(remaining, row.amount);
        remaining -= deduction;
        return { ...row, amount: row.amount - deduction };
      }
      // Hızlı satış indirimini fiscal-filtrelenmiş veriyle eşitle (tablo footer'ı ile tutarlı)
      if (row.paymentType === 'Quick Sale Discount') {
        return { ...row, amount: filteredQuickSaleDiscountSum };
      }
      return row;
    });
    
    // GENEL TOPLAM satırından da düş
    return result.map(row => {
      if (row.isTotal) {
        return { ...row, amount: row.amount - nonFiscalCashTotal };
      }
      return row;
    }).filter(row => row.amount > 0 || row.isTotal);
  }, [displaySummaryTableRows, shouldHideNonFiscal, nonFiscalCashTotal, filteredQuickSaleData]);

  // Tab'a göre aktif veri
  // 0=Hızlı Satış, 1=Paket, 2=Restoran, 3=Kiosk, 4=QR Menü, 5=Getir, 6=Migros, 7=Yemeksepeti, 8=Trendyol
  const getDataByTab = (tabIndex: number) => {
    switch (tabIndex) {
      case 0: return filteredQuickSaleData;
      case 1: return packageOrderData;
      case 2: return filteredRestaurantData;
      case 3: return kioskData;
      case 4: return qrMenuData;
      case 5: return getirOrderData;
      case 6: return migrosOrderData;
      case 7: return ysOrderData;
      case 8: return trendyolOrderData;
      default: return [];
    }
  };

  // Sayfalanmış veriler (aktif tab'a göre)
  const paginatedData = useMemo(() => {
    const data = getDataByTab(activeTab);
    const startIndex = page * rowsPerPage;
    return data.slice(startIndex, startIndex + rowsPerPage);
  }, [activeTab, filteredRestaurantData, filteredQuickSaleData, kioskData, qrMenuData, getirOrderData, migrosOrderData, ysOrderData, trendyolOrderData, page, rowsPerPage, filterFiscalOnly]);
  
  // Toplam veri sayısı (aktif tab'a göre)
  const totalDataCount = useMemo(() => {
    return getDataByTab(activeTab).length;
  }, [activeTab, filteredRestaurantData, filteredQuickSaleData, kioskData, qrMenuData, getirOrderData, migrosOrderData, ysOrderData, trendyolOrderData, filterFiscalOnly]);
  
  // Tüm kanalların toplam işlem sayısı
  const totalAllChannelsCount = useMemo(() => {
    return filteredRestaurantData.length + filteredQuickSaleData.length + kioskData.length + qrMenuData.length + getirOrderData.length + migrosOrderData.length + ysOrderData.length + trendyolOrderData.length;
  }, [filteredRestaurantData, filteredQuickSaleData, kioskData, qrMenuData, getirOrderData, migrosOrderData, ysOrderData, trendyolOrderData]);
  
  const activeColumns = useMemo(() => {
    switch (activeTab) {
      case 0: return QUICK_SALE_COLUMNS;
      case 1: return PACKAGE_ORDER_COLUMNS;
      case 2: return RESTAURANT_COLUMNS;
      case 3: return KIOSK_COLUMNS;
      case 4: return QR_MENU_COLUMNS;
      case 5: return PACKAGE_ORDER_COLUMNS;
      case 6: return PACKAGE_ORDER_COLUMNS;
      case 7: return PACKAGE_ORDER_COLUMNS;
      case 8: return PACKAGE_ORDER_COLUMNS;
      default: return QUICK_SALE_COLUMNS;
    }
  }, [activeTab]);
  
  // Tab değiştiğinde sayfa sıfırla
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setPage(0);
  };

  // ✅ YENİ: Tablodaki genel toplam hesaplaması (grandTotal ve paidAmount toplamları)
  const tableGrandTotals = useMemo(() => {
    const data = getDataByTab(activeTab) as any[];
    
    // Sadece iptal edilmemiş satışları dahil et
    const validData = data.filter((row) => row.status !== 'CANCELLED');
    
    const grandTotalSum = validData.reduce((sum, row) => sum + (row.grandTotal || 0), 0);
    const paidAmountSum = validData.reduce((sum, row) => sum + (row.paidAmount || 0), 0);
    // ✅ YENİ: Toplam indirim (bilgi amaçlı; ciroyu etkilemez)
    const discountSum = validData.reduce((sum, row) => sum + (Number(row.discount) || 0), 0);
    // İndirimsiz Toplam: row.originalTotal yoksa grandTotal'a fallback (hücre görüntüsüyle uyumlu).
    const originalTotalSum = validData.reduce(
      (sum, row) => sum + (Number(row.originalTotal ?? row.grandTotal) || 0),
      0
    );

    return {
      grandTotal: grandTotalSum,
      paidAmount: paidAmountSum,
      originalTotal: originalTotalSum,
      discount: discountSum,
      rowCount: data.length,
      validRowCount: validData.length,
    };
  }, [activeTab, filteredRestaurantData, filteredQuickSaleData, kioskData, qrMenuData, packageOrderData, getirOrderData, migrosOrderData, ysOrderData, trendyolOrderData, filterFiscalOnly]);

  // ✅ YENİ: 80mm Fiş Yazdır
  const handlePrintReceipt = async () => {
    if (!dataLoaded || !companyId || !startDate || !endDate) {
      setError(t('endOfDayReport.errors.filterFirst'));
      return;
    }

    setLoadingPrint(true);
    
    try {
      // ✅ FIX: Filtrelenen fişlerin invoiceId'lerini topla (ÖKC filtresi uygulanmış verilerden)
      const invoiceIds: string[] = [];
      
      // Quick Sale fişlerinden invoiceId topla (filtrelenmiş)
      filteredQuickSaleData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') {
          invoiceIds.push(row.invoiceId);
        }
      });
      
      // Restaurant fişlerinden invoiceId topla (filtrelenmiş)
      filteredRestaurantData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') {
          invoiceIds.push(row.invoiceId);
        }
      });
      
      // Kiosk fişlerinden invoiceId topla
      kioskData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') {
          invoiceIds.push(row.invoiceId);
        }
      });
      
      // QR Menü fişlerinden invoiceId topla
      qrMenuData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') {
          invoiceIds.push(row.invoiceId);
        }
      });
      
      // ✅ YENİ: Paket Sipariş fişlerinden invoiceId topla
      packageOrderData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') {
          invoiceIds.push(row.invoiceId);
        }
      });
      
      // ✅ YENİ: Getir Sipariş fişlerinden invoiceId topla
      getirOrderData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') {
          invoiceIds.push(row.invoiceId);
        }
      });
      migrosOrderData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') invoiceIds.push(row.invoiceId);
      });
      ysOrderData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') invoiceIds.push(row.invoiceId);
      });
      trendyolOrderData.forEach(row => {
        if (row.invoiceId && row.status !== 'CANCELLED') invoiceIds.push(row.invoiceId);
      });
      
      console.log('📊 [PRINT] Filtrelenen fişlerden toplam invoice ID:', invoiceIds.length);
      
      // Kasiyer isimlerini topla (filtrelenmiş fişlerden unique kasiyerler)
      const cashierSet = new Set<string>();
      filteredQuickSaleData.forEach(row => {
        if (row.cashierName) cashierSet.add(row.cashierName);
        if (row.createdByName && row.createdByName !== row.cashierName) cashierSet.add(row.createdByName);
      });
      filteredRestaurantData.forEach(row => {
        if (row.waiterName) cashierSet.add(row.waiterName);
      });
      // ✅ YENİ: Paket sipariş kasiyerlerini ekle
      packageOrderData.forEach(row => {
        if (row.cashierName) cashierSet.add(row.cashierName);
      });
      getirOrderData.forEach(row => {
        if (row.cashierName) cashierSet.add(row.cashierName);
      });
      migrosOrderData.forEach(row => {
        if (row.cashierName) cashierSet.add(row.cashierName);
      });
      ysOrderData.forEach(row => {
        if (row.cashierName) cashierSet.add(row.cashierName);
      });
      trendyolOrderData.forEach(row => {
        if (row.cashierName) cashierSet.add(row.cashierName);
      });
      
      // ✅ YENİ: Ödeme özetini PaymentProviderName kullanarak ayrıntılı hesapla
      // Normal Nakit ve POS ayrı, Online ve Diğer ödemeler platform bazlı ayrı gösterilecek
      let cashTotal = 0;  // Normal nakit (platform olmayan)
      let posTotal = 0;   // Normal POS (platform olmayan)
      let prepaidTotal = 0; // PYK ön ödemeli (kart) — kasa/banka değil, ayrı gösterilir
      const onlinePaymentsMap = new Map<string, number>(); // Yemeksepeti Nakit, Yemeksepeti POS vb.
      const otherPaymentsMap = new Map<string, number>();  // Multinet, Pluxee vb.
      
      // Hızlı satış verilerinden ayrıntılı ödeme hesaplama (filtrelenmiş)
      filteredQuickSaleData.forEach(row => {
        if (row.status === 'CANCELLED') return;
        
        if (row.payments && row.payments.length > 0) {
          row.payments.forEach(payment => {
            const method = payment.paymentMethod?.toUpperCase() || '';
            const providerName = payment.paymentProviderName?.toUpperCase() || '';
            const providerType = payment.paymentProviderType?.toUpperCase() || '';
            const amount = payment.amount || 0;
            
            // ✅ YENİ: PaymentProviderType'dan ödeme yöntemini çıkar
            // Format: ONLINE_YEMEK SEPETİ_NAKİT, ONLINE_GETİR YEMEK_POS, ONLINE_TRENDYOL_ONLİNE
            const isOnlinePayment = method.startsWith('ONLINE_') || providerType.startsWith('ONLINE_');
            
            // PaymentProviderType'tan ödeme türünü çıkar (_NAKİT, _POS, _ONLİNE)
            let onlinePaymentType = '';
            if (providerType.endsWith('_NAKİT') || providerType.endsWith('_NAKIT')) {
              onlinePaymentType = 'Nakit';
            } else if (providerType.endsWith('_POS')) {
              onlinePaymentType = 'POS';
            } else if (providerType.endsWith('_ONLİNE') || providerType.endsWith('_ONLINE')) {
              onlinePaymentType = 'Online';
            }
            
            // Online platform kontrolü
            const isOnlinePlatform = providerName.includes('YEMEK') || 
                                     providerName.includes('GETİR') || 
                                     providerName.includes('TRENDYOL') ||
                                     providerName.includes('MİGROS');
            
            const isOtherPayment = providerName.includes('MULTİNET') || 
                                   providerName.includes('MULTINET') ||
                                   providerName.includes('PLUXEE') ||
                                   providerName.includes('TICKET') ||
                                   providerName.includes('EDENRED') ||
                                   providerName.includes('SETCARD') ||
                                   providerName.includes('TOKENFLEX') ||
                                   providerName.includes('METROPOL') ||
                                   method === 'OTHER';
            
            if (method === 'PREPAID') {
              // PYK ön ödemeli: para zaten yükleme anında kasaya/bankaya girdi →
              // ayrı toplanır, nakit/POS'a eklenmez.
              prepaidTotal += amount;
            } else if (isOnlinePlatform || isOnlinePayment) {
              // Online platform ödemesi - platform adı + ödeme türü ile grupla
              let paymentTypeSuffix = '';
              
              // ✅ Önce PaymentProviderType'tan çıkarılan türü kullan
              if (onlinePaymentType) {
                paymentTypeSuffix = ` (${onlinePaymentType})`;
              } 
              // ✅ Fallback: PaymentMethod'dan çıkar
              else if (method === 'ONLINE_CASH' || method === 'CASH' || method === 'NAKİT') {
                paymentTypeSuffix = ' (Nakit)';
              } else if (method === 'ONLINE_POS' || method === 'POS' || method === 'CREDIT_CARD') {
                paymentTypeSuffix = ' (POS)';
              } else if (method === 'ONLINE_ONLINE' || method === 'ONLINE') {
                paymentTypeSuffix = ' (Online)';
              } else {
                paymentTypeSuffix = ' (Nakit)'; // Varsayılan
              }
              
              const key = providerName + paymentTypeSuffix;
              const current = onlinePaymentsMap.get(key) || 0;
              onlinePaymentsMap.set(key, current + amount);
            } else if (method === 'OPEN_ACCOUNT') {
              otherPaymentsMap.set('AÇIK HESAP', (otherPaymentsMap.get('AÇIK HESAP') || 0) + amount);
            } else if (isOtherPayment || (providerName && !isOnlinePlatform)) {
              const key = providerName || payment.cashboxName || 'Diğer';
              const current = otherPaymentsMap.get(key) || 0;
              otherPaymentsMap.set(key, current + amount);
            } else if (method === 'CASH' || method === 'NAKİT') {
              // Normal nakit (platform yok)
              cashTotal += amount;
            } else if (method === 'POS' || method === 'CREDIT_CARD') {
              // Normal POS (platform yok)
              posTotal += amount;
            } else {
              // Bilinmeyen - kasaya ekle
              cashTotal += amount;
            }
          });
        } else {
          // Fallback: payments yoksa eski yöntem
          if (row.paymentType === 'PREPAID') {
            prepaidTotal += row.paidAmount || 0;
          } else if (row.paymentType === 'OPEN_ACCOUNT') {
            otherPaymentsMap.set('AÇIK HESAP', (otherPaymentsMap.get('AÇIK HESAP') || 0) + (row.paidAmount || 0));
          } else if (row.paymentType === 'OTHER') {
            const providerName = row.paymentProviderName?.toUpperCase() || 'DİĞER';
            otherPaymentsMap.set(providerName, (otherPaymentsMap.get(providerName) || 0) + (row.paidAmount || 0));
          } else if (row.paymentType === 'ONLINE') {
            const providerName = row.paymentProviderName?.toUpperCase() || 'ONLINE';
            const key = `${providerName} (Online)`;
            const current = onlinePaymentsMap.get(key) || 0;
            onlinePaymentsMap.set(key, current + (row.paidAmount || 0));
          } else if (row.paymentType === 'CASH') {
            cashTotal += row.paidAmount || 0;
          } else if (row.paymentType === 'POS') {
            posTotal += row.paidAmount || 0;
          }
        }
      });
      
      // Restoran verilerinden ödeme hesaplama (Payments dizisi öncelikli)
      filteredRestaurantData.forEach(row => {
        if (row.status === 'CANCELLED') return;
        
        const sale = completedSales.find(s => s.Id === Number(row.id));
        if (sale?.Payments && sale.Payments.length > 0) {
          sale.Payments.forEach(payment => {
            const method = payment.PaymentMethod?.toLowerCase() || '';
            if (method === 'cash' || method === 'nakit') {
              cashTotal += payment.Amount || 0;
            } else if (method === 'pos' || method === 'credit_card') {
              posTotal += payment.Amount || 0;
            } else if (method === 'open_account' || method === 'açık hesap') {
              otherPaymentsMap.set('AÇIK HESAP', (otherPaymentsMap.get('AÇIK HESAP') || 0) + (payment.Amount || 0));
            } else {
              cashTotal += payment.Amount || 0;
            }
          });
        } else {
          if (row.paymentType === 'OPEN_ACCOUNT') {
            otherPaymentsMap.set('AÇIK HESAP', (otherPaymentsMap.get('AÇIK HESAP') || 0) + (row.paidAmount || 0));
          } else if (row.paymentType === 'CASH') {
            cashTotal += row.paidAmount || 0;
          } else if (row.paymentType === 'POS') {
            posTotal += row.paidAmount || 0;
          } else if (row.paymentType === 'MIXED') {
            cashTotal += (row.paidAmount || 0) / 2;
            posTotal += (row.paidAmount || 0) / 2;
          }
        }
      });
      
      // ✅ YENİ: Paket Sipariş verilerinden ödeme hesaplama (AYRI GÖSTER)
      let packageCashTotal = 0;
      let packagePosTotal = 0;
      
      packageOrderData.forEach(row => {
        if (row.status === 'CANCELLED') return;
        
        if (row.paymentType === 'OTHER' && row.otherAmount && row.otherAmount > 0) {
          const label = row.paymentProviderName?.toUpperCase() || 'DİĞER';
          const key = `PAKET ${label}`;
          otherPaymentsMap.set(key, (otherPaymentsMap.get(key) || 0) + row.otherAmount);
          return;
        }
        
        if (row.cashAmount && row.cashAmount > 0) {
          packageCashTotal += row.cashAmount;
        }
        if (row.posAmount && row.posAmount > 0) {
          packagePosTotal += row.posAmount;
        }
        
        if (!row.cashAmount && !row.posAmount) {
          if (row.paymentType === 'CASH') {
            packageCashTotal += row.paidAmount || 0;
          } else if (row.paymentType === 'POS') {
            packagePosTotal += row.paidAmount || 0;
          } else if (row.paymentType === 'MIXED') {
            packageCashTotal += (row.paidAmount || 0) / 2;
            packagePosTotal += (row.paidAmount || 0) / 2;
          }
        }
      });
      
      if (packageCashTotal > 0) {
        otherPaymentsMap.set('PAKET NAKİT', (otherPaymentsMap.get('PAKET NAKİT') || 0) + packageCashTotal);
      }
      if (packagePosTotal > 0) {
        otherPaymentsMap.set('PAKET POS', (otherPaymentsMap.get('PAKET POS') || 0) + packagePosTotal);
      }
      
      const processPlatformPayments = (
        data: EndOfDayPackageOrderRow[],
        platformLabel: string
      ) => {
        let plCash = 0, plPos = 0, plOnline = 0;
        const plOtherMap = new Map<string, number>();
        
        data.forEach(row => {
          if (row.status === 'CANCELLED') return;
          const amount = row.paidAmount || 0;
          
          if (row.paymentType === 'OTHER' && row.otherAmount && row.otherAmount > 0) {
            const label = row.paymentProviderName?.toUpperCase() || 'DİĞER';
            plOtherMap.set(label, (plOtherMap.get(label) || 0) + row.otherAmount);
          } else if (row.paymentType === 'ONLINE') {
            plOnline += amount;
          } else if (row.cashAmount && row.cashAmount > 0) {
            plCash += row.cashAmount;
            if (row.posAmount && row.posAmount > 0) plPos += row.posAmount;
          } else if (row.posAmount && row.posAmount > 0) {
            plPos += row.posAmount;
          } else if (row.paymentType === 'CASH') {
            plCash += amount;
          } else if (row.paymentType === 'POS') {
            plPos += amount;
          } else if (row.paymentType === 'MIXED') {
            plCash += amount / 2;
            plPos += amount / 2;
          }
        });
        
        if (plCash > 0) otherPaymentsMap.set(`${platformLabel} NAKİT`, (otherPaymentsMap.get(`${platformLabel} NAKİT`) || 0) + plCash);
        if (plPos > 0) otherPaymentsMap.set(`${platformLabel} POS`, (otherPaymentsMap.get(`${platformLabel} POS`) || 0) + plPos);
        if (plOnline > 0) otherPaymentsMap.set(`${platformLabel} ONLİNE`, (otherPaymentsMap.get(`${platformLabel} ONLİNE`) || 0) + plOnline);
        plOtherMap.forEach((amt, label) => {
          const key = `${platformLabel} ${label}`;
          otherPaymentsMap.set(key, (otherPaymentsMap.get(key) || 0) + amt);
        });
      };
      
      processPlatformPayments(getirOrderData, 'GETİR');
      processPlatformPayments(migrosOrderData, 'MİGROS');
      processPlatformPayments(ysOrderData, 'Y.SEPETİ');
      processPlatformPayments(trendyolOrderData, 'TRENDYOL');
      
      // Kiosk verilerinden ödeme hesaplama
      let kioskPosTotal = 0;
      
      kioskData.forEach(row => {
        if (row.status === 'CANCELLED') return;
        kioskPosTotal += row.paidAmount || 0;
      });
      
      // ✅ Kiosk POS'u otherPayments'a ekle (ayrı satır olarak göster)
      if (kioskPosTotal > 0) {
        otherPaymentsMap.set('KIOSK POS', (otherPaymentsMap.get('KIOSK POS') || 0) + kioskPosTotal);
      }
      
      console.log('🔍 [PRINT] Ödeme detayları:', {
        normalNakit: cashTotal,
        normalPos: posTotal,
        onlinePlatformlar: Object.fromEntries(onlinePaymentsMap),
        digerOdemeler: Object.fromEntries(otherPaymentsMap)
      });
      
      // Müşteri sayısı (filtrelenmiş kayıt toplamı)
      const customerCount = filteredRestaurantData.length + filteredQuickSaleData.length + kioskData.length + qrMenuData.length + packageOrderData.length + getirOrderData.length + migrosOrderData.length + ysOrderData.length + trendyolOrderData.length;
      
      // ✅ Restoran satışlarının InvoiceNumber'larını topla
      const restaurantInvoiceNumbers: string[] = [];
      filteredRestaurantData.forEach(row => {
        if (row.status === 'CANCELLED') return;
        const sale = completedSales.find(s => s.Id === Number(row.id));
        if (sale?.InvoiceNumber) {
          restaurantInvoiceNumbers.push(sale.InvoiceNumber);
        }
      });
      
      console.log('📊 [PRINT] Restoran InvoiceNumber sayısı:', restaurantInvoiceNumbers.length, 
        restaurantInvoiceNumbers.length > 0 ? restaurantInvoiceNumbers.slice(0, 3) : '');
      
      // ✅ Her iki API'yi paralel çağır
      const [quickSaleProductResponse, restaurantProductResponse] = await Promise.all([
        getProductSalesSummaryByInvoiceIds(invoiceIds),
        getProductSalesSummaryByInvoiceNumbers(restaurantInvoiceNumbers),
      ]);
      
      // ✅ İki API sonucunu birleştir
      const mergedProductMap = new Map<string, { unitPrice: number; totalQty: number; totalAmount: number }>();
      
      const addToMap = (items: ProductSalesSummaryItem[]) => {
        items.forEach(item => {
          const key = `${item.ProductName}__${item.UnitPrice}`;
          const existing = mergedProductMap.get(key);
          if (existing) {
            existing.totalQty += item.TotalQuantity;
            existing.totalAmount += item.TotalAmount;
          } else {
            mergedProductMap.set(key, {
              unitPrice: item.UnitPrice,
              totalQty: item.TotalQuantity,
              totalAmount: item.TotalAmount,
            });
          }
        });
      };
      
      addToMap(quickSaleProductResponse.Items || []);
      addToMap(restaurantProductResponse.Items || []);
      
      const productSalesItems: ProductSalesSummaryItem[] = 
        Array.from(mergedProductMap.entries()).map(([key, val]) => ({
          ProductName: key.split('__')[0],
          UnitPrice: val.unitPrice,
          TotalQuantity: val.totalQty,
          TotalAmount: val.totalAmount,
        })).sort((a, b) => b.TotalAmount - a.TotalAmount);
      
      console.log('📊 [PRINT] Ürün satış özeti:', {
        quickSaleItemCount: (quickSaleProductResponse.Items || []).length,
        restaurantItemCount: (restaurantProductResponse.Items || []).length,
        mergedItemCount: productSalesItems.length,
        totalRevenue: productSalesItems.reduce((s, i) => s + i.TotalAmount, 0),
      });
      
      // Platform sipariş sayıları ve toplamları
      // total         = net toplam (indirim sonrası, grandTotal)
      // originalTotal = brüt toplam (indirim öncesi). Row'da originalTotal
      //                 yoksa (eski/iptal/eşleşmeyen kayıt) grandTotal'e düşer.
      const calcPlatform = (data: EndOfDayPackageOrderRow[]) => {
        let count = 0, total = 0, originalTotal = 0;
        data.forEach(r => {
          if (r.status !== 'CANCELLED') {
            count++;
            total += r.grandTotal || 0;
            originalTotal += r.originalTotal ?? r.grandTotal ?? 0;
          }
        });
        return { count, total, originalTotal };
      };

      const otherMethodNames = ['MULTİNET', 'MULTINET', 'PLUXEE', 'TICKET', 'EDENRED', 'SETCARD', 'TOKENFLEX', 'METROPOL', 'PAYE'];
      
      const extractMethodName = (key: string): string | null => {
        const upper = key.toUpperCase();
        for (const method of otherMethodNames) {
          if (upper.includes(method)) return method === 'MULTİNET' ? 'MULTINET' : method;
        }
        return null;
      };
      
      const otherMethodTotalsMap = new Map<string, number>();
      const addToMethodTotals = (amount: number, key: string) => {
        const method = extractMethodName(key);
        if (method) {
          otherMethodTotalsMap.set(method, (otherMethodTotalsMap.get(method) || 0) + amount);
        }
      };
      
      otherPaymentsMap.forEach((amount, key) => addToMethodTotals(amount, key));
      onlinePaymentsMap.forEach((amount, key) => addToMethodTotals(amount, key));

      // İptal edilen adisyonları topla (restoran + hızlı satış)
      const cancelledOrders: Array<{ tableName: string; orderNumber: string; amount: number; waiterName?: string; notes?: string; closedAt?: string; source?: 'restaurant' | 'quickSale' }> = [];
      filteredRestaurantData.forEach(row => {
        if (row.status === 'CANCELLED') {
          cancelledOrders.push({
            tableName: row.tableName,
            orderNumber: row.orderNumber,
            amount: row.grandTotal || 0,
            waiterName: row.waiterName,
            notes: row.notes,
            closedAt: row.closedAt ? (typeof row.closedAt === 'string' ? row.closedAt : (row.closedAt as Date).toISOString()) : undefined,
            source: 'restaurant',
          });
        }
      });
      filteredQuickSaleData.forEach(row => {
        if (row.status === 'CANCELLED') {
          cancelledOrders.push({
            tableName: row.receiptNumber || row.referenceNumber || '-',
            orderNumber: row.referenceNumber || '',
            amount: row.grandTotal || 0,
            waiterName: row.cashierName || row.createdByName,
            notes: row.notes,
            closedAt: row.transactionDate ? (typeof row.transactionDate === 'string' ? row.transactionDate : (row.transactionDate as Date).toISOString()) : undefined,
            source: 'quickSale',
          });
        }
      });

      // Print data hazırla
      const printData: EndOfDayPrintData = {
        branchName: getSelectedBranchLabel(),
        cashierNames: Array.from(cashierSet),
        reportStartDate: startDate.toISOString(),
        reportEndDate: endDate.toISOString(),
        printDate: new Date().toISOString(),
        productSales: productSalesItems,
        totalRevenue: productSalesItems.reduce((sum, item) => sum + item.TotalAmount, 0),
        customerCount,
        paymentSummary: {
          cashTotal,
          posTotal,
          onlinePayments: Array.from(onlinePaymentsMap.entries()).map(([name, amount]) => ({ name, amount })),
          otherPayments: Array.from(otherPaymentsMap.entries()).map(([name, amount]) => ({ name, amount })),
        },
        grandTotal: (summary?.totalAmount || 0) - nonFiscalCashTotal,
        cancelledTotal: summary?.cancelledAmount || 0,
        cancelledOrders: cancelledOrders.length > 0 ? cancelledOrders : undefined,
        platformOrders: {
          getir: calcPlatform(getirOrderData),
          trendyol: calcPlatform(trendyolOrderData),
          yemeksepeti: calcPlatform(ysOrderData),
          migros: calcPlatform(migrosOrderData),
        },
        otherMethodTotals: Array.from(otherMethodTotalsMap.entries()).map(([name, amount]) => ({ name, amount })),
        posRefundTotal: summary?.posRefundAmount || 0,
        posRefundCount: summary?.posRefundCount || 0,
        prepaidTotal,
        prepaidCount: summary?.prepaidCount || 0,
        unpaidPlatformOrders: {
          package: { count: reconciliationData.package.unpaid.length, total: reconciliationData.package.unpaidTotal },
          getir: { count: reconciliationData.getir.unpaid.length, total: reconciliationData.getir.unpaidTotal },
          trendyol: { count: reconciliationData.trendyol.unpaid.length, total: reconciliationData.trendyol.unpaidTotal },
          yemeksepeti: { count: reconciliationData.yemeksepeti.unpaid.length, total: reconciliationData.yemeksepeti.unpaidTotal },
          migros: { count: reconciliationData.migros.unpaid.length, total: reconciliationData.migros.unpaidTotal },
        },
      };
      
      console.log('🖨️ [PRINT] Yazdırma verisi hazırlandı:', printData);
      
      // Yazdır
      printEndOfDayReceipt(printData);
      
    } catch (err: any) {
      console.error('Yazdırma hatası:', err);
      setError('Yazdırma sırasında bir hata oluştu: ' + err.message);
    } finally {
      setLoadingPrint(false);
    }
  };

  // Excel'e aktar - TÜM KANALLAR TEK EXCEL'DE
  const handleExportExcel = async () => {
    if (!dataLoaded) {
      setError('Lütfen önce verileri filtreleyin.');
      return;
    }

    setLoadingExport(true);
    
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Gün Sonu Raporu');
      
      let currentRow = 1;
      
      // ==================== ANA BAŞLIK ====================
      worksheet.mergeCells(`A${currentRow}:J${currentRow}`);
      const titleCell = worksheet.getCell(`A${currentRow}`);
      titleCell.value = 'GÜN SONU RAPORU';
      titleCell.style = {
        font: { bold: true, size: 18, color: { argb: 'FFFFFFFF' } },
        alignment: { horizontal: 'center', vertical: 'middle' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1565C0' } },
      };
      worksheet.getRow(currentRow).height = 30;
      currentRow++;
      
      // Tarih bilgisi
      worksheet.mergeCells(`A${currentRow}:J${currentRow}`);
      const dateCell = worksheet.getCell(`A${currentRow}`);
      dateCell.value = `${startDate ? formatDateTime(startDate) : ''} - ${endDate ? formatDateTime(endDate) : ''}`;
      dateCell.style = {
        font: { size: 12, italic: true },
        alignment: { horizontal: 'center' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE3F2FD' } },
      };
      currentRow++;
      
      // Şube bilgisi
      worksheet.mergeCells(`A${currentRow}:J${currentRow}`);
      const branchCell = worksheet.getCell(`A${currentRow}`);
      branchCell.value = `Şube: ${getSelectedBranchLabel()}`;
      branchCell.style = {
        font: { size: 11 },
        alignment: { horizontal: 'center' },
      };
      currentRow += 2;
      
      // ==================== ÖZET TABLOSU ====================
      worksheet.mergeCells(`A${currentRow}:C${currentRow}`);
      const summaryTitleCell = worksheet.getCell(`A${currentRow}`);
      summaryTitleCell.value = 'ÖDEME ÖZETİ';
      summaryTitleCell.style = {
        font: { bold: true, size: 14, color: { argb: 'FFFFFFFF' } },
        alignment: { horizontal: 'center' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF424242' } },
      };
      currentRow++;
      
      // Özet tablosu başlıkları
      const summaryHeaderRow = worksheet.getRow(currentRow);
      summaryHeaderRow.values = ['Ödeme Türü', 'Kasa / Banka', 'Tutar'];
      summaryHeaderRow.eachCell((cell, colNumber) => {
        if (colNumber <= 3) {
          cell.style = {
            font: { bold: true, color: { argb: 'FFFFFFFF' } },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF616161' } },
            alignment: { horizontal: 'center' },
            border: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            },
          };
        }
      });
      currentRow++;
      
      // Özet tablosu verileri (filtrelenmiş)
      filteredSummaryTableRows.forEach((row) => {
        const dataRow = worksheet.getRow(currentRow);
        dataRow.values = [row.paymentType, row.accountName || '-', formatCurrency(row.amount)];
        dataRow.eachCell((cell, colNumber) => {
          if (colNumber <= 3) {
            cell.style = {
              alignment: { horizontal: colNumber === 3 ? 'right' : 'left' },
              border: {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              },
              font: row.isTotal ? { bold: true } : undefined,
              fill: row.isTotal 
                ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBBDEFB' } } as ExcelJS.Fill
                : row.paymentType.includes('İptal')
                  ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFCDD2' } } as ExcelJS.Fill
                  : undefined,
            };
          }
        });
        currentRow++;
      });
      
      currentRow += 2; // Boşluk bırak
      
      // ==================== HELPER: Tablo Ekleme Fonksiyonu ====================
      const addDataTable = (
        title: string, 
        data: any[], 
        columns: typeof RESTAURANT_COLUMNS,
        headerColor: string,
        skipTurkeyOffset: boolean = false // ✅ Hızlı satış için true geç (zaten TR saatinde)
      ) => {
        if (data.length === 0) {
          // Boş tablo için sadece başlık ve "Kayıt Yok" mesajı
          worksheet.mergeCells(`A${currentRow}:J${currentRow}`);
          const sectionTitle = worksheet.getCell(`A${currentRow}`);
          sectionTitle.value = `${title} (0 kayıt)`;
          sectionTitle.style = {
            font: { bold: true, size: 13, color: { argb: 'FFFFFFFF' } },
            alignment: { horizontal: 'left' },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: headerColor } },
          };
          currentRow++;
          
          const emptyRow = worksheet.getRow(currentRow);
          emptyRow.values = ['Bu tarih aralığında kayıt bulunamadı.'];
          emptyRow.getCell(1).style = { font: { italic: true, color: { argb: 'FF757575' } } };
          currentRow += 2;
          return;
        }
        
        // Bölüm başlığı
        worksheet.mergeCells(`A${currentRow}:J${currentRow}`);
        const sectionTitle = worksheet.getCell(`A${currentRow}`);
        sectionTitle.value = `${title} (${data.length} kayıt)`;
        sectionTitle.style = {
          font: { bold: true, size: 13, color: { argb: 'FFFFFFFF' } },
          alignment: { horizontal: 'left' },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: headerColor } },
        };
        currentRow++;
        
        // Tablo başlıkları
        const headerRow = worksheet.getRow(currentRow);
        headerRow.values = columns.map(col => col.label);
        headerRow.eachCell((cell, colNumber) => {
          if (colNumber <= columns.length) {
            cell.style = {
              font: { bold: true, size: 10 },
              fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } },
              alignment: { horizontal: 'center' },
              border: {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              },
            };
          }
        });
        currentRow++;
        
        // Veri satırları
        data.forEach((row: any, index: number) => {
          const dataRow = worksheet.getRow(currentRow);
          const rowValues = columns.map(col => {
            const value = row[col.field];
            if (col.format === 'currency') return formatCurrency(value || 0);
            // ✅ skipTurkeyOffset true ise offset EKLEME (hızlı satış zaten TR saatinde)
            if (col.format === 'datetime') return value ? formatDateTime(value, !skipTurkeyOffset) : '-';
            if (col.format === 'duration') return formatDuration(value || 0);
            if (col.format === 'status') {
              if (value === 'PAID') return 'Ödendi';
              if (value === 'CANCELLED') return 'İptal';
              if (value === 'UNPAID') return 'Ödenmedi';
              if (value === 'PARTIAL') return 'Kısmi';
              return value || '-';
            }
            if (col.format === 'paymentType') {
              if (value === 'CASH') return 'Nakit';
              if (value === 'POS') return 'POS';
              if (value === 'MIXED') return 'Karma';
              if (value === 'OPEN_ACCOUNT') return 'Açık Hesap';
              if (value === 'ONLINE') return 'Online';
              if (value === 'OTHER') return 'Diğer';
              if (value === 'NONE') return '-';
              return value || '-';
            }
            return value || '-';
          });
          dataRow.values = rowValues;
          
          // Satır stilleri
          dataRow.eachCell((cell, colNumber) => {
            if (colNumber <= columns.length) {
              const isEvenRow = index % 2 === 0;
              const isCancelled = row.status === 'CANCELLED';
              cell.style = {
                font: { size: 9 },
                alignment: { horizontal: 'left' },
                border: {
                  top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                  left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                  bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                  right: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                },
                fill: isCancelled 
                  ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFEBEE' } } as ExcelJS.Fill
                  : isEvenRow 
                    ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } } as ExcelJS.Fill
                    : undefined,
              };
            }
          });
          currentRow++;
        });
        
        currentRow += 2; // Tablolar arası boşluk
      };
      
      // ==================== HIZLI SATIŞ TABLOSU ====================
      addDataTable('HIZLI SATIŞ', filteredQuickSaleData, QUICK_SALE_COLUMNS, 'FF9C27B0', true);
      
      // ==================== PAKET SİPARİŞ TABLOSU ====================
      addDataTable('PAKET SİPARİŞ', packageOrderData, PACKAGE_ORDER_COLUMNS, 'FF4CAF50', true);
      
      // ==================== RESTORAN TABLOSU ====================
      addDataTable('RESTORAN SATIŞLARI', filteredRestaurantData, RESTAURANT_COLUMNS, 'FF1976D2', false);
      
      // ==================== KIOSK TABLOSU ====================
      addDataTable('KIOSK', kioskData, KIOSK_COLUMNS, 'FF00ACC1', true);
      
      // ==================== GETİR SİPARİŞ TABLOSU ====================
      addDataTable('GETİR SİPARİŞ', getirOrderData, PACKAGE_ORDER_COLUMNS, 'FF7B1FA2', true);
      
      // ==================== MİGROS SİPARİŞ TABLOSU ====================
      addDataTable('MİGROS SİPARİŞ', migrosOrderData, PACKAGE_ORDER_COLUMNS, 'FFFF6F00', true);
      
      // ==================== YEMEKSEPETİ SİPARİŞ TABLOSU ====================
      addDataTable('YEMEKSEPETİ SİPARİŞ', ysOrderData, PACKAGE_ORDER_COLUMNS, 'FFFA0050', true);
      
      // ==================== TRENDYOL SİPARİŞ TABLOSU ====================
      addDataTable('TRENDYOL SİPARİŞ', trendyolOrderData, PACKAGE_ORDER_COLUMNS, 'FFFF6D00', true);
      
      // ==================== QR MENÜ TABLOSU ====================
      addDataTable('QR MENÜ', qrMenuData, QR_MENU_COLUMNS, 'FFFFA000');
      
      // ==================== SÜTUN GENİŞLİKLERİ ====================
      worksheet.columns = [
        { width: 8 },   // #
        { width: 18 },  // Tablo/Fiş No
        { width: 18 },  // Sipariş No
        { width: 12 },  // Durum
        { width: 14 },  // Ara Toplam
        { width: 14 },  // Toplam
        { width: 14 },  // Ödenen
        { width: 12 },  // Ödeme Türü
        { width: 18 },  // Kasa/Banka
        { width: 15 },  // Platform (Yemek Sepeti, Getir vb.)
        { width: 14 },  // İptal Tutar
        { width: 18 },  // Açılış
        { width: 18 },  // Kapanış
        { width: 10 },  // Süre
        { width: 20 },  // Garson/Kullanıcı
        { width: 20 },  // Cari
        { width: 18 },  // Fatura No
        { width: 15 },  // Şube
      ];
      
      // ==================== 2. SEKME: A4 YAZDIRMA ÖZETİ ====================
      const a4Sheet = workbook.addWorksheet('A4 Yazdırma Özeti');
      let a4Row = 1;
      
      // A4 sütun genişlikleri (7 sütun, A4 landscape'e sığacak şekilde)
      a4Sheet.columns = [
        { width: 6 },    // Sıra
        { width: 14 },   // Kanal
        { width: 22 },   // Fiş/Sipariş No
        { width: 10 },   // Durum
        { width: 14 },   // Toplam
        { width: 12 },   // Ödeme Türü
        { width: 18 },   // İşlem Tarihi
      ];
      
      // Sayfa ayarları (A4 landscape)
      a4Sheet.pageSetup = {
        paperSize: 9, // A4
        orientation: 'landscape',
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0, // sınırsız yükseklik
        margins: {
          left: 0.4, right: 0.4,
          top: 0.5, bottom: 0.5,
          header: 0.3, footer: 0.3,
        },
      };
      
      // Ana başlık
      a4Sheet.mergeCells(`A${a4Row}:G${a4Row}`);
      const a4Title = a4Sheet.getCell(`A${a4Row}`);
      a4Title.value = 'GÜN SONU RAPORU';
      a4Title.style = {
        font: { bold: true, size: 16 },
        alignment: { horizontal: 'center', vertical: 'middle' },
      };
      a4Sheet.getRow(a4Row).height = 28;
      a4Row++;
      
      // Tarih ve şube bilgisi
      a4Sheet.mergeCells(`A${a4Row}:G${a4Row}`);
      const a4DateCell = a4Sheet.getCell(`A${a4Row}`);
      a4DateCell.value = `${startDate ? formatDateTime(startDate) : ''} - ${endDate ? formatDateTime(endDate) : ''} | Şube: ${getSelectedBranchLabel()}`;
      a4DateCell.style = { font: { size: 10, italic: true }, alignment: { horizontal: 'center' } };
      a4Row += 2;
      
      // ==================== ÖDEME ÖZETİ (tüm işlemler tablosu ile aynı genişlikte) ====================
      a4Sheet.mergeCells(`A${a4Row}:G${a4Row}`);
      const a4SummaryTitle = a4Sheet.getCell(`A${a4Row}`);
      a4SummaryTitle.value = 'ÖDEME ÖZETİ';
      a4SummaryTitle.style = {
        font: { bold: true, size: 12, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF424242' } },
        alignment: { horizontal: 'left' },
      };
      a4Row++;
      
      // 3 sütunlu veri ama G'ye kadar genişlet: A-B merge (Ödeme Türü), C-E merge (Hesap), F-G merge (Tutar)
      const a4SummaryHeader = a4Sheet.getRow(a4Row);
      a4Sheet.mergeCells(`A${a4Row}:B${a4Row}`);
      a4Sheet.mergeCells(`C${a4Row}:E${a4Row}`);
      a4Sheet.mergeCells(`F${a4Row}:G${a4Row}`);
      a4SummaryHeader.getCell(1).value = 'Ödeme Türü';
      a4SummaryHeader.getCell(3).value = 'Hesap';
      a4SummaryHeader.getCell(6).value = 'Tutar';
      [1, 3, 6].forEach(col => {
        a4SummaryHeader.getCell(col).style = {
          font: { bold: true, size: 10 },
          fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } },
          alignment: { horizontal: 'center' },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        };
      });
      a4Row++;
      
      filteredSummaryTableRows.forEach((sRow) => {
        const sDataRow = a4Sheet.getRow(a4Row);
        a4Sheet.mergeCells(`A${a4Row}:B${a4Row}`);
        a4Sheet.mergeCells(`C${a4Row}:E${a4Row}`);
        a4Sheet.mergeCells(`F${a4Row}:G${a4Row}`);
        sDataRow.getCell(1).value = sRow.paymentType;
        sDataRow.getCell(3).value = sRow.accountName || '-';
        sDataRow.getCell(6).value = formatCurrency(sRow.amount);
        
        const cellStyle = {
          font: { size: 9, bold: sRow.isTotal ? true : false },
          border: { top: { style: 'thin' as const, color: { argb: 'FFE0E0E0' } }, left: { style: 'thin' as const, color: { argb: 'FFE0E0E0' } }, bottom: { style: 'thin' as const, color: { argb: 'FFE0E0E0' } }, right: { style: 'thin' as const, color: { argb: 'FFE0E0E0' } } },
          fill: sRow.isTotal
            ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBBDEFB' } } as ExcelJS.Fill
            : sRow.paymentType.includes('İptal')
              ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFCDD2' } } as ExcelJS.Fill
              : undefined,
        };
        sDataRow.getCell(1).style = { ...cellStyle, alignment: { horizontal: 'left' } };
        sDataRow.getCell(3).style = { ...cellStyle, alignment: { horizontal: 'left' } };
        sDataRow.getCell(6).style = { ...cellStyle, alignment: { horizontal: 'right' } };
        a4Row++;
      });
      a4Row += 2;
      
      // ==================== TÜM İŞLEMLER BİRLEŞTİRİLMİŞ (A4) ====================
      // Her kanal için veriyi kanal adıyla birlikte düz listeye dönüştür
      const a4Columns = ['Sıra', 'Kanal', 'Fiş / Sipariş No', 'Durum', 'Toplam', 'Ödeme', 'İşlem Tarihi'];
      
      interface A4Row {
        channel: string;
        receiptNo: string;
        status: string;
        total: number;
        paymentType: string;
        date: string;
      }
      
      const allA4Rows: A4Row[] = [];
      
      // Hızlı Satış (filtrelenmiş)
      filteredQuickSaleData.forEach(row => {
        allA4Rows.push({
          channel: 'Hızlı Satış',
          receiptNo: row.referenceNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.transactionDate ? formatDateTime(row.transactionDate as string, false) : '-',
        });
      });
      
      // Paket Sipariş
      packageOrderData.forEach(row => {
        allA4Rows.push({
          channel: 'Paket',
          receiptNo: row.orderNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.createdAt ? formatDateTime(row.createdAt as string, false) : '-',
        });
      });
      
      // Restoran (filtrelenmiş)
      filteredRestaurantData.forEach(row => {
        allA4Rows.push({
          channel: 'Restoran',
          receiptNo: row.orderNumber || row.tableName || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.closedAt ? formatDateTime(row.closedAt as string, true) : '-',
        });
      });
      
      // Kiosk
      kioskData.forEach(row => {
        allA4Rows.push({
          channel: 'Kiosk',
          receiptNo: row.referenceNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.transactionDate ? formatDateTime(row.transactionDate as string, false) : '-',
        });
      });
      
      // Getir Sipariş
      getirOrderData.forEach(row => {
        allA4Rows.push({
          channel: 'Getir',
          receiptNo: row.orderNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.createdAt ? formatDateTime(row.createdAt as string, false) : '-',
        });
      });

      // Migros Sipariş
      migrosOrderData.forEach(row => {
        allA4Rows.push({
          channel: 'Migros',
          receiptNo: row.orderNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.createdAt ? formatDateTime(row.createdAt as string, false) : '-',
        });
      });

      // Yemeksepeti Sipariş
      ysOrderData.forEach(row => {
        allA4Rows.push({
          channel: 'Y.Sepeti',
          receiptNo: row.orderNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.createdAt ? formatDateTime(row.createdAt as string, false) : '-',
        });
      });

      // Trendyol Sipariş
      trendyolOrderData.forEach(row => {
        allA4Rows.push({
          channel: 'Trendyol',
          receiptNo: row.orderNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.createdAt ? formatDateTime(row.createdAt as string, false) : '-',
        });
      });
      
      // QR Menü
      qrMenuData.forEach(row => {
        allA4Rows.push({
          channel: 'QR Menü',
          receiptNo: row.orderNumber || '-',
          status: row.status === 'PAID' ? 'Ödendi' : row.status === 'CANCELLED' ? 'İptal' : row.status === 'PARTIAL' ? 'Kısmi' : row.status === 'UNPAID' ? 'Ödenmedi' : row.status || '-',
          total: row.grandTotal || 0,
          paymentType: row.paymentType === 'CASH' ? 'Nakit' : row.paymentType === 'POS' ? 'POS' : row.paymentType === 'MIXED' ? 'Karma' : row.paymentType === 'OPEN_ACCOUNT' ? 'Açık Hesap' : row.paymentType === 'ONLINE' ? 'Online' : row.paymentType === 'OTHER' ? 'Diğer' : row.paymentType === 'NONE' ? 'Bilinmiyor' : row.paymentType || '-',
          date: row.transactionDate ? formatDateTime(row.transactionDate as string, false) : '-',
        });
      });
      
      // Tarihe göre sırala (en yeni en üstte)
      allA4Rows.sort((a, b) => {
        const dateA = a.date !== '-' ? new Date(a.date.split(' ').reverse().join(' ')).getTime() : 0;
        const dateB = b.date !== '-' ? new Date(b.date.split(' ').reverse().join(' ')).getTime() : 0;
        return dateB - dateA;
      });
      
      // Tablo başlığı
      a4Sheet.mergeCells(`A${a4Row}:G${a4Row}`);
      const a4DataTitle = a4Sheet.getCell(`A${a4Row}`);
      a4DataTitle.value = `TÜM İŞLEMLER (${allA4Rows.length} kayıt)`;
      a4DataTitle.style = {
        font: { bold: true, size: 12, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF37474F' } },
        alignment: { horizontal: 'left' },
      };
      a4Row++;
      
      // Tablo header
      const a4HeaderRow = a4Sheet.getRow(a4Row);
      a4HeaderRow.values = a4Columns;
      a4HeaderRow.eachCell((cell, colNumber) => {
        if (colNumber <= 7) {
          cell.style = {
            font: { bold: true, size: 10 },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } },
            alignment: { horizontal: 'center' },
            border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
          };
        }
      });
      a4Row++;
      
      // Kanal renkleri
      const channelColors: Record<string, string> = {
        'Hızlı Satış': 'FFE1BEE7',
        'Paket': 'FFC8E6C9',
        'Restoran': 'FFBBDEFB',
        'Kiosk': 'FFB2EBF2',
        'Getir': 'FFE1BEE7',
        'Migros': 'FFFFF3E0',
        'Y.Sepeti': 'FFFFEBEE',
        'QR Menü': 'FFFFF3E0',        // Turuncu açık
      };
      
      // Veri satırları
      allA4Rows.forEach((row, index) => {
        const dataRow = a4Sheet.getRow(a4Row);
        dataRow.values = [
          index + 1,
          row.channel,
          row.receiptNo,
          row.status,
          formatCurrency(row.total),
          row.paymentType,
          row.date,
        ];
        
        const isCancelled = row.status === 'İptal';
        const channelColor = channelColors[row.channel] || 'FFFFFFFF';
        
        dataRow.eachCell((cell, colNumber) => {
          if (colNumber <= 7) {
            cell.style = {
              font: { size: 9, color: isCancelled ? { argb: 'FFEF5350' } : undefined, strike: isCancelled },
              alignment: { horizontal: colNumber === 5 ? 'right' : 'left' },
              border: {
                top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                right: { style: 'thin', color: { argb: 'FFE0E0E0' } },
              },
              fill: isCancelled 
                ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFEBEE' } } as ExcelJS.Fill
                : colNumber === 2 
                  ? { type: 'pattern', pattern: 'solid', fgColor: { argb: channelColor } } as ExcelJS.Fill
                  : index % 2 === 0 
                    ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } } as ExcelJS.Fill
                    : undefined,
            };
          }
        });
        a4Row++;
      });
      
      // A4 sayfasının yazdırma başlığını tekrarla
      a4Sheet.headerFooter = {
        oddHeader: '&C&B&14GÜN SONU RAPORU',
        oddFooter: '&CSayfa &P / &N',
      };
      
      // Dosyayı indir
      const buffer = await workbook.xlsx.writeBuffer();
      const fileName = `Gun_Sonu_Raporu_${new Date().toISOString().split('T')[0]}.xlsx`;
      saveAs(new Blob([buffer]), fileName);
      
    } catch (err: any) {
      console.error('Excel export hatası:', err);
      setError(t('endOfDayReport.errors.excelCreateFailed'));
    } finally {
      setLoadingExport(false);
    }
  };

  // Tablo hücre değerini render et
  const renderCellValue = (row: any, column: TableColumnDef) => {
    const value = row[column.field];

    if (column.field === 'orderStatus') {
      return getOrderStatusLabel(value, t);
    }

    // İndirimsiz Toplam: platform listesinden eşleşemediyse Genel Toplam'a fallback
    if (column.field === 'originalTotal') {
      const fallback = Number(row.originalTotal ?? row.grandTotal ?? 0);
      return formatCurrency(fallback);
    }

    // İndirim: 0 ise gürültü olmaması için "-" göster
    if (column.field === 'discount') {
      const d = Number(row.discount ?? 0);
      return d > 0 ? formatCurrency(d) : '-';
    }

    switch (column.format) {
      case 'currency':
        return formatCurrency(value || 0);
      case 'datetime':
        // Hızlı satış (0), Paket (1), Kiosk (3), Getir (5), Migros (6), Trendyol (8) zaten Türkiye saatinde
        // Restoran (2), QR Menü (4) ve Yemeksepeti (7) UTC olarak geliyor, onlara +3 saat ekle
        const shouldAddOffset = activeTab === 2 || activeTab === 4 || activeTab === 7;
        return value ? formatDateTime(value, shouldAddOffset) : '-';
      case 'duration':
        return formatDuration(value || 0);
      case 'status':
        return getStatusChip(value as TransactionStatus, t);
      case 'paymentType':
        return getPaymentTypeChip(value as PaymentType, t);
      default:
        return value || '-';
    }
  };

  const getColumnLabel = (column: TableColumnDef): string => {
    const keyMap: Record<string, string> = {
      rowNumber: 'endOfDayReport.columns.rowNumber',
      tableName: 'endOfDayReport.columns.tableName',
      orderNumber: 'endOfDayReport.columns.orderNumber',
      status: 'endOfDayReport.columns.status',
      subtotal: 'endOfDayReport.columns.subtotal',
      grandTotal: 'endOfDayReport.columns.grandTotal',
      discount: 'endOfDayReport.columns.discount',
      paidAmount: 'endOfDayReport.columns.paidAmount',
      paymentType: 'endOfDayReport.columns.paymentType',
      cancelledTotal: 'endOfDayReport.columns.cancelledTotal',
      openedAt: 'endOfDayReport.columns.openedAt',
      closedAt: 'endOfDayReport.columns.closedAt',
      seatingDuration: 'endOfDayReport.columns.seatingDuration',
      waiterName: 'endOfDayReport.columns.waiterName',
      notes: 'endOfDayReport.columns.notes',
      receiptNumber: 'endOfDayReport.columns.receiptNumber',
      customerName: 'endOfDayReport.columns.customerName',
      invoiceNumber: 'endOfDayReport.columns.invoiceNumber',
      branchName: 'endOfDayReport.columns.branchName',
      screenName: 'endOfDayReport.columns.screenName',
      referenceNumber: 'endOfDayReport.columns.referenceNumber',
      paymentAccountName: 'endOfDayReport.columns.paymentAccountName',
      paymentProviderName: 'endOfDayReport.columns.paymentProviderName',
      transactionDate: 'endOfDayReport.columns.transactionDate',
      createdByName: 'endOfDayReport.columns.createdByName',
      kioskName: 'endOfDayReport.columns.kioskName',
      qrMenuName: 'endOfDayReport.columns.qrMenuName',
      shortCode: 'endOfDayReport.columns.shortCode',
      orderStatus: 'endOfDayReport.columns.orderStatus',
      createdAt: 'endOfDayReport.columns.createdAt',
      paymentDate: 'endOfDayReport.columns.paymentDate',
      customerPhone: 'endOfDayReport.columns.customerPhone',
      courierName: 'endOfDayReport.columns.courierName',
      cashierName: 'endOfDayReport.columns.cashierName',
    };
    const key = keyMap[column.field];
    return key ? t(key) : column.label;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
      <Box>
        {/* Üst Başlık */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 2, md: 0 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '100%', md: 'auto' } }}>
            <IconButton onClick={() => navigate(-1)} sx={{ mr: 1 }}>
              <ArrowBackIcon />
            </IconButton>
            <AssessmentIcon sx={{ fontSize: { xs: 28, md: 32 }, mr: 1.5, color: 'primary.main' }} />
            <Typography variant={isMobile ? 'h6' : 'h5'} component="h1" fontWeight="bold">
              {t('endOfDayReport.title')}
            </Typography>
          </Box>
          
          {/* Sağ Üst Butonlar */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Tooltip title={!dataLoaded ? t('endOfDayReport.tooltips.filterFirst') : totalAllChannelsCount === 0 ? t('endOfDayReport.tooltips.noRecordsInRange') : ''}>
              <span>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleEndOfDay}
                  disabled={!dataLoaded || loading || endOfDayProcessing || totalAllChannelsCount === 0}
                  startIcon={endOfDayProcessing ? <CircularProgress size={16} color="inherit" /> : <AssessmentIcon />}
                  size="small"
                >
                  {endOfDayProcessing ? t('endOfDayReport.common.processing') : t('endOfDayReport.actions.endOfDay')}
                </Button>
              </span>
            </Tooltip>
            <Tooltip title={t('endOfDayReport.actions.printReceipt80')}>
              <span>
                <IconButton
                  color="primary"
                  onClick={handlePrintReceipt}
                  disabled={!dataLoaded || loadingPrint}
                  size="small"
                  sx={{ 
                    bgcolor: 'primary.main', 
                    color: 'white',
                    '&:hover': { bgcolor: 'primary.dark' },
                    '&.Mui-disabled': { bgcolor: 'action.disabledBackground', color: 'action.disabled' }
                  }}
                >
                  {loadingPrint ? <CircularProgress size={20} color="inherit" /> : <PrintIcon />}
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title={t('endOfDayReport.actions.downloadExcel')}>
              <span>
                <IconButton
                  color="success"
                  onClick={handleExportExcel}
                  disabled={!dataLoaded || loadingExport}
                  size="small"
                  sx={{ 
                    bgcolor: 'success.main', 
                    color: 'white',
                    '&:hover': { bgcolor: 'success.dark' },
                    '&.Mui-disabled': { bgcolor: 'action.disabledBackground', color: 'action.disabled' }
                  }}
                >
                  {loadingExport ? <CircularProgress size={20} color="inherit" /> : <FileDownloadIcon />}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Box>

        {/* Filtreler - Sadeleştirilmiş */}
        <Box sx={{ mb: 2, position: 'relative' }}>
          <Grid container spacing={1} alignItems="center">
            {/* ✅ Son Gün Sonu Tarihi Bilgisi */}
            <Grid item xs="auto">
              <Paper 
                variant="outlined" 
                sx={{ 
                  px: 1, 
                  py: 0.5,
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: 0.5,
                  bgcolor: lastEndOfDayReport ? 'success.50' : 'grey.100',
                  borderColor: lastEndOfDayReport ? 'success.main' : 'grey.300',
                  height: '40px',
                }}
              >
                <EventRepeatIcon 
                  sx={{ fontSize: 16, flexShrink: 0 }}
                  color={lastEndOfDayReport ? 'success' : 'disabled'} 
                />
                <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                  {t('endOfDayReport.filters.lastEndOfDayLabel')}
                </Typography>
                <Typography 
                  variant="caption" 
                  fontWeight="bold" 
                  color={lastEndOfDayReport ? 'success.main' : 'text.secondary'}
                  sx={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}
                >
                  {lastEndOfDayReport 
                    ? formatDateTime(lastEndOfDayReport.endDate, false)
                    : t('endOfDayReport.filters.notDoneYet')}
                </Typography>
                <Tooltip title={t('endOfDayReport.filters.selectAfterLastEndOfDay')}>
                  <span>
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={handleApplyLastEndOfDayDate}
                      disabled={!lastEndOfDayReport}
                      sx={{ 
                        minWidth: 'auto', 
                        px: 1, 
                        py: 0.25,
                        fontSize: '0.7rem',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {t('endOfDayReport.actions.apply')}
                    </Button>
                  </span>
                </Tooltip>
              </Paper>
            </Grid>
            
            {/* Başlangıç Tarihi */}
            <Grid item xs={6} sm={4} md={2}>
              <DateTimePicker
                label={t('endOfDayReport.filters.startDate')}
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                slotProps={{
                  textField: { size: 'small', fullWidth: true },
                }}
                format="dd.MM.yyyy HH:mm"
              />
            </Grid>
            
            {/* Bitiş Tarihi */}
            <Grid item xs={6} sm={4} md={2}>
              <DateTimePicker
                label={t('endOfDayReport.filters.endDate')}
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                slotProps={{
                  textField: { size: 'small', fullWidth: true },
                }}
                format="dd.MM.yyyy HH:mm"
              />
            </Grid>
            
            {/* Şube Filtresi */}
            <Grid item xs={6} sm={4} md={2}>
              <Autocomplete
                multiple
                size="small"
                limitTags={2}
                disabled={isManager}
                options={isManager 
                  ? branches.filter(b => b.id === managerBranchId)
                  : branches.filter(b => b.id !== 'null')
                }
                getOptionLabel={(option) => option.name}
                value={branches.filter(b => selectedBranches.includes(b.id))}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(_, newValue) => {
                  if (isManager) return;
                  setSelectedBranches(newValue.map(v => v.id));
                  setSelectedScreenKeys([]); // Şube değişince ekran filtresini sıfırla
                  
                  setDataLoaded(false);
                  setRestaurantData([]);
                  setQuickSaleData([]);
                  setKioskData([]);
                  setQRMenuData([]);
                  setSummary(null);
                  setClubDepositSummary(null);
                }}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label={isManager ? t('endOfDayReport.filters.yourBranch') : t('endOfDayReport.filters.branch')}
                    placeholder={selectedBranches.length === 0 ? t('endOfDayReport.filters.allBranches') : undefined}
                    helperText={isManager ? t('endOfDayReport.filters.branchSelectionLocked') : (selectedBranches.length === 0 ? t('endOfDayReport.filters.allBranchesSelected') : undefined)}
                  />
                )}
                fullWidth
              />
            </Grid>

            {/* ✅ YENİ: Hızlı Satış + PYK Ekranı Filtresi (QuickSaleReceipts.ScreenId) — çoklu seçim */}
            <Grid item xs={6} sm={4} md={2}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                size="small"
                options={availableQuickSaleScreens}
                getOptionLabel={(option) => option.name}
                value={availableQuickSaleScreens.filter(s => selectedScreenKeys.includes(s.key))}
                isOptionEqualToValue={(option, value) => option.key === value.key}
                onChange={(_, newValue) => {
                  setSelectedScreenKeys(newValue.map(v => v.key));
                  setPage(0);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t('endOfDayReport.filters.quickSaleScreen', 'Hızlı Satış / PYK Ekranı')}
                    placeholder={selectedScreenKeys.length === 0 ? t('endOfDayReport.filters.allScreens', 'Tüm Ekranlar') : undefined}
                    helperText={selectedScreenKeys.length === 0 ? t('endOfDayReport.filters.allScreensSelected', 'Tüm ekranlar') : undefined}
                  />
                )}
                fullWidth
              />
            </Grid>
            
            {/* Filtrele Butonu */}
            <Grid item xs={6} sm={4} md={1.5}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFilter}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={16} /> : <FilterListIcon />}
                size="small"
                fullWidth
                sx={{ height: '40px', minWidth: 0, px: 1 }}
              >
                {loading ? t('endOfDayReport.common.loading') : t('endOfDayReport.actions.filter')}
              </Button>
            </Grid>
          </Grid>
          {/* ÖKC Filtresi (gizli toggle - en sağda) */}
          <Box sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)' }}>
            <Switch
              size="small"
              checked={filterFiscalOnly}
              onChange={(e) => setFilterFiscalOnly(e.target.checked)}
              sx={{ opacity: 0.15, '&:hover': { opacity: 1 }, transition: 'opacity 0.3s' }}
            />
          </Box>
        </Box>

        {/* Hata Mesajı */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Veri yüklenmeden önce bilgi mesajı */}
        {!dataLoaded && !loading && (
          <Box sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            justifyContent: 'center',
            height: '400px',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf2 100%)',
            borderRadius: 2
          }}>
            <AssessmentIcon sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" component="h2" gutterBottom color="primary.main" fontWeight="bold">
              {t('endOfDayReport.title')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('endOfDayReport.emptyState.beforeFilter')}
            </Typography>
          </Box>
        )}

        {/* Yükleniyor */}
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress size={60} />
          </Box>
        )}

        {/* Veri yüklendikten sonra */}
        {dataLoaded && !loading && (
          <>
            {/* ✅ Özet Tablosu (Tüm kanalların birleşik özeti) */}
            {filteredSummaryTableRows.length > 0 && (
              <Box 
                sx={{ 
                  mb: 2, 
                  overflowX: 'auto', 
                  border: '1px solid', 
                  borderColor: 'divider', 
                  borderRadius: 1,
                  bgcolor: 'background.paper',
                }}
              >
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell 
                        sx={{ 
                          fontWeight: 'bold', 
                          backgroundColor: 'grey.800', 
                          color: 'white',
                          width: '25%',
                        }}
                      >
                        {t('endOfDayReport.summaryTable.paymentType')}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontWeight: 'bold', 
                          backgroundColor: 'grey.800', 
                          color: 'white',
                          width: '45%',
                        }}
                      >
                        {t('endOfDayReport.summaryTable.cashBank')}
                      </TableCell>
                      <TableCell 
                        align="right"
                        sx={{ 
                          fontWeight: 'bold', 
                          backgroundColor: 'grey.800', 
                          color: 'white',
                          width: '30%',
                        }}
                      >
                        {t('endOfDayReport.summaryTable.amount')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredSummaryTableRows.map((row, index) => {
                      const isPlatformDiscount = row.paymentType === 'Platform Discount' || row.paymentType === 'Quick Sale Discount';
                      return (
                      <TableRow 
                        key={index}
                        sx={{
                          backgroundColor: row.isTotal 
                            ? 'primary.50' 
                            : row.paymentType.includes('Cancelled') 
                              ? 'error.50' 
                              : isPlatformDiscount
                                ? 'info.50'
                                : 'inherit',
                          '&:hover': {
                            backgroundColor: row.isTotal ? 'primary.100' : 'action.hover',
                          },
                        }}
                      >
                        <TableCell 
                          sx={{ 
                            fontWeight: row.isTotal || isPlatformDiscount ? 'bold' : 'normal',
                            color: row.paymentType.includes('Cancelled')
                              ? 'error.main'
                              : row.paymentType === 'Unknown'
                                ? 'warning.main'
                                : isPlatformDiscount
                                  ? 'info.dark'
                                  : 'inherit',
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {row.paymentType === 'Cash' && <AttachMoneyIcon fontSize="small" color="success" />}
                            {row.paymentType === 'POS' && <CreditCardIcon fontSize="small" color="primary" />}
                            {row.paymentType === 'Prepaid' && <AccountBalanceWalletIcon fontSize="small" color="info" />}
                            {row.paymentType === 'Open Account' && <AccountBalanceWalletIcon fontSize="small" color="warning" />}
                            {row.paymentType === 'Unknown' && <WarningAmberIcon fontSize="small" color="warning" />}
                            {row.paymentType.includes('Cancelled') && <CancelIcon fontSize="small" color="error" />}
                            {isPlatformDiscount && <LocalOfferIcon fontSize="small" color="info" />}
                            {row.paymentType === 'GRAND TOTAL' && <ReceiptLongIcon fontSize="small" color="primary" />}
                            {getSummaryPaymentTypeLabel(row.paymentType)}
                          </Box>
                        </TableCell>
                        <TableCell 
                          sx={{ 
                            fontWeight: row.isTotal ? 'bold' : 'normal',
                          }}
                        >
                          {row.accountName || '-'}
                        </TableCell>
                        <TableCell 
                          align="right"
                          sx={{ 
                            fontWeight: row.isTotal || isPlatformDiscount ? 'bold' : 'normal',
                            color: row.paymentType.includes('Cancelled')
                              ? 'error.main'
                              : row.paymentType === 'Unknown'
                                ? 'warning.main'
                                : isPlatformDiscount
                                  ? 'info.dark'
                                  : row.isTotal
                                    ? 'primary.main'
                                    : 'inherit',
                            fontSize: row.isTotal ? '1.1rem' : 'inherit',
                          }}
                        >
                          {isPlatformDiscount ? `-${formatCurrency(row.amount)}` : formatCurrency(row.amount)}
                        </TableCell>
                      </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* Kulüp Giriş Depozitoları — satış cirosuna DAHİL DEĞİLDİR (emanet tutar) */}
            {clubDepositSummary && (clubDepositSummary.collectedCount > 0 || clubDepositSummary.refundedCount > 0) && (
              <Box
                sx={{
                  mb: 2,
                  overflowX: 'auto',
                  border: '1px solid',
                  borderColor: 'info.light',
                  borderRadius: 1,
                  bgcolor: 'background.paper',
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2} sx={{ fontWeight: 'bold', backgroundColor: 'info.dark', color: 'white' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <AccountBalanceWalletIcon fontSize="small" />
                          Kulüp Giriş Depozitoları (ciroya dahil değildir)
                        </Box>
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold', backgroundColor: 'info.dark', color: 'white' }}>
                        Tutar
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ pl: 4 }}>Alınan Depozito (Nakit)</TableCell>
                      <TableCell sx={{ color: 'text.secondary' }}>{clubDepositSummary.collectedCount} kart</TableCell>
                      <TableCell align="right">{formatCurrency(clubDepositSummary.collectedCash)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ pl: 4 }}>Alınan Depozito (POS)</TableCell>
                      <TableCell />
                      <TableCell align="right">{formatCurrency(clubDepositSummary.collectedPos)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ pl: 4, fontWeight: 'medium' }}>Alınan Toplam</TableCell>
                      <TableCell />
                      <TableCell align="right" sx={{ fontWeight: 'medium' }}>{formatCurrency(clubDepositSummary.collectedTotal)}</TableCell>
                    </TableRow>
                    <TableRow sx={{ bgcolor: 'warning.50' }}>
                      <TableCell sx={{ pl: 4, color: 'warning.dark' }}>İade Edilen Depozito</TableCell>
                      <TableCell sx={{ color: 'text.secondary' }}>{clubDepositSummary.refundedCount} kart</TableCell>
                      <TableCell align="right" sx={{ color: 'warning.dark' }}>-{formatCurrency(clubDepositSummary.refundedTotal)}</TableCell>
                    </TableRow>
                    <TableRow sx={{ bgcolor: 'info.50' }}>
                      <TableCell sx={{ pl: 4, fontWeight: 'bold', color: 'info.dark' }}>Kalan (Net) Depozito</TableCell>
                      <TableCell />
                      <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark', fontSize: '1.05rem' }}>
                        {formatCurrency(clubDepositSummary.netTotal)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            )}

            {/* ✅ YENİ: Tab Sistemi - Satış Kanalları */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
              <Tabs 
                value={activeTab} 
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  '& .MuiTab-root': {
                    minHeight: 48,
                    textTransform: 'none',
                    fontWeight: 600,
                  },
                }}
              >
                {[
                  { key: 'quickSale', icon: <PointOfSaleIcon />, name: t('endOfDayReport.tabs.quickSale'), count: filteredQuickSaleData.length },
                  { key: 'package', icon: <LocalShippingIcon />, name: t('endOfDayReport.tabs.package'), count: packageOrderData.length },
                  { key: 'restaurant', icon: <RestaurantIcon />, name: t('endOfDayReport.tabs.restaurant'), count: filteredRestaurantData.length },
                  { key: 'kiosk', icon: <TabletAndroidIcon />, name: t('endOfDayReport.tabs.kiosk'), count: kioskData.length },
                  { key: 'qrMenu', icon: <QrCodeIcon />, name: t('endOfDayReport.tabs.qrMenu'), count: qrMenuData.length },
                  { key: 'getir', icon: <LocalShippingIcon />, name: t('endOfDayReport.tabs.getir'), count: getirOrderData.length },
                  { key: 'migros', icon: <LocalShippingIcon />, name: t('endOfDayReport.tabs.migros'), count: migrosOrderData.length },
                  { key: 'yemeksepeti', icon: <LocalShippingIcon />, name: t('endOfDayReport.tabs.yemeksepeti'), count: ysOrderData.length },
                  { key: 'trendyol', icon: <LocalShippingIcon />, name: t('endOfDayReport.tabs.trendyol'), count: trendyolOrderData.length },
                ].map(({ key, icon, name, count }) => {
                  const rec = reconciliationData[key];
                  const hasUnpaid = rec && rec.unpaid.length > 0;
                  const hasWarning = rec && rec.warnings.length > 0;
                  return (
                    <Tab
                      key={key}
                      icon={icon}
                      iconPosition="start"
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, pr: 1 }}>
                          <span>{name}</span>
                          {dataLoaded && count > 0 && (
                            <Badge badgeContent={count} color="secondary" max={999}><Box sx={{ width: 8 }} /></Badge>
                          )}
                          {/* Sağlama badge'leri - GİZLENDİ (ileride tekrar açılabilir) */}
                          {false && dataLoaded && rec && (
                            <Box sx={{ display: 'flex', gap: 0.3, ml: 0.5 }}>
                              {rec.paid.length > 0 && (
                                <Chip label={rec.paid.length} size="small" color="success" sx={{ height: 18, fontSize: '0.7rem', fontWeight: 700, '& .MuiChip-label': { px: 0.5 } }} />
                              )}
                              {hasUnpaid && (
                                <Chip label={rec.unpaid.length} size="small" color="warning" sx={{ height: 18, fontSize: '0.7rem', fontWeight: 700, '& .MuiChip-label': { px: 0.5 } }} />
                              )}
                              {rec.cancelled.length > 0 && (
                                <Chip label={rec.cancelled.length} size="small" color="error" sx={{ height: 18, fontSize: '0.7rem', fontWeight: 700, '& .MuiChip-label': { px: 0.5 } }} />
                              )}
                              {hasWarning && (
                                <Chip label={`!${rec.warnings.length}`} size="small" color="error" variant="outlined" sx={{ height: 18, fontSize: '0.7rem', fontWeight: 700, '& .MuiChip-label': { px: 0.5 } }} />
                              )}
                            </Box>
                          )}
                          {!dataLoaded && (
                            <Badge badgeContent={count} color="secondary" max={999}><Box sx={{ width: 8 }} /></Badge>
                          )}
                        </Box>
                      }
                    />
                  );
                })}
              </Tabs>
            </Box>

            {/* Aktif Tab'ın Tablosu */}
            <Box sx={{ overflowX: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
               <Table size="small">
                  <TableHead>
                    <TableRow>
                      {activeColumns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align || 'left'}
                          sx={{
                            fontWeight: 'bold',
                            backgroundColor: 'primary.main',
                            color: 'white',
                            whiteSpace: 'nowrap',
                            minWidth: column.width,
                          }}
                        >
                          {getColumnLabel(column)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.length === 0 ? (
                      <TableRow>
                        <TableCell 
                          colSpan={activeColumns.length}
                          align="center"
                          sx={{ py: 4 }}
                        >
                          <Typography color="text.secondary">
                            {t('endOfDayReport.emptyState.noDataInDateRange')}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      paginatedData.map((row: any, index) => {
                        // Tab 0 (Hızlı Satış) ve tab 2 (Restoran) her zaman tıklanabilir.
                        // Yemek platformu tab'larında (5=Getir, 6=Migros, 7=Yemeksepeti, 8=Trendyol)
                        // sadece platform sipariş ID'si propagate edilebilen satırlar tıklanabilir.
                        const isClickable =
                          activeTab === 0 ||
                          activeTab === 2 ||
                          (activeTab === 1 && !!row.packageOrderId) ||
                          (activeTab === 5 && !!row.getirOrderId) ||
                          (activeTab === 6 && !!row.migrosOrderId) ||
                          (activeTab === 7 && !!row.yemeksepetiOrderId) ||
                          (activeTab === 8 && !!row.trendyolOrderId);
                        const hoverColor =
                          activeTab === 0 ? 'secondary.50' :
                          activeTab === 2 ? 'primary.50' :
                          activeTab === 1 ? 'success.50' :
                          'info.50';
                        const hoverShadowColor =
                          activeTab === 0 ? 'secondary.main' :
                          activeTab === 2 ? 'primary.main' :
                          activeTab === 1 ? 'success.main' :
                          'info.main';
                        return (
                        <TableRow
                          key={row.id}
                          hover
                          onClick={() => handleRowClick(row)}
                          sx={{
                            cursor: isClickable ? 'pointer' : 'default',
                            '&:nth-of-type(odd)': {
                              backgroundColor: 'action.hover',
                            },
                            '&:hover': isClickable ? {
                              backgroundColor: hoverColor,
                              boxShadow: 'inset 0 0 0 2px',
                              boxShadowColor: hoverShadowColor,
                            } : {},
                          }}
                        >
                          {activeColumns.map((column) => (
                            <TableCell
                              key={`${row.id}-${column.id}`}
                              align={column.align || 'left'}
                              sx={{ whiteSpace: 'nowrap' }}
                            >
                              {renderCellValue(row, column)}
                            </TableCell>
                          ))}
                        </TableRow>
                        );
                      })
                    )}
                    {/* ✅ GENEL TOPLAM SATIRI */}
                    {totalDataCount > 0 && (
                      <TableRow
                        sx={{
                          backgroundColor: 'primary.dark',
                          position: 'sticky',
                          bottom: 0,
                          '& td': {
                            fontWeight: 'bold',
                            color: 'white',
                            borderTop: '2px solid',
                            borderColor: 'primary.main',
                          },
                        }}
                      >
                        {activeColumns.map((column) => {
                          // grandTotal sütunu
                          if (column.field === 'grandTotal') {
                            return (
                              <TableCell
                                key={`total-${column.id}`}
                                align="right"
                                sx={{ 
                                  fontWeight: 'bold', 
                                  color: 'white !important',
                                  fontSize: '0.95rem',
                                }}
                              >
                                {formatCurrency(tableGrandTotals.grandTotal)}
                              </TableCell>
                            );
                          }
                          // discount sütunu (Toplam İndirim)
                          if (column.field === 'discount') {
                            return (
                              <TableCell
                                key={`total-${column.id}`}
                                align="right"
                                sx={{
                                  fontWeight: 'bold',
                                  color: 'white !important',
                                  fontSize: '0.95rem',
                                }}
                              >
                                {tableGrandTotals.discount > 0 ? formatCurrency(tableGrandTotals.discount) : '-'}
                              </TableCell>
                            );
                          }
                          // originalTotal sütunu (İndirimsiz Toplam)
                          if (column.field === 'originalTotal') {
                            return (
                              <TableCell
                                key={`total-${column.id}`}
                                align="right"
                                sx={{
                                  fontWeight: 'bold',
                                  color: 'white !important',
                                  fontSize: '0.95rem',
                                }}
                              >
                                {formatCurrency(tableGrandTotals.originalTotal)}
                              </TableCell>
                            );
                          }
                          // paidAmount sütunu
                          if (column.field === 'paidAmount') {
                            return (
                              <TableCell
                                key={`total-${column.id}`}
                                align="right"
                                sx={{ 
                                  fontWeight: 'bold', 
                                  color: 'white !important',
                                  fontSize: '0.95rem',
                                }}
                              >
                                {formatCurrency(tableGrandTotals.paidAmount)}
                              </TableCell>
                            );
                          }
                          // rowNumber sütunu - "TOPLAM" yazısı
                          if (column.field === 'rowNumber') {
                            return (
                              <TableCell
                                key={`total-${column.id}`}
                                align="center"
                                sx={{ 
                                  fontWeight: 'bold', 
                                  color: 'white !important',
                                  fontSize: '0.85rem',
                                }}
                              >
                                {t('endOfDayReport.summaryTable.total')}
                              </TableCell>
                            );
                          }
                          // tableName/referenceNumber/orderNumber sütunu - satır sayısı bilgisi
                          if (['tableName', 'referenceNumber', 'orderNumber'].includes(column.field)) {
                            return (
                              <TableCell
                                key={`total-${column.id}`}
                                align="left"
                                sx={{ 
                                  fontWeight: 'bold', 
                                  color: 'white !important',
                                  fontSize: '0.85rem',
                                }}
                              >
                                {t('endOfDayReport.summaryTable.receiptsCount', { count: tableGrandTotals.validRowCount })}
                              </TableCell>
                            );
                          }
                          // Diğer sütunlar boş
                          return (
                            <TableCell
                              key={`total-${column.id}`}
                              align={column.align || 'left'}
                            >
                              &nbsp;
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
              
              <TablePagination
                component="div"
                count={totalDataCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage={t('endOfDayReport.pagination.rowsPerPage')}
                labelDisplayedRows={({ from, to, count }) => t('endOfDayReport.pagination.displayedRows', { from, to, count })}
                sx={{ borderTop: '1px solid', borderColor: 'divider' }}
              />

            {/* Sağlama Alt-Tabloları - GİZLENDİ (ileride tekrar açılabilir) */}
            {false && dataLoaded && (
              <Box sx={{ mt: 2 }}>
                {activeTab === 0 && <ReconciliationSubTables reconciliation={reconciliationData.quickSale} platformName="Hızlı Satış" />}
                {activeTab === 1 && <ReconciliationSubTables reconciliation={reconciliationData.package} platformName="Paket Sipariş" />}
                {activeTab === 2 && <ReconciliationSubTables reconciliation={reconciliationData.restaurant} platformName="Restoran" />}
                {activeTab === 3 && <ReconciliationSubTables reconciliation={reconciliationData.kiosk} platformName="Kiosk" />}
                {activeTab === 5 && <ReconciliationSubTables reconciliation={reconciliationData.getir} platformName="Getir" />}
                {activeTab === 6 && <ReconciliationSubTables reconciliation={reconciliationData.migros} platformName="Migros" />}
                {activeTab === 7 && <ReconciliationSubTables reconciliation={reconciliationData.yemeksepeti} platformName="Y.Sepeti" />}
                {activeTab === 8 && <ReconciliationSubTables reconciliation={reconciliationData.trendyol} platformName="Trendyol" />}
              </Box>
            )}
            
            {/* ✅ YENI: Hizli Satis tab'i icin Oturumu Acik (Bakiyeli) Kartlar.
                Restoran tab'indaki "Acik Masalar" tablosunun karsiligi; gun sonuna
                DAHIL DEGILDIR, sadece bilgi amaclidir. Siparis tablosu ile urun
                ozeti tablosunun arasinda konumlanir. */}
            {activeTab === 0 && (openCardSessions.length > 0 || loadingOpenCardSessions) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'info.50', border: '1px solid', borderColor: 'info.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => setShowOpenCardSessions(!showOpenCardSessions)}
                >
                  <Typography variant="subtitle1" color="info.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CreditCardIcon fontSize="small" />
                    {t('endOfDayReport.openCardSessions.title')} ({t('endOfDayReport.openCardSessions.notIncludedInEndOfDay')}) - {loadingOpenCardSessions ? '...' : openCardSessions.length} {t('endOfDayReport.openCardSessions.countSuffix')}
                    {loadingOpenCardSessions && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="info" />
                    )}
                  </Typography>
                  <IconButton size="small" color="info">
                    {showOpenCardSessions ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showOpenCardSessions}>
                  {openCardSessions.length === 0 && loadingOpenCardSessions ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="info" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ mt: 1.5, bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'info.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.openCardSessions.columns.cardNumber')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.openCardSessions.columns.cardUid')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.openCardSessions.columns.account')}</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.openCardSessions.columns.cardType')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.openCardSessions.columns.remainingBalance')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {openCardSessions.map((card, idx) => {
                            const accountName = card.accountName || card.activeSession?.accountName || '-';
                            const balance = Number(card.totalBalance) || 0;
                            return (
                              <TableRow key={card.id ?? idx} hover>
                                <TableCell>{idx + 1}</TableCell>
                                <TableCell>
                                  <Typography variant="body2" fontWeight="bold" color="info.dark">
                                    {card.cardNumber || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                                    {card.cardUID || '-'}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">{accountName}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2" color="text.secondary">{card.cardTypeName || '-'}</Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2" fontWeight="bold" color="success.main">
                                    {formatCurrency(balance)}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          {/* TOPLAM SATIRI (bilgi amaçlı — gün sonuna dahil değildir) */}
                          <TableRow sx={{ bgcolor: 'info.100' }}>
                            <TableCell colSpan={5} sx={{ fontWeight: 'bold', color: 'info.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>
                              {formatCurrency(openCardSessions.reduce((s, c) => s + (Number(c.totalBalance) || 0), 0))}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* ✅ YENI: Hizli Satis tab'i icin Urun Bazinda Satis Ozeti */}
            {activeTab === 0 && (quickSaleProductSummary.length > 0 || loadingQuickSaleProducts) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'success.50', border: '1px solid', borderColor: 'success.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowQuickSaleProductSummary(!showQuickSaleProductSummary)}
                >
                  <Typography variant="subtitle1" color="success.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {loadingQuickSaleProducts ? '...' : quickSaleProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                    {loadingQuickSaleProducts && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="success" />
                    )}
                  </Typography>
                  <IconButton size="small" color="success">
                    {showQuickSaleProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showQuickSaleProductSummary}>
                  {quickSaleProductSummary.length === 0 && loadingQuickSaleProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="success" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'success.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {quickSaleProductSummary.map((p, idx) => (
                            <TableRow key={`${p.name}-${idx}`} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="medium">
                                  {p.name}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="success.dark">
                                  {p.quantity}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatCurrency(p.totalRevenue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">—</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* TOPLAM SATIRI */}
                          <TableRow sx={{ bgcolor: 'success.100' }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {quickSaleProductSummary.reduce((s, p) => s + p.quantity, 0)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {formatCurrency(quickSaleProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              —
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* Paket Sipariş tab'ı için Ürün Bazında Satış Özeti — Hızlı Satış ile
                birebir aynı pattern (aynı API, aynı UI). orderCount aggregated
                API'sinde olmadığı için "—" gösterilir. */}
            {activeTab === 1 && (packageProductSummary.length > 0 || loadingPackageProducts) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'success.50', border: '1px solid', borderColor: 'success.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowPackageProductSummary(!showPackageProductSummary)}
                >
                  <Typography variant="subtitle1" color="success.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {loadingPackageProducts ? '...' : packageProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                    {loadingPackageProducts && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="success" />
                    )}
                  </Typography>
                  <IconButton size="small" color="success">
                    {showPackageProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showPackageProductSummary}>
                  {packageProductSummary.length === 0 && loadingPackageProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="success" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'success.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {packageProductSummary.map((p, idx) => (
                            <TableRow key={`${p.name}-${idx}`} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="medium">
                                  {p.name}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="success.dark">
                                  {p.quantity}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatCurrency(p.totalRevenue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">—</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* TOPLAM SATIRI */}
                          <TableRow sx={{ bgcolor: 'success.100' }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {packageProductSummary.reduce((s, p) => s + p.quantity, 0)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {formatCurrency(packageProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              —
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* Getir tab'ı için Ürün Bazında Satış Özeti — Paket / Hızlı Satış
                ile aynı pattern (aynı API, aynı UI). orderCount aggregated
                API'sinde olmadığı için "—" gösterilir. */}
            {activeTab === 5 && (getirProductSummary.length > 0 || loadingGetirProducts) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'success.50', border: '1px solid', borderColor: 'success.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowGetirProductSummary(!showGetirProductSummary)}
                >
                  <Typography variant="subtitle1" color="success.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {loadingGetirProducts ? '...' : getirProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                    {loadingGetirProducts && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="success" />
                    )}
                  </Typography>
                  <IconButton size="small" color="success">
                    {showGetirProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showGetirProductSummary}>
                  {getirProductSummary.length === 0 && loadingGetirProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="success" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'success.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {getirProductSummary.map((p, idx) => (
                            <TableRow key={`${p.name}-${idx}`} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="medium">
                                  {p.name}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="success.dark">
                                  {p.quantity}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatCurrency(p.totalRevenue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">—</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* TOPLAM SATIRI */}
                          <TableRow sx={{ bgcolor: 'success.100' }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {getirProductSummary.reduce((s, p) => s + p.quantity, 0)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              {formatCurrency(getirProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                              —
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* Migros (tab 6) — ürün bazlı satış özeti, turuncu (warning) tema */}
            {activeTab === 6 && (migrosProductSummary.length > 0 || loadingMigrosProducts) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'warning.50', border: '1px solid', borderColor: 'warning.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowMigrosProductSummary(!showMigrosProductSummary)}
                >
                  <Typography variant="subtitle1" color="warning.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {loadingMigrosProducts ? '...' : migrosProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                    {loadingMigrosProducts && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="warning" />
                    )}
                  </Typography>
                  <IconButton size="small" color="warning">
                    {showMigrosProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showMigrosProductSummary}>
                  {migrosProductSummary.length === 0 && loadingMigrosProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="warning" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'warning.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {migrosProductSummary.map((p, idx) => (
                            <TableRow key={`${p.name}-${idx}`} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="medium">
                                  {p.name}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="warning.dark">
                                  {p.quantity}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatCurrency(p.totalRevenue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">—</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* TOPLAM SATIRI */}
                          <TableRow sx={{ bgcolor: 'warning.100' }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'warning.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>
                              {migrosProductSummary.reduce((s, p) => s + p.quantity, 0)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>
                              {formatCurrency(migrosProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>
                              —
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* Yemeksepeti (tab 7) — ürün bazlı satış özeti, kırmızı (error) tema */}
            {activeTab === 7 && (ysProductSummary.length > 0 || loadingYsProducts) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'error.50', border: '1px solid', borderColor: 'error.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowYsProductSummary(!showYsProductSummary)}
                >
                  <Typography variant="subtitle1" color="error.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {loadingYsProducts ? '...' : ysProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                    {loadingYsProducts && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="error" />
                    )}
                  </Typography>
                  <IconButton size="small" color="error">
                    {showYsProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showYsProductSummary}>
                  {ysProductSummary.length === 0 && loadingYsProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="error" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'error.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'error.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'error.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'error.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'error.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'error.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {ysProductSummary.map((p, idx) => (
                            <TableRow key={`${p.name}-${idx}`} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="medium">
                                  {p.name}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="error.dark">
                                  {p.quantity}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatCurrency(p.totalRevenue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">—</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* TOPLAM SATIRI */}
                          <TableRow sx={{ bgcolor: 'error.100' }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'error.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'error.dark' }}>
                              {ysProductSummary.reduce((s, p) => s + p.quantity, 0)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'error.dark' }}>
                              {formatCurrency(ysProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'error.dark' }}>
                              —
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* Trendyol (tab 8) — ürün bazlı satış özeti, mavi (info) tema */}
            {activeTab === 8 && (trendyolProductSummary.length > 0 || loadingTrendyolProducts) && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'info.50', border: '1px solid', borderColor: 'info.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowTrendyolProductSummary(!showTrendyolProductSummary)}
                >
                  <Typography variant="subtitle1" color="info.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {loadingTrendyolProducts ? '...' : trendyolProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                    {loadingTrendyolProducts && (
                      <CircularProgress size={14} sx={{ ml: 1 }} color="info" />
                    )}
                  </Typography>
                  <IconButton size="small" color="info">
                    {showTrendyolProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showTrendyolProductSummary}>
                  {trendyolProductSummary.length === 0 && loadingTrendyolProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                      <CircularProgress size={28} color="info" />
                    </Box>
                  ) : (
                    <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow sx={{ bgcolor: 'info.100' }}>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {trendyolProductSummary.map((p, idx) => (
                            <TableRow key={`${p.name}-${idx}`} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="medium">
                                  {p.name}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="info.dark">
                                  {p.quantity}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatCurrency(p.totalRevenue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">—</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                          {/* TOPLAM SATIRI */}
                          <TableRow sx={{ bgcolor: 'info.100' }}>
                            <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'info.dark' }}>
                              {t('endOfDayReport.productSummary.totalRow')}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>
                              {trendyolProductSummary.reduce((s, p) => s + p.quantity, 0)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>
                              {formatCurrency(trendyolProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', color: 'info.dark' }}>
                              —
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Collapse>
              </Paper>
            )}

            {/* ✅ Açık Masalar Bölümü (Sadece Restoran tab'ında göster) — TABLO FORMATI */}
            {activeTab === 2 && activeTables.length > 0 && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'warning.50', border: '1px solid', borderColor: 'warning.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => setShowActiveTables(!showActiveTables)}
                >
                  <Typography variant="subtitle1" color="warning.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TableRestaurantIcon fontSize="small" />
                    {t('endOfDayReport.activeTables.title')} ({t('endOfDayReport.activeTables.notIncludedInEndOfDay')}) - {activeTables.length} {t('endOfDayReport.activeTables.countSuffix')}
                  </Typography>
                  <IconButton size="small" color="warning">
                    {showActiveTables ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showActiveTables}>
                  <TableContainer component={Paper} variant="outlined" sx={{ mt: 1.5, bgcolor: 'white' }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow sx={{ bgcolor: 'warning.100' }}>
                          <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>#</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.table')}</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.screen')}</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.openedAt')}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.duration')}</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.waiter')}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.itemCount')}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.totalAmount')}</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'warning.dark' }}>{t('endOfDayReport.activeTables.columns.status')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {activeTables.map((table, idx) => {
                          const screen = screenOptions.find(s => s.id === table.RestaurantScreenId);
                          // ⚠️ OpenedAt UTC string; UI TR saatine cevirmek icin +3h ekliyoruz (eski mantik).
                          const openedAtTurkeyTime = new Date(table.OpenedAt).getTime() + (3 * 60 * 60 * 1000);
                          const duration = Math.round((Date.now() - openedAtTurkeyTime) / 60000);
                          const waiter = table.PavoPaymentCashierName || table.OpenedBy || '-';
                          const itemCount = table.ItemCount ?? table.Items?.length ?? 0;

                          return (
                            <TableRow key={table.Id} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>
                                <Typography variant="body2" fontWeight="bold" color="warning.dark">
                                  {table.TableName || `${t('endOfDayReport.activeTables.tablePrefix')} ${table.TableId}`}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" color="text.secondary">
                                  {screen?.name || t('endOfDayReport.activeTables.screenFallback')}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="caption" color="text.secondary">
                                  {formatDateTime(table.OpenedAt)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatDuration(duration)}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2">{waiter}</Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">{itemCount}</Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2" fontWeight="bold" color="primary.main">
                                  {formatCurrency(table.TotalAmount || 0)}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                  {table.PavoPaymentPending && (
                                    <Chip
                                      size="small"
                                      label={t('endOfDayReport.activeTables.status.pavoPending')}
                                      sx={{ bgcolor: 'secondary.main', color: 'white', fontWeight: 'bold', fontSize: '0.7rem' }}
                                    />
                                  )}
                                  {table.IsReceiptPrinted && (
                                    <Chip
                                      size="small"
                                      label={t('endOfDayReport.activeTables.status.receiptPrinted')}
                                      sx={{ bgcolor: 'info.main', color: 'white', fontWeight: 'bold', fontSize: '0.7rem' }}
                                    />
                                  )}
                                  {!table.PavoPaymentPending && !table.IsReceiptPrinted && (
                                    <Typography variant="caption" color="text.secondary">-</Typography>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              </Paper>
            )}

            {/* ✅ YENI: Urun Bazinda Satis Ozeti (Sadece Restoran tab'inda goster) */}
            {activeTab === 2 && restaurantProductSummary.length > 0 && (
              <Paper elevation={2} sx={{ mt: 2, p: 2, bgcolor: 'success.50', border: '1px solid', borderColor: 'success.main' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: 1.5,
                  }}
                  onClick={() => setShowProductSummary(!showProductSummary)}
                >
                  <Typography variant="subtitle1" color="success.dark" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Inventory2Icon fontSize="small" />
                    {t('endOfDayReport.productSummary.title')} — {restaurantProductSummary.length} {t('endOfDayReport.productSummary.productSuffix')}
                  </Typography>
                  <IconButton size="small" color="success">
                    {showProductSummary ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </Box>

                <Collapse in={showProductSummary}>
                  <TableContainer component={Paper} variant="outlined" sx={{ bgcolor: 'white' }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow sx={{ bgcolor: 'success.100' }}>
                          <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>#</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.productName')}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalQuantity')}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.totalRevenue')}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>{t('endOfDayReport.productSummary.columns.orderCount')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {restaurantProductSummary.map((p, idx) => (
                          <TableRow key={`${p.name}-${idx}`} hover>
                            <TableCell>{idx + 1}</TableCell>
                            <TableCell>
                              <Typography variant="body2" fontWeight="medium">
                                {p.name}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" fontWeight="bold" color="success.dark">
                                {p.quantity}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2">
                                {formatCurrency(p.totalRevenue)}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Typography variant="body2" color="text.secondary">
                                {p.orderCount}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ))}
                        {/* TOPLAM SATIRI */}
                        <TableRow sx={{ bgcolor: 'success.100' }}>
                          <TableCell colSpan={2} sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                            {t('endOfDayReport.productSummary.totalRow')}
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                            {restaurantProductSummary.reduce((s, p) => s + p.quantity, 0)}
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                            {formatCurrency(restaurantProductSummary.reduce((s, p) => s + p.totalRevenue, 0))}
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
                            —
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              </Paper>
            )}
          </>
        )}

        {/* ✅ YENİ: Gün Sonu Ön Onay Modalı (Tarih, Şube, Toplam bilgileri) */}
        <Dialog
          open={preConfirmDialogOpen}
          onClose={() => setPreConfirmDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            bgcolor: 'primary.main', 
            color: 'white',
            py: 2,
          }}>
            <AssessmentIcon />
            {t('endOfDayReport.modals.preConfirm.title')}
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            {/* Şube Bilgisi */}
            <Box sx={{ 
              p: 2, 
              mb: 2, 
              bgcolor: isAllBranches ? 'grey.100' : 'info.50', 
              borderRadius: 2,
              border: '1px solid',
              borderColor: isAllBranches ? 'grey.300' : 'info.main',
            }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                {t('endOfDayReport.modals.preConfirm.branch')}
              </Typography>
              <Typography variant="h6" fontWeight="bold" color={isAllBranches ? 'text.primary' : 'info.main'}>
                {isAllBranches ? t('endOfDayReport.modals.preConfirm.generalEndOfDay') : `📍 ${getSelectedBranchLabel()}`}
              </Typography>
            </Box>
            
            {/* Tarih Aralığı - ÇOK ÖNEMLİ */}
            <Box sx={{ 
              p: 2, 
              mb: 2, 
              bgcolor: 'warning.50', 
              borderRadius: 2,
              border: '2px solid',
              borderColor: 'warning.main',
            }}>
              <Typography variant="subtitle2" color="warning.dark" gutterBottom fontWeight="bold">
                {t('endOfDayReport.modals.preConfirm.dateRangeTitle')}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary">{t('endOfDayReport.filters.startDate')}</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.dark">
                    {startDate ? formatDateTime(startDate, false) : '-'}
                  </Typography>
                </Box>
                <Typography variant="h5" color="text.secondary">→</Typography>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary">{t('endOfDayReport.filters.endDate')}</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.dark">
                    {endDate ? formatDateTime(endDate, false) : '-'}
                  </Typography>
                </Box>
              </Box>
            </Box>
            
            {/* Genel Toplam */}
            <Box sx={{ 
              p: 2, 
              bgcolor: 'success.50', 
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'success.main',
            }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                {t('endOfDayReport.modals.preConfirm.grandTotal')}
              </Typography>
              <Typography variant="h4" fontWeight="bold" color="success.main">
                {formatCurrency(summary?.totalAmount || 0)}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  {t('endOfDayReport.modals.preConfirm.cash')}: {formatCurrency(summary?.cashAmount || 0)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  POS: {formatCurrency(summary?.posAmount || 0)}
                </Typography>
                {(summary?.openAccountAmount || 0) > 0 && (
                  <Typography variant="caption" color="warning.main">
                    {t('endOfDayReport.modals.preConfirm.openAccount')}: {formatCurrency(summary?.openAccountAmount || 0)}
                  </Typography>
                )}
                {(summary?.prepaidAmount || 0) > 0 && (
                  <Typography variant="caption" color="info.main">
                    {t('endOfDayReport.paymentTypes.prepaid')}: {formatCurrency(summary?.prepaidAmount || 0)} ({summary?.prepaidCount || 0} {t('endOfDayReport.modals.preConfirm.items')})
                  </Typography>
                )}
                {(summary?.cancelledAmount || 0) > 0 && (
                  <Typography variant="caption" color="error.main">
                    {t('endOfDayReport.modals.preConfirm.cancelled')}: {formatCurrency(summary?.cancelledAmount || 0)}
                  </Typography>
                )}
                {(summary?.posRefundAmount || 0) > 0 && (
                  <Typography variant="caption" color="error.main">
                    {t('endOfDayReport.modals.preConfirm.posRefund')}: -{formatCurrency(summary?.posRefundAmount || 0)} ({summary?.posRefundCount || 0} {t('endOfDayReport.modals.preConfirm.items')})
                  </Typography>
                )}
              </Box>
            </Box>
            
            {/* İşlem Sayıları */}
            <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
              <Chip 
                icon={<RestaurantIcon />} 
                label={`${t('endOfDayReport.tabs.restaurant')}: ${filteredRestaurantData.length}`} 
                size="small" 
                color="primary" 
                variant="outlined"
              />
              <Chip 
                icon={<PointOfSaleIcon />} 
                label={`${t('endOfDayReport.tabs.quickSale')}: ${filteredQuickSaleData.length}`} 
                size="small" 
                color="secondary" 
                variant="outlined"
              />
              {kioskData.length > 0 && (
                <Chip 
                  icon={<TabletAndroidIcon />} 
                  label={`${t('endOfDayReport.tabs.kiosk')}: ${kioskData.length}`} 
                  size="small" 
                  color="info" 
                  variant="outlined"
                />
              )}
              {qrMenuData.length > 0 && (
                <Chip 
                  icon={<QrCodeIcon />} 
                  label={`${t('endOfDayReport.tabs.qrMenu')}: ${qrMenuData.length}`} 
                  size="small" 
                  color="warning" 
                  variant="outlined"
                />
              )}
              {getirOrderData.length > 0 && (
                <Chip 
                  icon={<LocalShippingIcon />} 
                  label={`${t('endOfDayReport.tabs.getir')}: ${getirOrderData.length}`} 
                  size="small" 
                  color="secondary" 
                  variant="outlined"
                />
              )}
              {migrosOrderData.length > 0 && (
                <Chip 
                  icon={<LocalShippingIcon />} 
                  label={`${t('endOfDayReport.tabs.migros')}: ${migrosOrderData.length}`} 
                  size="small" 
                  color="warning" 
                  variant="outlined"
                />
              )}
              {ysOrderData.length > 0 && (
                <Chip 
                  icon={<LocalShippingIcon />} 
                  label={`${t('endOfDayReport.tabs.yemeksepeti')}: ${ysOrderData.length}`} 
                  size="small"
                  color="error" 
                  variant="outlined"
                />
              )}
              {trendyolOrderData.length > 0 && (
                <Chip 
                  icon={<LocalShippingIcon />} 
                  label={`${t('endOfDayReport.tabs.trendyol')}: ${trendyolOrderData.length}`} 
                  size="small" 
                  color="warning" 
                  variant="outlined"
                />
              )}
            </Box>
            
            {/* Açık Masa Uyarısı */}
            {activeTables.length > 0 && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                <Typography variant="body2">
                  {t('endOfDayReport.modals.openTables.alert', { count: activeTables.length })}
                </Typography>
              </Alert>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button 
              onClick={() => setPreConfirmDialogOpen(false)} 
              color="inherit"
            >
              {t('endOfDayReport.common.cancel')}
            </Button>
            <Button 
              onClick={handlePreConfirmContinue}
              variant="contained" 
              color="success"
              size="large"
              startIcon={endOfDayProcessing ? <CircularProgress size={20} color="inherit" /> : <AssessmentIcon />}
              disabled={endOfDayProcessing}
            >
              {endOfDayProcessing ? t('endOfDayReport.common.processing') : t('endOfDayReport.actions.endOfDay')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ✅ YENİ: Tarih Çakışması Modalı */}
        <Dialog
          open={dateConflictDialogOpen}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown
          onClose={(event, reason) => {
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              return;
            }
          }}
        >
          <DialogTitle sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            bgcolor: 'error.main', 
            color: 'white',
            py: 2,
          }}>
            <BlockIcon />
            {t('endOfDayReport.modals.dateConflict.title')}
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Alert severity="error" sx={{ mb: 2 }}>
              <Typography variant="body2">
                {t('endOfDayReport.modals.dateConflict.description', { count: conflictingReports.length })}
              </Typography>
            </Alert>
            
            <Typography variant="body2" color="text.secondary" paragraph>
              {t('endOfDayReport.modals.dateConflict.helpText')}
            </Typography>
            
            {/* Çakışan raporların listesi */}
            <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'grey.50', maxHeight: 200, overflow: 'auto' }}>
              <Typography variant="caption" color="text.secondary" gutterBottom sx={{ display: 'block', mb: 1 }}>
                {t('endOfDayReport.modals.dateConflict.conflictingReports')}
              </Typography>
              {conflictingReports.map((report) => (
                <Box 
                  key={report.id} 
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between',
                    p: 1,
                    mb: 0.5,
                    bgcolor: 'error.50',
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'error.200',
                  }}
                >
                  <Box>
                    <Typography variant="caption" fontWeight="bold" color="error.main">
                      {t('endOfDayReport.modals.dateConflict.reportLabel', { id: report.id })}
                    </Typography>
                    <Typography variant="caption" display="block" color="text.secondary">
                      {formatDateTime(report.startDate)} - {formatDateTime(report.endDate)}
                    </Typography>
                  </Box>
                  <Chip 
                    label={report.screenType === 'RESTAURANT' ? t('endOfDayReport.tabs.restaurant') : report.screenType}
                    size="small"
                    color="error"
                    variant="outlined"
                  />
                </Box>
              ))}
            </Paper>
            
            <Divider sx={{ my: 2 }} />
            
            <Typography variant="body2" fontWeight="bold">
              {t('endOfDayReport.modals.dateConflict.whatYouCanDo')}
            </Typography>
            <Typography variant="body2" color="text.secondary" component="ul" sx={{ mt: 1, pl: 2 }}>
              <li>{t('endOfDayReport.modals.dateConflict.tip1')}</li>
              <li>{t('endOfDayReport.modals.dateConflict.tip2')}</li>
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button 
              onClick={() => {
                setDateConflictDialogOpen(false);
                setConflictingReports([]);
              }} 
              variant="contained" 
              color="primary"
            >
              {t('endOfDayReport.modals.dateConflict.okChangeDate')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ✅ YENİ: Gün Sonu Onay Modalı */}
        <Dialog
          open={confirmDialogOpen}
          onClose={() => setConfirmDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'warning.main' }}>
            <WarningAmberIcon />
            {t('endOfDayReport.modals.openTables.title')}
          </DialogTitle>
          <DialogContent dividers>
            <Alert severity="warning" sx={{ mb: 2 }}>
              <Typography variant="body2">
                {t('endOfDayReport.modals.openTables.alert', { count: activeTables.length })}
              </Typography>
            </Alert>
            
            <Typography variant="body2" color="text.secondary" paragraph>
              {t('endOfDayReport.modals.openTables.description')}
            </Typography>
            
            {/* Açık masaların listesi */}
            <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'grey.50' }}>
              <Typography variant="caption" color="text.secondary" gutterBottom>
                {t('endOfDayReport.modals.openTables.listTitle')}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                {activeTables.slice(0, 10).map((table) => (
                  <Chip
                    key={table.Id}
                    label={`${table.TableName || `${t('endOfDayReport.modals.openTables.table')} ${table.TableId}`} - ${formatCurrency(table.TotalAmount || 0)}`}
                    size="small"
                    color="warning"
                    variant="outlined"
                  />
                ))}
                {activeTables.length > 10 && (
                  <Chip
                    label={t('endOfDayReport.modals.openTables.moreTables', { count: activeTables.length - 10 })}
                    size="small"
                    color="default"
                  />
                )}
              </Box>
            </Paper>
            
            <Typography variant="body2" sx={{ mt: 2 }}>
              {t('endOfDayReport.modals.openTables.confirmQuestion')}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmDialogOpen(false)} color="inherit">
              {t('endOfDayReport.common.cancel')}
            </Button>
            <Button 
              onClick={processEndOfDay} 
              variant="contained" 
              color="warning"
              startIcon={<AssessmentIcon />}
            >
              {t('endOfDayReport.modals.openTables.continueAndEndOfDay')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ✅ YENİ: Gün Sonu Başarı Modalı */}
        <Dialog
          open={successDialogOpen}
          maxWidth="xs"
          fullWidth
          disableEscapeKeyDown
          onClose={(event, reason) => {
            // Backdrop tıklamasını engelle, sadece Tamam butonu ile kapansın
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              return;
            }
          }}
        >
          <DialogTitle sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            bgcolor: 'success.main', 
            color: 'white',
            py: 2,
          }}>
            <AssessmentIcon />
            {t('endOfDayReport.modals.success.title')}
          </DialogTitle>
          <DialogContent sx={{ pt: 3, pb: 2, textAlign: 'center' }}>
            <Box sx={{ 
              width: 80, 
              height: 80, 
              borderRadius: '50%', 
              bgcolor: 'success.50', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              mx: 'auto',
              mb: 2,
            }}>
              <AssessmentIcon sx={{ fontSize: 40, color: 'success.main' }} />
            </Box>
            
            <Typography variant="h6" gutterBottom color="success.main" fontWeight="bold">
              {t('endOfDayReport.modals.success.saved')}
            </Typography>
            
            <Divider sx={{ my: 2 }} />
            
            <Box sx={{ textAlign: 'left', px: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2" color="text.secondary">{t('endOfDayReport.modals.success.reportNo')}</Typography>
                <Typography variant="body2" fontWeight="bold">#{successDialogData?.reportId}</Typography>
              </Box>
              
              {/* Şube Bilgisi */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2" color="text.secondary">{t('endOfDayReport.modals.success.branch')}</Typography>
                <Typography variant="body2" fontWeight="bold" color={successDialogData?.branchName ? 'info.main' : 'text.secondary'}>
                  {successDialogData?.branchName || t('endOfDayReport.modals.success.generalEndOfDayAllBranches')}
                </Typography>
              </Box>
              
              {/* Tarih Aralığı */}
              <Box sx={{ 
                mt: 2, 
                p: 1.5, 
                bgcolor: 'grey.100', 
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.300',
              }}>
                <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                  {t('endOfDayReport.modals.success.recordedDateRange')}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                  <Typography variant="body2" fontWeight="medium">
                    {successDialogData?.startDate ? formatDateTime(successDialogData.startDate, false) : '-'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">→</Typography>
                  <Typography variant="body2" fontWeight="medium">
                    {successDialogData?.endDate ? formatDateTime(successDialogData.endDate, false) : '-'}
                  </Typography>
                </Box>
              </Box>
              
              {/* Toplam Tutar */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Typography variant="body2" color="text.secondary">{t('endOfDayReport.modals.success.totalAmount')}</Typography>
                <Typography variant="body1" fontWeight="bold" color="success.main">
                  {formatCurrency(successDialogData?.balance || 0)}
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
            <Button 
              onClick={() => {
                setSuccessDialogOpen(false);
                setSuccessDialogData(null);
              }} 
              variant="contained" 
              color="success"
              size="large"
              sx={{ minWidth: 120 }}
            >
              {t('endOfDayReport.modals.success.ok')}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ✅ YENİ: Satış Detay Modalı (Ayrı Component) - Restoran ve Hızlı Satış için */}
        <SaleDetailModal
          open={detailModalOpen}
          onClose={() => {
            setDetailModalOpen(false);
            setSelectedSaleDetail(null);
            setSelectedQuickSaleDetail(null);
          }}
          saleDetail={selectedSaleDetail}
          companyId={companyId}
          quickSaleDetail={selectedQuickSaleDetail}
        />

        {/* Yemek platformu detay modalları (PackageOrderScreen'deki ile aynı componentler) */}
        <GetirOrderDetailModal
          open={getirDetailModalOpen}
          onClose={() => {
            setGetirDetailModalOpen(false);
            setSelectedGetirOrderId(null);
          }}
          orderId={selectedGetirOrderId}
          companyId={companyId}
        />
        <MigrosOrderDetailModal
          open={migrosDetailModalOpen}
          onClose={() => {
            setMigrosDetailModalOpen(false);
            setSelectedMigrosOrderId(null);
          }}
          orderId={selectedMigrosOrderId}
          companyId={companyId ?? ''}
        />
        <YemeksepetiOrderDetailModal
          open={ysDetailModalOpen}
          onClose={() => {
            setYsDetailModalOpen(false);
            setSelectedYsOrderId(null);
          }}
          orderId={selectedYsOrderId}
          companyId={companyId ?? ''}
        />
        <TrendyolOrderDetailModal
          open={trendyolDetailModalOpen}
          onClose={() => {
            setTrendyolDetailModalOpen(false);
            setSelectedTrendyolOrder(null);
          }}
          order={selectedTrendyolOrder}
        />
        {/* Paket (telefon) sipariş detay modali — operasyonel handler'lar
            geçilmediği için modal salt okuma modunda davranır: Yazdır/İptal/
            Sepeti Düzenle butonları görünmez, yalnızca sipariş özeti,
            kalemleri, müşteri/teslimat bilgisi ve durum chip'leri gösterilir. */}
        <OrderDetailModal
          open={packageDetailModalOpen}
          onClose={() => {
            setPackageDetailModalOpen(false);
            setSelectedPackageOrderId(null);
          }}
          orderId={selectedPackageOrderId}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default EndOfDayReport;
